// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.business-dashboard {
  --dash-bg: var(--bg-primary, #f4f7f7);
  --dash-surface: var(--surface-primary, #fff);
  --dash-surface-2: var(--surface-secondary, #f4f7f7);
  --dash-surface-3: var(--surface-tertiary, #e8edec);
  --dash-border: var(--border-subtle, #dce3e2);
  --dash-border-strong: var(--border-default, #cdd6d4);
  --dash-text: var(--text-primary, #142624);
  --dash-muted: var(--text-secondary, #506360);
  --dash-brand: var(--interactive-default, #0f766e);
  --dash-brand-soft: var(--interactive-soft, #f0f8f7);
  --dash-danger: var(--money-overdue, #c23a2b);
  --dash-danger-soft: var(--money-overdue-soft, #fef2f1);
  --interactive-selected: #dcefec;
  --interactive-pressed: #0a4a46;
  --text-link: #0f766e;
  --chart-grid: #dce3e2;
  --chart-primary: #0f766e;
  --chart-secondary: #aebab8;
  --chart-danger: #e04434;
  --warning-default: #b7701a;
  min-height: 100vh;
  color: var(--dash-text);
  background: var(--dash-bg);
  font-family: var(--font-family-primary, "Lexend", sans-serif);
  font-size: 13px;
  line-height: 1.4;
}

.business-dashboard.dark,
.business-dashboard[data-theme="dark"] {
  --dash-bg: var(--bg-primary);
  --dash-surface: var(--surface-primary);
  --dash-surface-2: var(--surface-secondary);
  --dash-surface-3: var(--surface-tertiary);
  --dash-border: var(--border-subtle);
  --dash-border-strong: var(--border-default);
  --dash-text: var(--text-primary);
  --dash-muted: var(--text-secondary);
  --dash-brand: var(--interactive-default);
  --dash-brand-soft: var(--interactive-soft);
  --dash-danger: var(--danger-default);
  --dash-danger-soft: var(--danger-soft);
  --interactive-pressed: var(--interactive-hover);
}

.business-dashboard *,
.business-dashboard *::before,
.business-dashboard *::after {
  box-sizing: border-box;
}
.business-dashboard button,
.business-dashboard input {
  color: inherit;
  font: inherit;
}
.business-dashboard button {
  cursor: pointer;
}
.business-dashboard a {
  color: inherit;
  text-decoration: none;
}

.dashboard-nav {
  --dash-surface: #fff;
  --dash-surface-2: #f4f7f7;
  --dash-surface-3: #e8edec;
  --dash-border: #dce3e2;
  --dash-border-strong: #cdd6d4;
  --dash-text: #142624;
  --dash-muted: #506360;
  --dash-lock: #6b7b78;
  --dash-brand: #0f766e;
  --dash-brand-soft: #f0f8f7;
  --dash-danger: #c23a2b;
  --text-link: #0f766e;
  position: fixed;
  inset: 0 auto 0 0;
  z-index: 9999;
  width: 256px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-right: 1px solid var(--dash-border);
  background: var(--dash-surface);
  font-family: var(--font-family-primary, "Lexend", sans-serif) !important;
  font-size: 13px !important;
  line-height: normal !important;
  box-sizing: border-box !important;
  color: var(--dash-text);
}
.dashboard-nav *,
.dashboard-nav *::before,
.dashboard-nav *::after {
  box-sizing: border-box;
}
.dashboard-nav button {
  font-family: var(--font-family-primary, "Lexend", sans-serif);
  color: inherit;
  font-size: inherit;
  cursor: pointer;
  border: 0;
  background: transparent;
  padding: 0;
}
.dashboard-nav a {
  font-family: var(--font-family-primary, "Lexend", sans-serif);
  color: inherit;
  text-decoration: none;
}
.dashboard-nav.dark {
  --dash-surface: var(--surface-primary);
  --dash-surface-2: var(--surface-secondary);
  --dash-surface-3: var(--surface-tertiary);
  --dash-border: var(--border-subtle);
  --dash-border-strong: var(--border-default);
  --dash-text: var(--text-primary);
  --dash-muted: var(--text-secondary);
  --dash-lock: var(--text-tertiary);
  --dash-brand: var(--interactive-default);
  --dash-brand-soft: var(--interactive-soft);
  --dash-danger: var(--danger-default);
}
.dashboard-nav-brand {
  height: 64px;
  min-height: 64px;
  max-height: 64px;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  flex-shrink: 0;
  border-bottom: 1px solid var(--dash-border);
}
.dashboard-nav-close-btn,
.dashboard-nav-brand > button {
  display: grid !important;
  place-items: center !important;
  margin-left: auto !important;
  width: 40px !important;
  height: 40px !important;
  min-width: 40px !important;
  min-height: 40px !important;
  padding: 0 !important;
  border: 1px solid var(--dash-border) !important;
  border-radius: 10px !important;
  background: var(--dash-surface-2) !important;
  color: var(--dash-muted) !important;
  cursor: pointer !important;
  flex-shrink: 0 !important;
  transition: background-color 0.15s ease, border-color 0.15s ease,
    color 0.15s ease !important;
}
.dashboard-nav-close-btn:hover,
.dashboard-nav-brand > button:hover {
  background: var(--dash-surface-3) !important;
  border-color: var(--dash-border-strong) !important;
  color: var(--dash-text) !important;
}
.dashboard-nav.dark .dashboard-nav-close-btn,
.dashboard-nav.dark .dashboard-nav-brand > button {
  background: var(--surface-secondary, #1b2726) !important;
  border-color: var(--border-subtle, #223230) !important;
  color: var(--text-secondary, #879b97) !important;
}
.dashboard-nav.dark .dashboard-nav-close-btn:hover,
.dashboard-nav.dark .dashboard-nav-brand > button:hover {
  background: var(--surface-tertiary, #243533) !important;
  border-color: var(--border-default, #324644) !important;
  color: var(--text-primary, #f2f3f5) !important;
}
.dashboard-nav-close-btn svg,
.dashboard-nav-brand > button svg {
  width: 18px !important;
  height: 18px !important;
  color: inherit !important;
  stroke: currentColor !important;
  stroke-width: 1.67 !important;
  display: block !important;
}
.dashboard-brand {
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
  height: 32px;
  flex-shrink: 0;
}
.dashboard-brand > span {
  width: 32px;
  height: 32px;
  min-width: 32px;
  max-width: 32px;
  flex: 0 0 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  color: #fff !important;
  background: var(--dash-brand) !important;
  font-family: var(--font-family-primary, "Lexend", sans-serif) !important;
  font-size: 11px !important;
  font-weight: 500 !important;
  letter-spacing: 0.11px !important;
  line-height: 14.3px !important;
  text-transform: lowercase;
}
.business-dashboard.dark .dashboard-brand > span,
.dashboard-nav.dark .dashboard-brand > span {
  color: #fff !important;
  background: var(--dash-brand) !important;
}
.dashboard-brand strong {
  font-family: var(--font-family-primary, "Lexend", sans-serif) !important;
  font-size: 13px !important;
  font-weight: 500 !important;
  line-height: 16.9px !important;
  color: var(--dash-text) !important;
  letter-spacing: 0.065px !important;
  white-space: nowrap;
}
.dashboard-org-wrap {
  width: 100%;
  height: 100px;
  min-height: 100px;
  max-height: 100px;
  padding: 12px;
  box-sizing: border-box;
  flex-shrink: 0;
  position: relative;
}
.dashboard-org {
  width: 100%;
  height: 76px;
  min-height: 76px;
  padding: 12px !important;
  display: flex !important;
  align-items: center !important;
  gap: 8px !important;
  text-align: left;
  border: 1px solid var(--border-subtle, #dce3e2) !important;
  border-radius: 10px !important;
  background: var(--surface-secondary, #f4f7f7) !important;
  box-sizing: border-box;
  font-family: var(--font-family-primary, "Lexend", sans-serif) !important;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;
}
.dashboard-org:hover,
.dashboard-org.is-open {
  border-color: var(--interactive-default, #0f766e) !important;
}
.dashboard-org.is-switching {
  cursor: wait !important;
}
.dashboard-org > .dashboard-org-switching {
  width: 100%;
  display: flex !important;
  flex-direction: row !important;
  align-items: center !important;
  gap: 8px !important;
}
.dashboard-org > .dashboard-org-switching > .app-skeleton {
  flex: 0 0 32px;
}
.dashboard-org > .dashboard-org-switching > div {
  display: flex !important;
  flex: 1 1 auto !important;
  flex-direction: column !important;
  gap: 5px !important;
}
.dashboard-organisation-switch-overlay {
  position: fixed;
  inset: 0;
  z-index: 10000;
  display: grid;
  grid-template-columns: 252px minmax(0, 1fr);
  overflow: hidden;
  background: var(--surface-primary, #ffffff);
  cursor: wait;
}
.dashboard-organisation-switch-overlay > aside {
  padding: 16px 12px;
  border-right: 1px solid var(--border-subtle, #dce3e2);
  background: var(--surface-primary, #ffffff);
}
.dashboard-switch-brand-skeleton,
.dashboard-switch-org-skeleton,
.dashboard-switch-nav-skeleton > div,
.dashboard-organisation-switch-overlay > section > header,
.dashboard-organisation-switch-overlay > section > header > div {
  display: flex;
  align-items: center;
}
.dashboard-switch-brand-skeleton {
  height: 32px;
  gap: 9px;
  margin-bottom: 28px;
}
.dashboard-switch-org-skeleton {
  min-height: 76px;
  padding: 12px;
  gap: 8px;
  border: 1px solid var(--border-subtle, #dce3e2);
  border-radius: 10px;
  background: var(--surface-secondary, #f4f7f7);
}
.dashboard-switch-org-skeleton > div {
  display: flex;
  flex: 1 1;
  flex-direction: column;
  gap: 6px;
}
.dashboard-switch-nav-skeleton {
  display: flex;
  flex-direction: column;
  gap: 22px;
  padding: 30px 10px;
}
.dashboard-switch-nav-skeleton > div {
  gap: 12px;
}
.dashboard-organisation-switch-overlay > section {
  min-width: 0;
  background: var(--surface-secondary, #f7f9f9);
}
.dashboard-organisation-switch-overlay > section > header {
  height: 64px;
  padding: 0 24px;
  justify-content: space-between;
  border-bottom: 1px solid var(--border-subtle, #dce3e2);
  background: var(--surface-primary, #ffffff);
}
.dashboard-organisation-switch-overlay > section > header > div {
  gap: 16px;
}
.dashboard-organisation-switch-overlay main {
  padding: 32px;
}
.dashboard-switch-heading-skeleton,
.dashboard-switch-card-grid > div,
.dashboard-switch-content-skeleton {
  display: flex;
  flex-direction: column;
}
.dashboard-switch-heading-skeleton {
  gap: 12px;
  margin-bottom: 28px;
}
.dashboard-switch-card-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
}
.dashboard-switch-card-grid > div {
  min-height: 126px;
  padding: 20px;
  justify-content: space-between;
  border: 1px solid var(--border-subtle, #dce3e2);
  border-radius: 12px;
  background: var(--surface-primary, #ffffff);
}
.dashboard-switch-content-skeleton {
  margin-top: 24px;
  padding: 24px;
  gap: 14px;
  border: 1px solid var(--border-subtle, #dce3e2);
  border-radius: 12px;
  background: var(--surface-primary, #ffffff);
}
@media (max-width: 767px) {
  .dashboard-organisation-switch-overlay {
    grid-template-columns: 1fr;
  }
  .dashboard-organisation-switch-overlay > aside {
    display: none;
  }
  .dashboard-organisation-switch-overlay > section > header {
    height: 56px;
    padding: 0 16px;
  }
  .dashboard-organisation-switch-overlay > section > header > .app-skeleton {
    width: 58% !important;
  }
  .dashboard-organisation-switch-overlay main {
    padding: 20px 16px;
  }
  .dashboard-switch-card-grid {
    grid-template-columns: 1fr;
  }
}
.org-switch-icon {
  color: var(--interactive-default, #0f766e) !important;
  width: 16px !important;
  height: 16px !important;
  stroke-width: 2 !important;
  flex-shrink: 0 !important;
  margin-left: auto !important;
}
.dashboard-org > span {
  position: relative !important;
  width: 32px !important;
  height: 32px !important;
  min-width: 32px !important;
  max-width: 32px !important;
  flex: 0 0 32px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  border: 1.5px solid var(--border-subtle, #dce3e2) !important;
  border-radius: 16px !important;
  color: var(--interactive-default, #0f766e) !important;
  background: var(--interactive-soft, #f0f8f7) !important;
  font-family: var(--font-family-primary, "Lexend", sans-serif) !important;
  font-size: 12px !important;
  font-weight: 500 !important;
  line-height: normal !important;
  letter-spacing: 0 !important;
  text-align: center !important;
  overflow: hidden !important;
}
.dashboard-org > span > img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  background: var(--surface-primary, #ffffff);
}
.dashboard-mobile-org {
  display: flex !important;
  align-items: center !important;
  gap: 8px !important;
  padding: 10px 12px !important;
  min-height: 66px !important;
  border: 1px solid var(--border-subtle, #dce3e2) !important;
  border-radius: 10px !important;
  background: var(--surface-secondary, #f4f7f7) !important;
  cursor: pointer !important;
  text-align: left !important;
  box-sizing: border-box !important;
}
.dashboard-mobile-org > span {
  position: relative !important;
  width: 32px !important;
  height: 32px !important;
  min-width: 32px !important;
  max-width: 32px !important;
  flex: 0 0 32px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  border: 1.5px solid var(--border-subtle, #dce3e2) !important;
  border-radius: 16px !important;
  color: var(--interactive-default, #0f766e) !important;
  background: var(--interactive-soft, #f0f8f7) !important;
  font-family: var(--font-family-primary, "Lexend", sans-serif) !important;
  font-size: 12px !important;
  font-weight: 500 !important;
  line-height: normal !important;
  overflow: hidden !important;
}
.dashboard-org div {
  min-width: 0 !important;
  flex: 1 1 !important;
  display: flex !important;
  flex-direction: column !important;
  justify-content: center !important;
  gap: 2px !important;
  overflow: hidden !important;
}
.dashboard-mobile-org div {
  min-width: 0 !important;
  flex: 1 1 !important;
  display: flex !important;
  flex-direction: column !important;
  justify-content: center !important;
  gap: 2px !important;
  overflow: hidden !important;
}
.dashboard-org strong {
  overflow: hidden !important;
  font-family: var(--font-family-primary, "Lexend", sans-serif) !important;
  font-size: 13px !important;
  font-weight: 500 !important;
  line-height: 16.9px !important;
  letter-spacing: 0.065px !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  color: var(--text-primary, #142624) !important;
  display: block !important;
}
.dashboard-mobile-org strong {
  overflow: hidden !important;
  font-family: var(--font-family-primary, "Lexend", sans-serif) !important;
  font-size: 13px !important;
  font-weight: 500 !important;
  line-height: 16.9px !important;
  letter-spacing: 0.065px !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  color: var(--text-primary, #142624) !important;
  display: block !important;
}
.dashboard-org small {
  font-family: var(--font-family-primary, "Lexend", sans-serif) !important;
  font-size: 11px !important;
  font-weight: 400 !important;
  line-height: 15.4px !important;
  letter-spacing: 0.11px !important;
  color: var(--text-secondary, #506360) !important;
  white-space: nowrap !important;
  display: block !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}
.dashboard-mobile-org small {
  font-family: var(--font-family-primary, "Lexend", sans-serif) !important;
  font-size: 11px !important;
  font-weight: 400 !important;
  line-height: 15.4px !important;
  letter-spacing: 0.11px !important;
  color: var(--text-secondary, #506360) !important;
  white-space: nowrap !important;
  display: block !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}
.dashboard-org-user {
  color: var(--text-tertiary, #667976) !important;
  font-size: 10px !important;
  line-height: 14px !important;
}
.dashboard-org .org-switch-icon,
.dashboard-mobile-org .org-switch-icon {
  stroke-width: 2 !important;
  color: var(--interactive-default, #0f766e) !important;
}

/* Dark mode overrides for Organisation Selector (Figma Node 1119:53210) */
.business-dashboard.dark .dashboard-org,
[data-theme="dark"] .dashboard-org,
.dark .dashboard-org,
.business-dashboard.dark .dashboard-mobile-org,
[data-theme="dark"] .dashboard-mobile-org,
.dark .dashboard-mobile-org {
  background: var(--surface-secondary, #22252a) !important;
  border-color: var(--border-subtle, #2c3036) !important;
}
.business-dashboard.dark .dashboard-org:hover,
.business-dashboard.dark .dashboard-org.is-open,
[data-theme="dark"] .dashboard-org:hover,
[data-theme="dark"] .dashboard-org.is-open,
.dark .dashboard-org:hover,
.dark .dashboard-org.is-open {
  border-color: var(--interactive-default, #43a79c) !important;
}
.business-dashboard.dark .dashboard-org > span,
[data-theme="dark"] .dashboard-org > span,
.dark .dashboard-org > span,
.business-dashboard.dark .dashboard-mobile-org > span,
[data-theme="dark"] .dashboard-mobile-org > span,
.dark .dashboard-mobile-org > span {
  background: rgba(67, 167, 156, 0.15) !important;
  border-color: var(--border-subtle, #2c3036) !important;
  color: var(--interactive-default, #43a79c) !important;
}
.business-dashboard.dark .dashboard-org strong,
[data-theme="dark"] .dashboard-org strong,
.dark .dashboard-org strong,
.business-dashboard.dark .dashboard-mobile-org strong,
[data-theme="dark"] .dashboard-mobile-org strong,
.dark .dashboard-mobile-org strong {
  color: var(--text-primary, #f2f3f5) !important;
}
.business-dashboard.dark .dashboard-org small,
[data-theme="dark"] .dashboard-org small,
.dark .dashboard-org small,
.business-dashboard.dark .dashboard-mobile-org small,
[data-theme="dark"] .dashboard-mobile-org small,
.dark .dashboard-mobile-org small {
  color: var(--text-secondary, #b3b8c2) !important;
}
.business-dashboard.dark .dashboard-org .org-switch-icon,
[data-theme="dark"] .dashboard-org .org-switch-icon,
.dark .dashboard-org .org-switch-icon,
.business-dashboard.dark .dashboard-mobile-org .org-switch-icon,
[data-theme="dark"] .dashboard-mobile-org .org-switch-icon,
.dark .dashboard-mobile-org .org-switch-icon {
  color: var(--interactive-default, #43a79c) !important;
}

.dashboard-org-menu {
  position: fixed;
  z-index: 1200;
  top: 76px;
  left: 264px;
  width: 360px;
  padding: 6px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  border: 1px solid var(--dash-border-strong);
  border-radius: 14px;
  background: var(--dash-surface);
  box-shadow: 0 6px 16px -4px rgba(14, 26, 32, 0.1),
    0 1px 2px rgba(14, 26, 32, 0.04);
}

.dashboard-org-menu :is(button, a) {
  width: 100%;
  height: 44px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  border: 0;
  border-radius: 4px;
  background: transparent;
  color: var(--dash-text);
  font-family: var(--font-family-primary, "Lexend", sans-serif);
  font-size: 13px;
  font-weight: 400;
  line-height: 20.2px;
  text-align: left;
  text-decoration: none;
}

.dashboard-org-menu :is(button, a):hover,
.dashboard-org-menu :is(button, a).active {
  color: var(--dash-brand);
  background: var(--dash-brand-soft);
}

.dashboard-org-menu :is(button, a) > svg {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

.dashboard-org-menu :is(button, a) > span {
  flex: 1 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.dashboard-org-menu button:disabled {
  cursor: default;
  opacity: 1;
}

.dashboard-org-menu .dashboard-org-menu-check {
  margin-left: auto;
}
.dashboard-mobile-org small {
  color: var(--dash-muted);
}
.dashboard-nav-links {
  flex: 1 1;
  min-height: 0;
  padding: 16px 12px;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: var(--dash-muted) transparent;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.dashboard-nav-links::-webkit-scrollbar {
  width: 6px;
}
.dashboard-nav-links::-webkit-scrollbar-thumb {
  background: var(--dash-muted);
  border-radius: var(--radius-sm, 4px);
}
.dashboard-nav-group {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.dashboard-nav-links > a,
.dashboard-nav-group a,
.dashboard-nav-group .dashboard-locked-link {
  width: 100%;
  height: 40px;
  padding: 9px 12px;
  display: flex;
  align-items: center;
  gap: 10px;
  border: 0;
  border-radius: 10px;
  color: var(--dash-text);
  background: transparent;
  appearance: none;
  font-family: inherit;
  font-size: 13px;
  font-weight: 400;
  line-height: 20.2px;
  letter-spacing: 0;
  text-align: left;
  text-decoration: none;
  box-sizing: border-box;
  transition: background-color 0.15s ease, color 0.15s ease;
}
.dashboard-nav-links > a:hover:not(.active),
.dashboard-nav-group a:hover:not(.active),
.dashboard-nav-group .dashboard-locked-link:hover {
  background: var(--dash-surface-2);
}
.dashboard-nav-links a svg,
.dashboard-locked-link svg {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  color: var(--dash-muted);
}
.dashboard-nav-links a.active {
  color: var(--dash-brand) !important;
  background: var(--dash-brand-soft) !important;
  font-weight: 500;
}
.dashboard-nav-links a.active svg {
  color: var(--dash-brand) !important;
}
.dashboard-nav-links > a > .dashboard-nav-label,
.dashboard-nav-group a > .dashboard-nav-label,
.dashboard-nav-group .dashboard-locked-link > .dashboard-nav-label,
.dashboard-nav-links > a > span:not(.dashboard-nav-badge),
.dashboard-nav-group a > span:not(.dashboard-nav-badge),
.dashboard-nav-group .dashboard-locked-link > span:not(.dashboard-nav-badge) {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.dashboard-nav-group p {
  margin: 0;
  padding: 20px 12px 4px;
  color: var(--dash-muted);
  font-size: 13px;
  font-weight: 500;
  line-height: 16.9px;
  letter-spacing: 0.065px;
  text-transform: uppercase;
}
.dashboard-nav-badge,
.dashboard-nav-group a em,
.dashboard-locked-link em {
  flex: 0 0 auto !important;
  flex-shrink: 0 !important;
  flex-grow: 0 !important;
  width: auto !important;
  min-width: 18px !important;
  height: 18px !important;
  margin-left: auto !important;
  padding: 1px 6px !important;
  color: #ffffff !important;
  background: var(--red-600, #c23a2b) !important;
  border-radius: 10px !important;
  font-family: var(--font-family-primary, "Lexend", sans-serif) !important;
  font-size: 11px !important;
  font-weight: 600 !important;
  font-style: normal !important;
  line-height: normal !important;
  text-align: center !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  box-sizing: border-box !important;
  white-space: nowrap !important;
}
.dashboard-nav-group a small,
.dashboard-locked-link small {
  margin-left: auto;
  color: var(--dash-muted);
}
.dashboard-locked-link .dashboard-lock-icon {
  width: 14px;
  height: 14px;
  margin-left: auto;
  color: var(--dash-lock, #6b7b78);
  flex-shrink: 0;
}
.dashboard-plan {
  margin: 12px 12px 16px;
  padding: 12px 12px 10px;
  border-radius: 10px;
  background: var(--dash-surface-2);
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex-shrink: 0;
}
.dashboard-plan-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 13px;
  font-weight: 500;
  line-height: 16.9px;
  letter-spacing: 0.065px;
}
.dashboard-plan-header strong {
  font-weight: 500;
  color: var(--dash-text);
  text-transform: uppercase;
}
.dashboard-plan-header a {
  color: var(--dash-brand);
  font-weight: 500;
  text-decoration: none;
}
.dashboard-plan-header a:hover {
  text-decoration: underline;
}
.dashboard-plan-usage {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 13px;
  font-weight: 400;
  line-height: 20.2px;
  letter-spacing: 0;
}
.dashboard-plan-usage span {
  color: var(--dash-muted);
}
.dashboard-plan-usage b {
  font-weight: 400;
  color: var(--dash-text);
}
.dashboard-plan-progress {
  width: 100%;
  height: 4px;
  border-radius: 2px;
  background: var(--dash-border);
  overflow: hidden;
}
.dashboard-plan-progress span {
  display: block;
  height: 100%;
  border-radius: 2px;
  background: var(--dash-brand);
  transition: width 0.3s ease;
}
.dashboard-plan
  div:not(.dashboard-plan-header):not(.dashboard-plan-usage):not(.dashboard-plan-progress),
.dashboard-plan p {
  display: flex;
  justify-content: space-between;
  font-size: 13px;
}
.dashboard-plan div a:not(.dashboard-plan-header a) {
  color: var(--dash-brand);
  font-weight: 500;
}
.dashboard-plan p {
  margin: 8px 0;
}
.dashboard-plan i {
  height: 4px;
  display: block;
  overflow: hidden;
  border-radius: 2px;
  background: var(--dash-border);
}
.dashboard-plan i span {
  height: 100%;
  display: block;
  border-radius: 2px;
  background: var(--dash-brand);
}

.dashboard-main {
  min-height: 100vh;
  margin-left: 256px;
}

@media (min-width: 1025px) {
  .global-dashboard-layout {
    margin-left: 256px;
    width: auto;
  }
}
@media (max-width: 1024px) {
  .global-dashboard-layout {
    margin-left: 0 !important;
    width: 100% !important;
  }
}
.dashboard-topbar {
  position: sticky;
  top: 0;
  z-index: 100;
  height: 64px;
  padding: 0 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid var(--dash-border);
  background: var(--dash-surface);
}
.dashboard-search {
  width: 320px;
  max-width: 320px;
  height: 40px;
  padding: 0 12px;
  display: flex;
  align-items: center;
  gap: 8px;
  border: 1px solid var(--dash-border);
  border-radius: 10px;
  background: var(--dash-surface-2);
}
.dashboard-search svg {
  width: 16px;
  height: 16px;
  color: var(--text-tertiary, #6b7b78);
  flex-shrink: 0;
}
.dashboard-search input {
  width: 100%;
  border: 0;
  outline: 0;
  background: transparent;
  font-family: var(--font-family-primary, "Lexend", sans-serif);
  font-size: 14px;
  color: var(--dash-text);
}
.dashboard-top-actions {
  display: flex;
  align-items: center;
  gap: 16px;
}
.dashboard-top-actions > span,
.dashboard-top-actions .dashboard-topbar-credits {
  height: 32px;
  padding: 0 12px 0 10px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 1px solid var(--dash-border-strong, #cdd6d4);
  border-radius: 999px;
  font-family: var(--font-family-primary, "Lexend", sans-serif);
  font-size: 13px;
  font-weight: 500;
  color: var(--dash-text);
  cursor: pointer;
  background: transparent;
  box-sizing: border-box;
}
.dashboard-top-actions
  > button:not(.dashboard-profile-control):not(.dashboard-topbar-credits) {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 18px;
  background: transparent;
  color: var(--dash-text);
  cursor: pointer;
}
.dashboard-top-actions
  > button:not(.dashboard-profile-control):not(.dashboard-topbar-credits):hover {
  background: var(--dash-surface-2);
}
.dashboard-top-actions
  > button:not(.dashboard-profile-control):not(.dashboard-topbar-credits)
  svg {
  width: 20px;
  height: 20px;
}
.dashboard-topbar-credits svg {
  width: 16px;
  height: 16px;
}
.dashboard-profile-control {
  padding: 4px;
  display: flex;
  align-items: center;
  gap: 4px;
  border: 0;
  border-radius: 10px;
  background: transparent;
}
.dashboard-profile-control > svg {
  transition: transform 160ms ease;
}
.dashboard-profile-control.is-open > svg {
  transform: rotate(180deg);
}
.dashboard-avatar {
  position: relative;
  width: 32px;
  height: 32px;
  padding: 0;
  display: grid;
  place-items: center;
  border: 1.5px solid var(--dash-border);
  border-radius: 50%;
  color: #fff;
  background: var(--dash-brand);
  font-size: 10px;
  font-weight: 500;
  line-height: 1;
  text-align: center;
}
.dashboard-avatar i {
  position: absolute;
  right: -1px;
  bottom: -1px;
  width: 9px;
  height: 9px;
  border: 2px solid var(--dash-surface);
  border-radius: 50%;
  background: #26a269;
}
.dashboard-avatar > img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
  border-radius: inherit;
}
.dashboard-mobile-controls {
  display: none;
}
.dashboard-profile-menu {
  position: absolute;
  z-index: 60;
  top: 56px;
  right: 12px;
  width: 240px;
  padding: 4px;
  display: grid;
  gap: 4px;
  border: 1px solid var(--dash-border);
  border-radius: 10px;
  background: var(--dash-surface);
  box-shadow: 0 8px 30px rgba(14, 26, 32, 0.16);
}
.dashboard-profile-menu > button {
  height: 36px;
  padding: 0 12px;
  display: flex;
  align-items: center;
  gap: 8px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  text-align: left;
  font-size: 14px;
}
.dashboard-profile-menu > button:hover {
  background: var(--dash-surface-2);
}
.dashboard-profile-help {
  display: none !important;
}
.dashboard-profile-menu > small {
  padding: 4px 12px 10px;
  color: var(--dash-muted);
  overflow: hidden;
  text-overflow: ellipsis;
}
.dashboard-credits {
  padding: 16px;
  display: none;
  grid-template-columns: 20px 1fr;
  align-items: center;
  gap: 8px;
  border-radius: 10px;
  background: var(--dash-surface-2);
}
.dashboard-credits strong {
  grid-column: 1 / -1;
  font-family: var(--font-family-mono, monospace);
  font-size: 20px;
}
.dashboard-appearance {
  padding: 8px 12px;
  color: var(--dash-muted);
}
.dashboard-appearance > div {
  width: 168px;
  height: 36px;
  margin-top: 8px;
  padding: 3px;
  display: flex;
  border: 0;
  border-radius: 10px;
  background: transparent;
}
.dashboard-appearance button {
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  border: 0;
  border-radius: 6px;
  background: transparent;
}
.dashboard-appearance button.active {
  color: var(--dash-brand);
  background: var(--dash-surface);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}
.dashboard-appearance button:focus-visible {
  outline: 2px solid var(--focus-ring);
  outline-offset: 3px;
}
.dashboard-profile-close {
  display: none !important;
}

.dashboard-content {
  width: 100%;
  max-width: none;
  margin: 0;
  padding: 32px;
  display: grid;
  gap: 24px;
}
.dashboard-heading {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 16px;
}
.dashboard-heading h1 {
  margin: 0;
  font-size: 32px;
  font-weight: 600;
  line-height: 40px;
  letter-spacing: -0.48px;
}
.dashboard-heading p,
.dashboard-period-info span {
  margin: 0;
  color: var(--dash-muted);
}
.dashboard-heading > div:first-child > p {
  margin-top: 4px;
  font-size: 13px;
  font-weight: 400;
  line-height: 20.2px;
  letter-spacing: 0;
}
.dashboard-create {
  display: flex;
  gap: 12px;
}
.dashboard-create button {
  font: inherit;
  cursor: pointer;
}
.dashboard-create :is(a, button) {
  height: 40px;
  padding: 0 12px;
  display: flex;
  align-items: center;
  gap: 6px;
  border: 1px solid var(--dash-border-strong);
  border-radius: 10px;
  background: var(--dash-surface);
  font-family: var(--font-family-primary, "Lexend", sans-serif);
  font-size: 13px;
  font-weight: 500;
  line-height: 16.9px;
  letter-spacing: 0.065px;
}
.dashboard-create :is(a, button) svg {
  display: none;
}
.dashboard-create :is(a, button).primary,
.dashboard-attention a.primary {
  color: #fff;
  border-color: var(--dash-brand);
  background: var(--dash-brand);
}
.business-dashboard.dark .dashboard-create :is(a, button).primary,
.business-dashboard.dark .dashboard-attention a.primary {
  color: #101113;
}
.dashboard-period-info {
  display: grid;
  gap: 4px;
}
.dashboard-period-info b {
  font-size: 13px;
  font-weight: 500;
  line-height: 16.9px;
  letter-spacing: 0.065px;
  color: var(--dash-text);
}
.dashboard-period-info span {
  font-size: 13px;
  font-weight: 400;
  line-height: 18.2px;
  letter-spacing: 0.065px;
  color: var(--dash-muted);
}
.dashboard-periods {
  align-self: end;
  justify-self: end;
  display: flex;
  gap: 4px;
  background: transparent;
  padding: 0;
}
.dashboard-periods button {
  height: 33px;
  padding: 8px 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: var(--radius-md, 10px);
  background: transparent;
  color: var(--dash-muted, #506360);
  font-family: var(--font-family-primary, "Lexend", sans-serif);
  font-size: 13px;
  font-weight: 500;
  line-height: 16.9px;
  letter-spacing: 0.065px;
  white-space: nowrap;
  cursor: pointer;
  transition: background-color 150ms ease, color 150ms ease;
}
.dashboard-periods button:hover {
  color: var(--dash-text, #142624);
  background: var(--dash-surface-2, #f4f7f7);
}
.dashboard-periods button.active {
  background: var(--interactive-selected, #dcefec);
  color: var(--interactive-pressed, #0a4a46);
}
.business-dashboard.dark .dashboard-periods button {
  color: #b3b8c2;
}
.business-dashboard.dark .dashboard-periods button:hover {
  color: #f2f3f5;
  background: rgba(255, 255, 255, 0.05);
}
.business-dashboard.dark .dashboard-periods button.active {
  background: rgba(67, 167, 156, 0.2);
  color: #83c7be;
}

.dashboard-card {
  overflow: hidden;
  border: 1px solid var(--dash-border);
  border-radius: 14px;
  background: var(--dash-surface);
}
.dashboard-metrics {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
}
.dashboard-metric {
  min-height: 300px;
  height: 300px;
  padding: 24px;
  display: flex;
  flex-direction: column;
}
.dashboard-metric header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.dashboard-metric header svg {
  width: 20px;
  height: 20px;
  color: var(--dash-brand);
}
.dashboard-card h2 {
  margin: 0;
  font: 500 16px/22.4px var(--font-family-primary, "Lexend", sans-serif);
  letter-spacing: -0.08px;
  color: var(--dash-text);
}
.dashboard-money {
  margin-top: 24px;
  font: 700 20px/24px var(--font-family-mono, "JetBrains Mono", monospace) !important;
  letter-spacing: 0;
  font-variant-numeric: tabular-nums;
  color: var(--dash-text);
}
.dashboard-metric > p {
  margin: 8px 0 24px;
  font: 400 13px/18.2px var(--font-family-primary, "Lexend", sans-serif);
  letter-spacing: 0.065px;
  color: var(--dash-muted);
}
.dashboard-metric-rows {
  display: grid;
  gap: 12px;
}
.dashboard-metric-rows div {
  display: flex;
  justify-content: space-between;
}
.dashboard-metric-rows span {
  font: 400 13px/20.2px var(--font-family-primary, "Lexend", sans-serif);
  letter-spacing: 0;
  color: var(--dash-muted);
}
.dashboard-metric-rows b {
  font: 400 13px/20.2px var(--font-family-primary, "Lexend", sans-serif);
  letter-spacing: 0;
  font-variant-numeric: tabular-nums;
  color: var(--dash-text);
}
.dashboard-note {
  margin-top: auto;
  display: flex;
  align-items: flex-start;
  gap: 8px;
  color: var(--text-tertiary, #6b7b78);
  font: 400 13px/18.2px var(--font-family-primary, "Lexend", sans-serif);
  letter-spacing: 0.065px;
}
.business-dashboard.dark .dashboard-note {
  color: var(--text-tertiary, #9299a5);
}
.dashboard-note svg {
  width: 16px;
  height: 16px;
  flex: none;
  margin-top: 1px;
}

.dashboard-attention {
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  box-shadow: 0 1px 2px rgba(14, 26, 32, 0.06);
}
.dashboard-attention > header {
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.dashboard-attention > header p {
  margin: 4px 0 0;
  font-size: 13px;
  color: var(--dash-muted);
}
.dashboard-attention-row {
  min-height: 72px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) 112px 160px;
  align-items: center;
  gap: 16px;
  padding-bottom: 8px;
  border-bottom: 1px solid var(--dash-border);
}
.dashboard-attention-row:last-child {
  border-bottom: 0;
}
.dashboard-attention-context {
  min-width: 0;
  min-height: 64px;
  display: flex;
  align-items: center;
  gap: 12px;
}
.dashboard-attention-context svg {
  width: 20px;
  height: 20px;
  flex: none;
  color: var(--dash-text);
}
.dashboard-attention-context > div {
  min-width: 0;
  display: grid;
}
.dashboard-attention-context strong,
.dashboard-attention-context p {
  margin: 0;
  font-size: 13px;
  font-weight: 400;
  line-height: 20.2px;
  color: var(--dash-text);
}
.dashboard-attention-row > .status-pill {
  justify-self: start;
}
.dashboard-attention-row a {
  width: 160px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--dash-border-strong);
  border-radius: var(--radius-md, 10px);
  background: var(--dash-surface-2);
  color: var(--dash-text);
  font-size: 13px;
  font-weight: 500;
  white-space: nowrap;
}
.dashboard-attention-row a.primary {
  color: #fff;
  border: 0;
  background: var(--dash-brand);
}
.business-dashboard.dark .dashboard-attention-row a {
  background: var(--dash-surface-2, #22252a);
  border-color: var(--dash-border-strong, #3a3f47);
  color: var(--dash-text, #f2f3f5);
}
.business-dashboard.dark .dashboard-attention-row a.primary {
  color: #101113;
  background: var(--dash-brand, #43a79c);
}

.status-pill {
  height: 22px;
  padding: 0 6px;
  border-radius: 999px;
  font-family: var(--font-family-primary, "Lexend", sans-serif);
  font-size: 12px;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  font-style: normal;
}
.status-pill.status-overdue,
.status-pill.overdue {
  background: var(--danger-soft, #fef2f1);
  color: var(--danger-text, #a3301f);
}
.status-pill.status-awaiting-payment,
.status-pill.awaiting-payment,
.status-pill.status-pending,
.status-pill.pending {
  background: var(--warning-soft, #fef8ec);
  color: var(--warning-text, #7d4412);
}
.status-pill.status-sent,
.status-pill.sent {
  background: var(--info-soft, #eff6ff);
  color: var(--info-text, #1d4ed8);
}
.status-pill.status-paid,
.status-pill.paid {
  background: var(--success-soft, #edfbf2);
  color: var(--success-text, #115a33);
}
.status-pill.status-viewed,
.status-pill.viewed {
  background: var(--interactive-soft, #f0f8f7);
  color: var(--interactive-default, #0f766e);
}
.status-pill.status-draft,
.status-pill.draft {
  background: var(--surface-tertiary, #e8edec);
  color: var(--text-primary, #142624);
}
.business-dashboard.dark .status-pill.status-overdue,
.business-dashboard.dark .status-pill.overdue,
.business-dashboard[data-theme="dark"] .status-pill.status-overdue,
.business-dashboard[data-theme="dark"] .status-pill.overdue {
  background: var(--danger-soft, #332022);
  color: var(--danger-text, #f3aaa4);
}
.business-dashboard.dark .status-pill.status-awaiting-payment,
.business-dashboard.dark .status-pill.awaiting-payment,
.business-dashboard.dark .status-pill.status-pending,
.business-dashboard.dark .status-pill.pending,
.business-dashboard[data-theme="dark"] .status-pill.status-awaiting-payment,
.business-dashboard[data-theme="dark"] .status-pill.awaiting-payment,
.business-dashboard[data-theme="dark"] .status-pill.status-pending,
.business-dashboard[data-theme="dark"] .status-pill.pending {
  background: var(--warning-soft, #342b1d);
  color: var(--warning-text, #e6c78c);
}
.business-dashboard.dark .status-pill.status-sent,
.business-dashboard.dark .status-pill.sent,
.business-dashboard[data-theme="dark"] .status-pill.status-sent,
.business-dashboard[data-theme="dark"] .status-pill.sent {
  background: var(--info-soft, #1e2b3c);
  color: var(--info-text, #aec9ec);
}
.business-dashboard.dark .status-pill.status-paid,
.business-dashboard.dark .status-pill.paid,
.business-dashboard[data-theme="dark"] .status-pill.status-paid,
.business-dashboard[data-theme="dark"] .status-pill.paid {
  background: var(--success-soft, #1b2d25);
  color: var(--success-text, #94d3af);
}
.business-dashboard.dark .status-pill.status-viewed,
.business-dashboard.dark .status-pill.viewed,
.business-dashboard[data-theme="dark"] .status-pill.status-viewed,
.business-dashboard[data-theme="dark"] .status-pill.viewed {
  background: var(--interactive-soft, #22252a);
  color: var(--interactive-default, #43a79c);
}
.business-dashboard.dark .status-pill.status-draft,
.business-dashboard.dark .status-pill.draft,
.business-dashboard[data-theme="dark"] .status-pill.status-draft,
.business-dashboard[data-theme="dark"] .status-pill.draft {
  background: var(--surface-tertiary, #2b2f35);
  color: var(--text-primary, #f2f3f5);
}

.dashboard-charts {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
}
.dashboard-charts article {
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.dashboard-charts article:first-child {
  height: 451px;
}
.dashboard-charts article:last-child {
  height: 432px;
}
.dashboard-charts header p {
  margin: 4px 0 0;
  font-size: 12px;
  line-height: 19px;
  letter-spacing: 0.12px;
  color: var(--dash-muted);
}
.dashboard-chart-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
}
.dashboard-plot-row {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  width: 100%;
  margin-top: 0;
}
.dashboard-currency-scale {
  width: 48px;
  height: 228px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-family: var(--font-family-mono, monospace);
  font-size: 13px;
  line-height: 19px;
  color: var(--text-tertiary, #6b7b78);
  padding: 18px 0 7px;
}
.business-dashboard.dark .dashboard-currency-scale {
  color: var(--text-tertiary, #9299a5);
}
.dashboard-bar-chart {
  flex: 1 1;
  display: flex;
  align-items: flex-end;
  gap: 12px;
  height: 256px;
}
.dashboard-bar-item {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  min-width: 0;
}
.dashboard-bar-track {
  width: 100%;
  height: 210px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  gap: 4px;
  border-bottom: 1px solid var(--chart-grid, #dce3e2);
}
.business-dashboard.dark .dashboard-bar-track {
  border-bottom-color: #343940;
}
.dashboard-bar-track b {
  font-family: var(--font-family-mono, monospace);
  font-size: 13px;
  line-height: 16.9px;
  font-weight: 400;
  color: var(--dash-muted, #506360);
  text-align: center;
}
.business-dashboard.dark .dashboard-bar-track b {
  color: #b3b8c2;
}
.dashboard-bar-track i {
  width: 100%;
  max-width: 44px;
  border-radius: 3px;
  display: block;
}
.dashboard-bar-track i.overdue {
  background: var(--chart-danger, #e04434);
}
.business-dashboard.dark .dashboard-bar-track i.overdue {
  background: var(--chart-danger, #f08078);
}
.dashboard-bar-track i.due {
  background: var(--warning-default, #b7701a);
}
.business-dashboard.dark .dashboard-bar-track i.due {
  background: var(--warning-default, #ddb56b);
}
.dashboard-bar-track i.future {
  background: var(--chart-primary, #0f766e);
}
.business-dashboard.dark .dashboard-bar-track i.future {
  background: var(--chart-primary, #43a79c);
}
.dashboard-bar-label {
  font-family: var(--font-family-primary, "Lexend", sans-serif);
  font-size: 13px;
  font-weight: 400;
  line-height: 19px;
  letter-spacing: 0.12px;
  color: var(--text-tertiary, #6b7b78);
  text-align: center;
  white-space: pre-wrap;
  word-break: break-word;
}
.business-dashboard.dark .dashboard-bar-label {
  color: var(--text-tertiary, #9299a5);
}

.dashboard-cash-chart {
  flex: 1 1;
  display: flex;
  align-items: flex-end;
  gap: 12px;
  height: 237px;
}
.dashboard-cash-item {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  min-width: 0;
}
.dashboard-cash-track {
  width: 100%;
  height: 210px;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  gap: 4px;
  border-bottom: 1px solid var(--chart-grid, #dce3e2);
}
.business-dashboard.dark .dashboard-cash-track {
  border-bottom-color: #343940;
}
.cash-col {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  gap: 4px;
  max-width: 28px;
}
.cash-col b {
  font-family: var(--font-family-mono, monospace);
  font-size: 13px;
  font-weight: 400;
  color: var(--dash-muted, #506360);
  text-align: center;
}
.business-dashboard.dark .cash-col b {
  color: #b3b8c2;
}
.cash-col i {
  width: 100%;
  max-width: 28px;
  border-radius: 3px;
  display: block;
}
.cash-col i.in {
  background: var(--chart-primary, #0f766e);
}
.business-dashboard.dark .cash-col i.in {
  background: var(--chart-primary, #43a79c);
}
.cash-col i.out {
  background: var(--chart-secondary, #aebab8);
}
.business-dashboard.dark .cash-col i.out {
  background: var(--chart-secondary, #77817c);
}

.dashboard-legend {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 24px;
  align-items: center;
}
.dashboard-legend-item {
  display: flex;
  align-items: center;
  gap: 8px;
}
.dashboard-legend-item span:not(.legend-marker) {
  font-family: var(--font-family-primary, "Lexend", sans-serif);
  font-size: 13px;
  font-weight: 400;
  line-height: 19px;
  letter-spacing: 0.12px;
  color: var(--dash-muted, #506360);
  white-space: nowrap;
}
.business-dashboard.dark .dashboard-legend-item span:not(.legend-marker) {
  color: #b3b8c2;
}
.legend-marker {
  width: 10px;
  height: 10px;
  border-radius: 2px;
  flex-shrink: 0;
}
.legend-marker.overdue {
  background: var(--chart-danger, #e04434);
}
.business-dashboard.dark .legend-marker.overdue {
  background: var(--chart-danger, #f08078);
}
.legend-marker.due {
  background: var(--warning-default, #b7701a);
}
.business-dashboard.dark .legend-marker.due {
  background: var(--warning-default, #ddb56b);
}
.legend-marker.future {
  background: var(--chart-primary, #0f766e);
}
.business-dashboard.dark .legend-marker.future {
  background: var(--chart-primary, #43a79c);
}
.legend-marker.cash-out {
  background: var(--chart-secondary, #aebab8);
}
.business-dashboard.dark .legend-marker.cash-out {
  background: var(--chart-secondary, #77817c);
}
.dashboard-chart-summary {
  font-family: var(--font-family-primary, "Lexend", sans-serif);
  font-size: 12px;
  font-weight: 400;
  line-height: 19px;
  letter-spacing: 0.12px;
  color: var(--dash-muted, #506360);
  margin: 0;
  width: 100%;
}
.business-dashboard.dark .dashboard-chart-summary {
  color: #b3b8c2;
}

.dashboard-invoices header {
  min-height: 58px;
  padding: 0 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.dashboard-invoices {
  box-shadow: 0 1px 2px rgba(14, 26, 32, 0.06);
}
.dashboard-invoices header p {
  margin: 2px 0 0;
  font-size: 13px;
  color: var(--text-tertiary, #6b7b78);
}
.business-dashboard.dark .dashboard-invoices header p {
  color: var(--text-tertiary, #9299a5);
}
.dashboard-invoices header a {
  min-height: 40px;
  padding: 0 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--text-link, #0f766e);
  font-size: 13px;
  font-weight: 500;
  line-height: 16.9px;
  letter-spacing: 0.065px;
  border-radius: var(--radius-md, 10px);
}
.business-dashboard.dark .dashboard-invoices header a {
  color: var(--text-link, #83c7be);
}
.dashboard-table {
  overflow-x: auto;
}
.dashboard-table-head,
.dashboard-table-row {
  min-width: 1000px;
  display: grid;
  grid-template-columns:
    minmax(112px, 1fr) minmax(150px, 1.35fr) minmax(100px, 0.9fr)
    minmax(112px, 0.95fr) minmax(108px, 0.95fr) minmax(124px, 1.05fr)
    minmax(104px, 0.9fr) minmax(144px, 1.15fr);
  align-items: center;
  gap: 0;
}
.dashboard-table-head {
  height: 44px;
  color: var(--dash-muted);
  background: var(--dash-surface-2);
  border-bottom: 1px solid var(--dash-border);
  font-size: 12px;
  line-height: 16px;
  font-weight: 500;
}
.dashboard-table-head > span {
  min-width: 0;
  padding: 0 16px;
}
.dashboard-table-head > span:nth-child(7),
.dashboard-table-head > span:nth-child(8) {
  text-align: right;
}
.dashboard-table-row {
  min-height: 52px;
  border-bottom: 1px solid var(--dash-border);
}
.dashboard-invoice-row {
  cursor: pointer;
}
.dashboard-invoice-row:hover {
  background: var(--dash-surface-2);
}
.dashboard-invoice-row:focus-visible {
  outline: 2px solid var(--text-link);
  outline-offset: -2px;
}
.dashboard-empty-state {
  min-height: 112px;
  padding: 24px;
  display: grid;
  place-items: center;
  color: var(--dash-muted);
  font-size: 13px;
  text-align: center;
  border-bottom: 1px solid var(--dash-border);
}
.dashboard-table-row .invoice-number {
  grid-column: 1;
  padding: 10px 16px;
  font-family: var(--font-family-mono, monospace);
  font-size: 14px;
  line-height: 18.2px;
  letter-spacing: 0.28px;
  font-weight: 500;
  text-transform: uppercase;
  color: var(--text-link, #0f766e);
}
.dashboard-table-row .customer {
  grid-column: 2;
  min-width: 0;
  padding: 10px 16px;
  font-size: 13px;
  line-height: 20.2px;
  color: var(--dash-text);
  overflow: hidden;
  text-overflow: ellipsis;
}
.dashboard-table-row .customer small,
.dashboard-table-row .invoice-payment-status small,
.dashboard-table-row .invoice-balance small {
  display: block;
  margin-top: 3px;
  color: var(--dash-muted);
  font-size: 12px;
  line-height: 16px;
}
.dashboard-table-row .invoice-date {
  grid-column: 3;
  padding: 10px 16px;
  font-size: 13px;
  line-height: 19px;
  white-space: nowrap;
}
.dashboard-table-row .due-date {
  grid-column: 4;
  padding: 10px 16px;
  color: var(--dash-text);
  font-size: 13px;
  line-height: 19px;
  white-space: nowrap;
}
.dashboard-table-row .invoice-lifecycle-status {
  grid-column: 5;
  padding: 10px 16px;
}
.dashboard-table-row .invoice-payment-status {
  grid-column: 6;
  padding: 10px 16px;
}
.dashboard-table-row .invoice-lifecycle-status i,
.dashboard-table-row .invoice-payment-status i {
  display: inline-flex;
  min-height: 22px;
  align-items: center;
  padding: 0 6px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 500;
  line-height: 14px;
  font-style: normal;
  white-space: nowrap;
}
.dashboard-table-row .invoice-lifecycle-status i {
  color: var(--interactive-default, #0f766e);
  background: var(--interactive-soft, #f0f8f7);
}
.dashboard-table-row .invoice-lifecycle-status i.draft,
.dashboard-table-row .invoice-lifecycle-status i.pending,
.dashboard-table-row .invoice-payment-status i.draft,
.dashboard-table-row .invoice-payment-status i.voided {
  color: var(--text-secondary, #506360);
  background: var(--surface-tertiary, #e8edec);
}
.dashboard-table-row .invoice-payment-status i.awaiting {
  color: var(--warning-text, #7d4412);
  background: var(--warning-soft, #fef8ec);
}
.dashboard-table-row .invoice-payment-status i.overdue {
  color: var(--danger-text, #a3301f);
  background: var(--danger-soft, #fef2f1);
}
.dashboard-table-row .invoice-payment-status i.paid {
  color: var(--success-text, #115a33);
  background: var(--success-soft, #edfbf2);
}
.dashboard-table-row .invoice-amount {
  grid-column: 7;
  padding: 10px 16px;
  font-family: var(--font-family-mono, monospace);
  font-size: 15px;
  line-height: 19.5px;
  font-weight: 500;
  color: var(--dash-text);
  text-align: right;
  white-space: nowrap;
}
.dashboard-table-row .invoice-balance {
  grid-column: 8;
  min-width: 0;
  padding: 10px 16px;
  text-align: right;
}
.dashboard-table-row .invoice-balance strong {
  display: block;
  font-family: var(--font-family-mono, monospace);
  font-size: 15px;
  line-height: 19.5px;
  white-space: nowrap;
}
.dashboard-invoices footer {
  padding: 16px 24px;
  color: var(--text-tertiary, #6b7b78);
  font-size: 13px;
  line-height: 18.2px;
  letter-spacing: 0.065px;
}
.business-dashboard.dark .dashboard-invoices footer {
  color: var(--text-tertiary, #9299a5);
}
.dashboard-mobile-context,
.dashboard-mobile-plan {
  display: none;
}
.dashboard-sidebar-launcher {
  display: none;
}
.dashboard-overlay {
  position: fixed !important;
  inset: 0 !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  width: 100vw !important;
  height: 100vh !important;
  z-index: 9998 !important;
  background: var(--overlay-default, rgba(10, 22, 20, 0.44)) !important;
  border: 0;
  padding: 0;
  margin: 0;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  display: none;
}
@media (max-width: 1024px) {
  .dashboard-overlay.is-open {
    opacity: 1 !important;
    pointer-events: auto !important;
    display: block !important;
  }
}
@media (min-width: 1025px) {
  .dashboard-overlay,
  .dashboard-overlay.is-open {
    display: none !important;
    opacity: 0 !important;
    pointer-events: none !important;
    visibility: hidden !important;
  }
}
.business-dashboard.dark .dashboard-overlay,
.dashboard-nav.dark ~ .dashboard-overlay,
[data-theme="dark"] .dashboard-overlay {
  background: rgba(0, 0, 0, 0.65) !important;
}

@media (max-width: 1024px) {
  .dashboard-nav {
    display: flex !important;
    position: fixed !important;
    top: 0 !important;
    bottom: 0 !important;
    left: 0 !important;
    width: 280px !important;
    max-width: 85vw !important;
    z-index: 9999 !important;
    transform: translateX(-100%) !important;
    transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1),
      visibility 0.25s ease !important;
    visibility: hidden !important;
    box-shadow: none !important;
    border-right: 1px solid var(--dash-border) !important;
    background: var(--dash-surface) !important;
    overflow: hidden !important;
  }
  .dashboard-nav.is-open {
    transform: translateX(0) !important;
    visibility: visible !important;
    box-shadow: 4px 0 24px rgba(10, 22, 20, 0.18) !important;
  }
  .dashboard-nav .dashboard-org-wrap {
    display: none !important;
  }
  .dashboard-nav-brand {
    height: 76px !important;
    min-height: 76px !important;
    max-height: 76px !important;
    padding: 16px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: space-between !important;
    border-bottom: 1px solid var(--dash-border) !important;
    border-right: 1px solid var(--dash-border) !important;
    box-sizing: border-box !important;
    flex-shrink: 0 !important;
    z-index: 10000 !important;
  }
  .dashboard-nav-close-btn,
  .dashboard-nav-brand > button {
    display: grid !important;
    place-items: center !important;
    margin-left: auto !important;
    width: 44px !important;
    height: 44px !important;
    min-width: 44px !important;
    min-height: 44px !important;
    padding: 0 !important;
    border: 1px solid var(--dash-border) !important;
    border-radius: 10px !important;
    background: var(--dash-surface-2) !important;
    color: var(--dash-muted) !important;
    cursor: pointer !important;
    flex-shrink: 0 !important;
    transition: background-color 0.15s ease, border-color 0.15s ease,
      color 0.15s ease !important;
  }
  .dashboard-nav-close-btn:hover,
  .dashboard-nav-brand > button:hover {
    background: var(--dash-surface-3) !important;
    border-color: var(--dash-border-strong) !important;
    color: var(--dash-text) !important;
  }
  .dashboard-nav.dark .dashboard-nav-close-btn,
  .dashboard-nav.dark .dashboard-nav-brand > button {
    background: var(--surface-secondary, #1b2726) !important;
    border-color: var(--border-subtle, #223230) !important;
    color: var(--text-secondary, #879b97) !important;
  }
  .dashboard-nav.dark .dashboard-nav-close-btn:hover,
  .dashboard-nav.dark .dashboard-nav-brand > button:hover {
    background: var(--surface-tertiary, #243533) !important;
    border-color: var(--border-default, #324644) !important;
    color: var(--text-primary, #f2f3f5) !important;
  }
  .dashboard-nav-close-btn svg,
  .dashboard-nav-brand > button svg {
    width: 18px !important;
    height: 18px !important;
    color: inherit !important;
    stroke: currentColor !important;
    stroke-width: 1.67 !important;
    display: block !important;
  }
  .dashboard-overlay {
    display: block !important;
  }
  .dashboard-sidebar-launcher {
    position: fixed;
    z-index: 38;
    left: 12px;
    bottom: 12px;
    width: 44px;
    height: 44px;
    display: grid;
    place-items: center;
    border: 1px solid var(--dash-border, #dce3e2);
    border-radius: 10px;
    color: var(--dash-text, #142624);
    background: var(--dash-surface, #fff);
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.18);
  }
  .dashboard-main {
    margin-left: 0;
  }
  .dashboard-mobile-controls {
    display: flex;
    gap: 12px;
  }
  .dashboard-mobile-controls button {
    width: 44px;
    height: 44px;
    display: grid;
    place-items: center;
    border: 1px solid var(--dash-border);
    border-radius: 10px;
    background: var(--dash-surface-2);
    color: var(--dash-text);
  }
  .dashboard-mobile-controls button svg {
    width: 20px;
    height: 20px;
  }
  .dashboard-topbar {
    height: 64px;
    padding: 0 24px;
    border-bottom: 1px solid var(--dash-border);
  }
  .dashboard-top-actions {
    display: flex;
    align-items: center;
    gap: 16px;
  }
  .dashboard-top-actions .dashboard-notification {
    width: 36px;
    height: 36px;
    display: grid;
    place-items: center;
    border-radius: 18px;
    background: transparent;
    color: var(--dash-text);
  }
  .dashboard-top-actions .dashboard-notification svg {
    width: 20px;
    height: 20px;
  }
  .dashboard-profile-control {
    padding: 4px;
    gap: 4px;
  }
  .dashboard-avatar {
    width: 32px;
    height: 32px;
    border-radius: 16px;
  }
  .dashboard-profile-control > svg {
    width: 16px;
    height: 16px;
  }
  .dashboard-credits {
    display: grid;
  }
  .dashboard-profile-help {
    display: flex !important;
  }
  .dashboard-appearance {
    border-bottom: 1px solid var(--dash-border);
    padding-bottom: 18px;
    margin-bottom: 8px;
  }
  .dashboard-content {
    max-width: none;
    padding: 24px;
    gap: 20px;
    display: flex;
    flex-direction: column;
  }

  /* ORDER matching Figma:
     1. Mobile/Tablet context (Product identity + Org selector + Shortcuts)
     2. Heading (Dashboard title + Create buttons + Metadata + Periods)
     3. Financial summary metrics
     4. Needs attention
     5. Recent invoices
     6. Historical analysis charts
     7. Plan and usage banner
  */
  .dashboard-mobile-context {
    order: 1;
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
  }
  .dashboard-org-product-row {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .dashboard-product-identity {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .dashboard-launcher-btn {
    width: 44px;
    height: 44px;
    display: grid;
    place-items: center;
    border: 1px solid var(--dash-border);
    border-radius: 10px;
    background: var(--dash-surface-2);
    color: var(--dash-text);
    cursor: pointer;
  }
  .dashboard-launcher-btn svg {
    width: 20px;
    height: 20px;
  }
  .dashboard-product-name {
    font-family: var(--font-family-primary, "Lexend", sans-serif);
    font-size: 13px;
    font-weight: 500;
    line-height: 16.9px;
    letter-spacing: 0.065px;
    color: var(--dash-muted);
    white-space: nowrap;
  }
  .dashboard-mobile-org {
    height: 61px;
    padding: 12px;
    display: flex;
    align-items: center;
    gap: 8px;
    border: 1px solid var(--dash-border);
    border-radius: var(--radius-md, 10px);
    background: var(--dash-surface);
    text-align: left;
    cursor: pointer;
  }
  .dashboard-mobile-org > span {
    width: 32px;
    height: 32px;
    flex: none;
    display: grid;
    place-items: center;
    border: 1.5px solid var(--dash-border);
    border-radius: 50%;
    color: var(--dash-brand);
    background: var(--dash-brand-soft);
    font-family: var(--font-family-primary, "Lexend", sans-serif);
    font-size: 12px;
    font-weight: 500;
  }
  .dashboard-mobile-org div {
    min-width: 0;
    flex: 1 1;
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
  .dashboard-mobile-org strong {
    overflow: hidden;
    font-size: 13px;
    font-weight: 500;
    line-height: 16.9px;
    letter-spacing: 0.065px;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: var(--dash-text);
  }
  .dashboard-mobile-org small {
    font-size: 11px;
    font-weight: 400;
    line-height: 15.4px;
    letter-spacing: 0.11px;
    color: var(--dash-muted);
    white-space: nowrap;
  }
  .dashboard-mobile-org .org-switch-icon,
  .dashboard-mobile-org svg {
    width: 16px;
    height: 16px;
    flex: none;
    margin-left: auto;
    color: var(--interactive-default, #0f766e) !important;
    stroke-width: 3;
  }
  .business-dashboard.dark .dashboard-mobile-org {
    background: var(--dash-surface);
    border-color: var(--dash-border);
  }
  .business-dashboard.dark .dashboard-mobile-org > span {
    border-color: var(--dash-border);
    color: var(--dash-brand);
    background: var(--dash-brand-soft);
  }
  .business-dashboard.dark .dashboard-mobile-org strong {
    color: var(--dash-text);
  }
  .business-dashboard.dark .dashboard-mobile-org small {
    color: var(--dash-muted);
  }
  .business-dashboard.dark .dashboard-mobile-org .org-switch-icon,
  .business-dashboard.dark .dashboard-mobile-org svg {
    color: var(--interactive-default, #43a79c) !important;
  }

  /* Shortcuts matching Figma 452:55846 and 504:36335 */
  .dashboard-shortcuts {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
    padding-bottom: 8px;
    border-bottom: 1px solid var(--dash-border);
    color: var(--text-link, #0f766e);
  }
  .dashboard-shortcut {
    height: 40px;
    padding: 0 12px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    border-radius: var(--radius-md, 10px);
    font-family: var(--font-family-primary, "Lexend", sans-serif);
    font-size: 13px;
    font-weight: 500;
    color: var(--text-link, #0f766e);
    white-space: nowrap;
    text-decoration: none;
    background: transparent;
    transition: background-color 150ms ease, color 150ms ease;
  }
  .dashboard-shortcut:hover {
    background: var(--dash-surface-2, #f4f7f7);
    color: var(--interactive-hover, #0c5f59);
  }
  .business-dashboard.dark .dashboard-shortcuts {
    border-bottom-color: var(--dash-border, #2c3036);
  }
  .business-dashboard.dark .dashboard-shortcut {
    color: var(--text-link, #83c7be);
  }
  .business-dashboard.dark .dashboard-shortcut:hover {
    background: rgba(255, 255, 255, 0.05);
    color: var(--interactive-hover, #83c7be);
  }

  /* Heading matching Figma 504:36317 */
  .dashboard-heading {
    order: 2;
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
  }
  .dashboard-heading > div:first-child h1 {
    font-size: 24px;
    font-weight: 600;
    line-height: 30px;
    letter-spacing: -0.36px;
    color: var(--dash-text);
    margin: 0;
  }
  .dashboard-heading > div:first-child p {
    font-size: 13px;
    font-weight: 400;
    line-height: 20.2px;
    letter-spacing: 0;
    color: var(--dash-muted);
    margin: 4px 0 0;
  }
  .dashboard-create {
    display: flex;
    gap: 12px;
    width: 100%;
  }
  .dashboard-create :is(a, button) {
    flex: 1 1;
    height: 40px;
    padding: 0 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    border-radius: var(--radius-md, 10px);
    font-size: 13px;
    font-weight: 500;
    white-space: nowrap;
    text-decoration: none;
    background: var(--dash-surface-2, #f4f7f7);
    border: 1px solid var(--dash-border-strong, #cdd6d4);
    color: var(--dash-text, #142624);
  }
  .dashboard-create :is(a, button).primary {
    background: var(--dash-brand, #0f766e);
    border: 0;
    color: #ffffff;
  }
  .business-dashboard.dark .dashboard-create :is(a, button) {
    background: var(--dash-surface-2, #22252a);
    border-color: var(--dash-border-strong, #3a3f47);
    color: var(--dash-text, #f2f3f5);
  }
  .business-dashboard.dark .dashboard-create :is(a, button).primary {
    background: var(--dash-brand, #43a79c);
    color: #101113;
  }
  .dashboard-create :is(a, button) svg {
    display: none;
  }
  .dashboard-period-info {
    display: flex;
    flex-direction: column;
    gap: 4px;
    width: 100%;
  }
  .dashboard-period-info b {
    font-size: 13px;
    font-weight: 500;
    line-height: 16.9px;
    letter-spacing: 0.065px;
    color: var(--dash-text);
  }
  .dashboard-period-info span {
    font-size: 13px;
    font-weight: 400;
    line-height: 18.2px;
    letter-spacing: 0.065px;
    color: var(--dash-muted);
  }
  .dashboard-periods {
    width: -moz-fit-content;
    width: fit-content;
    max-width: 100%;
    display: flex;
    gap: 4px;
    align-items: flex-end;
    align-self: flex-start;
    justify-self: flex-start;
    padding: 0;
    border: 0;
    background: transparent;
  }
  .dashboard-periods button {
    height: 33px;
    padding: 8px 16px;
    border-radius: var(--radius-md, 10px);
    font-family: var(--font-family-primary, "Lexend", sans-serif);
    font-size: 13px;
    font-weight: 500;
    line-height: 16.9px;
    letter-spacing: 0.065px;
    border: 0;
    background: transparent;
    color: var(--dash-muted, #506360);
    cursor: pointer;
    transition: background-color 150ms ease, color 150ms ease;
    white-space: nowrap;
  }
  .dashboard-periods button:hover {
    color: var(--dash-text, #142624);
    background: var(--dash-surface-2, #f4f7f7);
  }
  .dashboard-periods button.active {
    background: var(--interactive-selected, #dcefec);
    color: var(--interactive-pressed, #0a4a46);
  }
  .business-dashboard.dark .dashboard-periods button,
  .business-dashboard[data-theme="dark"] .dashboard-periods button {
    color: var(--dash-muted, #b3b8c2);
  }
  .business-dashboard.dark .dashboard-periods button:hover,
  .business-dashboard[data-theme="dark"] .dashboard-periods button:hover {
    color: var(--dash-text, #f2f3f5);
    background: rgba(255, 255, 255, 0.05);
  }
  .business-dashboard.dark .dashboard-periods button.active,
  .business-dashboard[data-theme="dark"] .dashboard-periods button.active {
    background: rgba(67, 167, 156, 0.2);
    color: #83c7be;
  }

  /* Financial summary matching Figma 504:36398 */
  .dashboard-metrics {
    order: 3;
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
  }
  .dashboard-metric,
  .dashboard-metric:last-child {
    width: 100%;
    height: auto;
    min-height: auto;
    padding: 16px;
    border-radius: var(--radius-lg, 14px);
    display: flex;
    flex-direction: column;
    gap: 12px;
    border: 1px solid var(--dash-border);
    background: var(--dash-surface);
  }
  .dashboard-metric header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }
  .dashboard-metric header h2 {
    font-size: 16px;
    font-weight: 500;
    line-height: 22.4px;
    letter-spacing: -0.08px;
    color: var(--dash-text);
    margin: 0;
  }
  .dashboard-metric header svg {
    width: 20px;
    height: 20px;
    color: var(--dash-brand, #0f766e);
  }
  .business-dashboard.dark .dashboard-metric header svg,
  .business-dashboard[data-theme="dark"] .dashboard-metric header svg {
    color: var(--dash-brand, #43a79c);
  }
  .dashboard-metric .dashboard-money {
    font-family: var(--font-family-mono, monospace);
    font-size: 20px;
    font-weight: 700;
    line-height: 24px;
    letter-spacing: 0;
    color: var(--dash-text);
    margin: 0;
  }
  .dashboard-metric > p {
    font-size: 13px;
    font-weight: 400;
    line-height: 18.2px;
    letter-spacing: 0.065px;
    color: var(--dash-muted);
    margin: 0;
  }
  .dashboard-metric-rows {
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;
    margin: 0;
  }
  .dashboard-metric-rows > div {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
    width: 100%;
    padding: 0;
    border: 0;
  }
  .dashboard-metric-rows > div span {
    font-size: 13px;
    font-weight: 400;
    line-height: 20.2px;
    color: var(--dash-muted);
  }
  .dashboard-metric-rows > div b {
    font-size: 13px;
    font-weight: 400;
    line-height: 20.2px;
    color: var(--dash-text);
  }
  .dashboard-note {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    width: 100%;
    margin-top: 0;
    font-size: 13px;
    font-weight: 400;
    line-height: 18.2px;
    letter-spacing: 0.065px;
    color: var(--text-tertiary, #6b7b78);
  }
  .dashboard-note svg {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
    margin-top: 1px;
    color: var(--text-tertiary, #6b7b78);
  }

  /* Needs attention matching Figma 504:36516 */
  .dashboard-attention {
    order: 4;
    padding: 16px;
    border-radius: var(--radius-lg, 14px);
    border: 1px solid var(--dash-border);
    background: var(--dash-surface);
  }
  .dashboard-attention > header {
    padding-bottom: 4px;
  }
  .dashboard-attention > header h2 {
    font-size: 16px;
    font-weight: 500;
    line-height: 22.4px;
    letter-spacing: -0.08px;
    color: var(--dash-text);
    margin: 0;
  }
  .dashboard-attention > header p {
    font-size: 13px;
    font-weight: 400;
    line-height: 18.2px;
    letter-spacing: 0.065px;
    color: var(--dash-muted);
    margin: 4px 0 0;
  }
  .dashboard-attention > .dashboard-attention-row {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    padding: 12px 0 16px;
    border-top: 1px solid var(--dash-border);
    width: 100%;
  }
  .dashboard-attention > .dashboard-attention-row:last-child {
    padding-bottom: 0;
  }
  .dashboard-attention-priority {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    width: 100%;
  }
  .dashboard-attention-priority svg {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
    color: var(--dash-text);
  }
  .dashboard-attention-priority strong {
    font-size: 13px;
    font-weight: 500;
    line-height: 16.9px;
    letter-spacing: 0.065px;
    color: var(--dash-text);
  }
  .dashboard-attention-desc {
    font-size: 13px;
    font-weight: 400;
    line-height: 20.2px;
    letter-spacing: 0;
    color: var(--dash-text);
    margin: 0;
    width: 100%;
  }
  .dashboard-attention-row a {
    width: 100%;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: var(--radius-md, 10px);
    font-size: 13px;
    font-weight: 500;
    text-decoration: none;
    background: var(--dash-surface-2, #f4f7f7);
    border: 1px solid var(--dash-border-strong, #cdd6d4);
    color: var(--dash-text, #142624);
  }
  .dashboard-attention-row a.primary {
    background: var(--dash-brand, #0f766e);
    border: 0;
    color: #ffffff;
  }
  .business-dashboard.dark .dashboard-attention-row a {
    background: var(--dash-surface-2, #22252a);
    border-color: var(--dash-border-strong, #3a3f47);
    color: var(--dash-text, #f2f3f5);
  }
  .business-dashboard.dark .dashboard-attention-row a.primary {
    background: var(--dash-brand, #43a79c);
    color: #101113;
  }

  /* Recent Invoices matching Figma 504:36585 */
  .dashboard-invoices {
    order: 5;
    border-radius: var(--radius-lg, 14px);
    border: 1px solid var(--dash-border);
    background: var(--dash-surface);
    box-shadow: 0px 1px 2px 0px rgba(14, 26, 32, 0.06);
  }
  .dashboard-invoices header {
    padding: 16px;
    height: auto;
    align-items: flex-start;
  }
  .dashboard-invoices header h2 {
    font-size: 16px;
    font-weight: 500;
    line-height: 22.4px;
    letter-spacing: -0.08px;
    color: var(--dash-text);
    margin: 0;
  }
  .dashboard-invoices header p {
    font-size: 13px;
    font-weight: 400;
    line-height: 18.2px;
    letter-spacing: 0.065px;
    color: var(--text-tertiary, #6b7b78);
    margin: 4px 0 0;
  }
  .dashboard-invoices header a {
    height: 40px;
    padding: 0 12px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    font-weight: 500;
    line-height: 16.9px;
    letter-spacing: 0.065px;
    color: var(--text-link, #0f766e);
    border-radius: var(--radius-md, 10px);
    white-space: nowrap;
  }
  .dashboard-table {
    padding: 0;
  }
  .dashboard-table-head {
    display: none;
  }
  .dashboard-table-row {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    grid-template-areas:
      "invoice lifecycle"
      "customer customer"
      "invoice-date due"
      "payment payment"
      "amount balance";
    align-items: center;
    padding: 16px;
    border-top: 1px solid var(--dash-border);
    border-bottom: 0;
    min-width: 0;
    gap: 8px;
    width: 100%;
  }
  .dashboard-table-row .invoice-number {
    grid-area: invoice;
    font-family: var(--font-family-mono, monospace);
    font-size: 14px;
    font-weight: 500;
    line-height: 18.2px;
    letter-spacing: 0.28px;
    text-transform: uppercase;
    color: var(--dash-text);
    padding: 0;
  }
  .dashboard-table-row .invoice-number {
    color: var(--text-link, #0f766e);
  }
  .dashboard-table-row .customer {
    grid-area: customer;
    font-family: var(--font-family-primary, "Lexend", sans-serif);
    font-size: 13px;
    font-weight: 400;
    line-height: 20.2px;
    color: var(--dash-text);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
    padding: 0;
  }
  .dashboard-table-row .customer small {
    margin-top: 2px;
  }
  .dashboard-table-row .invoice-date {
    grid-area: invoice-date;
    padding: 0;
    color: var(--dash-muted);
    font-size: 13px;
    white-space: nowrap;
  }
  .dashboard-table-row .invoice-date::before {
    content: "Invoice date ";
  }
  .dashboard-table-row .due-date {
    grid-area: due;
    font-family: var(--font-family-primary, "Lexend", sans-serif);
    font-size: 13px;
    font-weight: 400;
    line-height: 20.2px;
    color: var(--dash-muted);
    padding: 0;
    text-align: right;
  }
  .dashboard-table-row .due-date::before {
    content: "Due ";
  }
  .dashboard-table-row .invoice-lifecycle-status {
    grid-area: lifecycle;
    justify-self: end;
    padding: 0;
  }
  .dashboard-table-row .invoice-payment-status {
    grid-area: payment;
    padding: 0;
  }
  .dashboard-table-row .invoice-amount {
    grid-area: amount;
    font-family: var(--font-family-mono, monospace);
    font-size: 15px;
    font-weight: 500;
    line-height: 19.5px;
    color: var(--dash-text);
    white-space: nowrap;
    padding: 0;
    text-align: left;
  }
  .dashboard-table-row .invoice-amount::before {
    content: "Total ";
    color: var(--dash-muted);
    font-family: var(--font-family-primary, "Lexend", sans-serif);
    font-size: 12px;
    font-weight: 400;
  }
  .dashboard-table-row .invoice-balance {
    grid-area: balance;
    padding: 0;
    text-align: right;
  }
  .dashboard-table-row--loading > :nth-child(1) {
    grid-area: invoice;
  }
  .dashboard-table-row--loading > :nth-child(2) {
    grid-area: customer;
  }
  .dashboard-table-row--loading > :nth-child(3) {
    grid-area: invoice-date;
  }
  .dashboard-table-row--loading > :nth-child(4) {
    grid-area: due;
  }
  .dashboard-table-row--loading > :nth-child(5) {
    grid-area: lifecycle;
  }
  .dashboard-table-row--loading > :nth-child(6) {
    grid-area: payment;
  }
  .dashboard-table-row--loading > :nth-child(7) {
    grid-area: amount;
  }
  .dashboard-table-row--loading > :nth-child(8) {
    grid-area: balance;
  }
  .dashboard-invoices footer {
    border-top: 1px solid var(--dash-border);
    padding: 16px;
    font-size: 13px;
    font-weight: 400;
    line-height: 18.2px;
    letter-spacing: 0.065px;
    color: var(--text-tertiary, #6b7b78);
  }

  /* Historical analysis charts matching Figma 504:36970 */
  .dashboard-charts {
    order: 6;
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
  }
  .dashboard-charts article {
    min-height: auto;
    padding: 16px;
    border-radius: var(--radius-lg, 14px);
    border: 1px solid var(--dash-border);
    background: var(--dash-surface);
  }
  .dashboard-charts header h2 {
    font-size: 16px;
    font-weight: 500;
    line-height: 22.4px;
    letter-spacing: -0.08px;
    color: var(--dash-text);
    margin: 0;
  }
  .dashboard-charts header p {
    font-size: 13px;
    font-weight: 400;
    line-height: 18.2px;
    letter-spacing: 0.065px;
    color: var(--dash-muted);
    margin: 4px 0 0;
  }
  .dashboard-chart-container {
    gap: 16px;
  }
  .dashboard-plot-row {
    margin-top: 8px;
  }
  .dashboard-currency-scale {
    width: 48px;
    height: 210px;
    font-size: 12px;
  }
  .dashboard-bar-chart,
  .dashboard-cash-chart {
    height: 228px;
  }
  .dashboard-bar-label {
    font-size: 12px;
    line-height: 18px;
  }

  /* Plan and usage banner matching Figma 504:37240 */
  .dashboard-mobile-plan {
    order: 7;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 56px;
    padding: 16px;
    border: 1px solid var(--dash-border);
    border-radius: var(--radius-md, 10px);
    background: var(--dash-surface);
    width: 100%;
  }
  .dashboard-mobile-plan strong {
    font-family: var(--font-family-mono, monospace);
    font-size: 14px;
    font-weight: 500;
    line-height: 18.2px;
    letter-spacing: 0.28px;
    text-transform: uppercase;
    color: var(--dash-text);
  }
  .dashboard-mobile-plan span {
    font-family: var(--font-family-primary, "Lexend", sans-serif);
    font-size: 13px;
    font-weight: 400;
    line-height: 20.2px;
    letter-spacing: 0;
    color: var(--dash-muted);
  }
  .dashboard-mobile-plan a {
    height: 40px;
    padding: 0 12px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: var(--radius-md, 10px);
    font-family: var(--font-family-primary, "Lexend", sans-serif);
    font-size: 13px;
    font-weight: 500;
    color: var(--text-link, #0f766e);
    text-decoration: none;
    transition: background-color 150ms ease, color 150ms ease;
  }
  .dashboard-mobile-plan a:hover {
    background: var(--dash-surface-2, #f4f7f7);
    color: var(--interactive-hover, #0c5f59);
  }
  .business-dashboard.dark .dashboard-mobile-plan a,
  .business-dashboard[data-theme="dark"] .dashboard-mobile-plan a {
    color: var(--text-link, #83c7be);
  }
  .business-dashboard.dark .dashboard-mobile-plan a:hover,
  .business-dashboard[data-theme="dark"] .dashboard-mobile-plan a:hover {
    background: rgba(255, 255, 255, 0.05);
  }
  .business-dashboard.dark .dashboard-invoice-actions button:hover,
  .business-dashboard[data-theme="dark"]
    .dashboard-invoice-actions
    button:hover {
    background: var(--dash-surface-2, #22252a);
    color: var(--dash-text, #f2f3f5);
  }
}

/* ==========================================================================
   TABLET VIEW (768px - 1024px) — Figma Node 452:55830 & 460:63624
   ========================================================================== */
@media (min-width: 768px) and (max-width: 1024px) {
  .business-dashboard:has(.dashboard-product-identity)
    .dashboard-mobile-controls,
  .business-dashboard:has(.dashboard-product-identity)
    .app-topbar__mobile-controls,
  .dashboard-main:has(.dashboard-product-identity) .dashboard-mobile-controls {
    display: none !important;
  }
  .business-dashboard:has(.dashboard-launcher-btn) .dashboard-sidebar-launcher,
  .business-dashboard:has(.app-topbar__mobile-btn) .dashboard-sidebar-launcher {
    display: none !important;
  }
  .business-dashboard:not(:has(.dashboard-product-identity))
    .dashboard-mobile-controls,
  .business-dashboard:not(:has(.dashboard-product-identity))
    .app-topbar__mobile-controls {
    display: flex !important;
  }
  .dashboard-topbar {
    padding: 0 24px !important;
  }
  .dashboard-search {
    display: flex !important;
    max-width: 320px !important;
    width: 100% !important;
    height: 40px !important;
    padding: 0 12px !important;
    align-items: center !important;
    gap: 8px !important;
    border: 1px solid var(--dash-border) !important;
    border-radius: 10px !important;
    background: var(--dash-surface-2) !important;
  }
  .dashboard-search svg {
    width: 16px !important;
    height: 16px !important;
    color: var(--text-tertiary, #6b7b78) !important;
    flex-shrink: 0;
  }
  .dashboard-search input {
    font-family: var(--font-family-primary, "Lexend", sans-serif) !important;
    font-size: 14px !important;
    border: 0 !important;
    outline: 0 !important;
    background: transparent !important;
    color: var(--dash-text) !important;
    width: 100% !important;
  }
  .dashboard-search input::placeholder {
    color: var(--text-tertiary, #6b7b78) !important;
  }
  .dashboard-top-actions {
    display: flex !important;
    align-items: center !important;
    gap: 16px !important;
  }
  .dashboard-top-actions .dashboard-topbar-credits,
  .dashboard-top-actions > span {
    display: inline-flex !important;
    height: 32px !important;
    padding: 0 12px 0 10px !important;
    align-items: center !important;
    gap: 6px !important;
    border: 1px solid var(--border-default, #cdd6d4) !important;
    border-radius: 999px !important;
    font-family: var(--font-family-primary, "Lexend", sans-serif) !important;
    font-size: 13px !important;
    font-weight: 500 !important;
    color: var(--text-primary, #142624) !important;
    white-space: nowrap !important;
    background: transparent !important;
  }
  .dashboard-top-actions .dashboard-topbar-credits svg,
  .dashboard-top-actions > span svg {
    width: 16px !important;
    height: 16px !important;
  }
  .business-dashboard.dark .dashboard-top-actions .dashboard-topbar-credits,
  .business-dashboard.dark .dashboard-top-actions > span {
    border-color: var(--dash-border-strong, #3a3f47) !important;
    color: var(--dash-text, #f2f3f5) !important;
  }
  .dashboard-top-actions .dashboard-topbar-help,
  .dashboard-top-actions > button[aria-label="Help"] {
    display: grid !important;
    width: 36px !important;
    height: 36px !important;
    place-items: center !important;
    border-radius: 18px !important;
    border: 0 !important;
    background: transparent !important;
    cursor: pointer !important;
  }
  .dashboard-top-actions .dashboard-topbar-help svg,
  .dashboard-top-actions > button[aria-label="Help"] svg {
    width: 20px !important;
    height: 20px !important;
  }
  .dashboard-top-actions .dashboard-notification {
    display: grid !important;
    width: 36px !important;
    height: 36px !important;
    place-items: center !important;
    border-radius: 18px !important;
    background: transparent !important;
  }
  .dashboard-content {
    padding: 24px !important;
    gap: 20px !important;
  }
  .dashboard-mobile-context {
    display: flex !important;
    flex-direction: column !important;
    gap: 16px !important;
    width: 100% !important;
  }
  .dashboard-org-product-row {
    display: flex !important;
    align-items: center !important;
    justify-content: space-between !important;
    width: 100% !important;
  }
  .dashboard-product-identity {
    display: flex !important;
    align-items: center !important;
    gap: 8px !important;
  }
  .dashboard-launcher-btn {
    width: 44px !important;
    height: 44px !important;
    display: grid !important;
    place-items: center !important;
    border: 1px solid var(--border-subtle, #dce3e2) !important;
    border-radius: 10px !important;
    background: var(--surface-secondary, #f4f7f7) !important;
    color: var(--dash-text, #142624) !important;
    cursor: pointer !important;
    padding: 0 !important;
  }
  .business-dashboard.dark .dashboard-launcher-btn {
    background: var(--dash-surface-2, #22252a) !important;
    border-color: var(--dash-border, #2c3036) !important;
    color: var(--dash-text, #f2f3f5) !important;
  }
  .dashboard-launcher-btn svg {
    width: 20px !important;
    height: 20px !important;
  }
  .dashboard-product-name {
    font-family: var(--font-family-primary, "Lexend", sans-serif) !important;
    font-size: 13px !important;
    font-weight: 500 !important;
    line-height: 16.9px !important;
    letter-spacing: 0.065px !important;
    color: var(--text-secondary, #506360) !important;
    white-space: nowrap !important;
  }
  .business-dashboard.dark .dashboard-product-name {
    color: var(--dash-muted, #b3b8c2) !important;
  }
  .dashboard-mobile-org {
    width: 220px !important;
    height: 61px !important;
    padding: 12px !important;
    display: flex !important;
    align-items: center !important;
    gap: 8px !important;
    border: 1px solid var(--border-subtle, #dce3e2) !important;
    border-radius: 10px !important;
    background: var(--surface-primary, #ffffff) !important;
    cursor: pointer !important;
    flex: none !important;
    box-sizing: border-box !important;
  }
  .business-dashboard.dark .dashboard-mobile-org {
    background: var(--dash-surface, #191b1f) !important;
    border-color: var(--dash-border, #2c3036) !important;
  }
  .dashboard-mobile-org .org-switch-icon,
  .org-switch-icon {
    width: 16px !important;
    height: 16px !important;
    margin-left: auto !important;
    color: var(--interactive-default, #0f766e) !important;
    stroke-width: 3 !important;
    flex-shrink: 0 !important;
  }
  .business-dashboard.dark .dashboard-mobile-org .org-switch-icon,
  .business-dashboard.dark .org-switch-icon {
    color: var(--interactive-default, #43a79c) !important;
  }
  .dashboard-shortcuts {
    display: flex !important;
    align-items: center !important;
    gap: 8px !important;
    padding-bottom: 8px !important;
    border-bottom: 1px solid var(--border-subtle, #dce3e2) !important;
    width: 100% !important;
  }
  .dashboard-shortcut {
    height: 40px !important;
    padding: 0 12px !important;
    border-radius: 10px !important;
    font-family: var(--font-family-primary, "Lexend", sans-serif) !important;
    font-size: 13px !important;
    font-weight: 500 !important;
    color: var(--text-link, #0f766e) !important;
    white-space: nowrap !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
  }
  .dashboard-heading {
    display: grid !important;
    grid-template-columns: 1fr auto !important;
    gap: 16px 20px !important;
    width: 100% !important;
    align-items: center !important;
  }
  .dashboard-heading > div:first-child {
    grid-column: 1 !important;
    grid-row: 1 !important;
    display: flex !important;
    flex-direction: column !important;
    gap: 4px !important;
  }
  .dashboard-heading > div:first-child h1 {
    font-size: 28px !important;
    line-height: 35px !important;
    font-weight: 600 !important;
    letter-spacing: -0.42px !important;
    margin: 0 !important;
    color: var(--dash-text) !important;
  }
  .dashboard-heading > div:first-child p {
    font-size: 13px !important;
    line-height: 20.2px !important;
    letter-spacing: 0 !important;
    margin: 0 !important;
    color: var(--dash-muted) !important;
  }
  .dashboard-create {
    grid-column: 2 !important;
    grid-row: 1 !important;
    display: flex !important;
    flex-direction: row !important;
    gap: 12px !important;
    width: auto !important;
    justify-content: flex-end !important;
    align-items: center !important;
  }
  .dashboard-create :is(a, button) {
    width: auto !important;
    flex: none !important;
    height: 36px !important;
    padding: 0 14px !important;
    border-radius: 10px !important;
    font-family: var(--font-family-primary, "Lexend", sans-serif) !important;
    font-size: 13px !important;
    font-weight: 500 !important;
    white-space: nowrap !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
  }
  .dashboard-create a:not(.primary) {
    background: var(--surface-primary, #ffffff) !important;
    border: 1px solid var(--border-default, #cdd6d4) !important;
    color: var(--text-primary, #142624) !important;
  }
  .dashboard-create :is(a, button).primary {
    background: var(--interactive-default, #0f766e) !important;
    border: 0 !important;
    color: #ffffff !important;
  }
  .business-dashboard.dark .dashboard-create a:not(.primary) {
    background: var(--dash-surface-2, #22252a) !important;
    border-color: var(--dash-border-strong, #3a3f47) !important;
    color: var(--dash-text, #f2f3f5) !important;
  }
  .business-dashboard.dark .dashboard-create :is(a, button).primary {
    background: var(--interactive-default, #43a79c) !important;
    color: #101113 !important;
  }
  .dashboard-period-info {
    grid-column: 1 !important;
    grid-row: 2 !important;
    display: flex !important;
    flex-direction: column !important;
    gap: 4px !important;
    width: 100% !important;
  }
  .dashboard-period-info b {
    font-size: 13px !important;
    font-weight: 500 !important;
    line-height: 16.9px !important;
    letter-spacing: 0.065px !important;
    color: var(--dash-text) !important;
  }
  .dashboard-period-info span {
    font-size: 13px !important;
    font-weight: 400 !important;
    line-height: 18.2px !important;
    letter-spacing: 0.065px !important;
    color: var(--dash-muted) !important;
  }
  .dashboard-periods {
    grid-column: 2 !important;
    grid-row: 2 !important;
    align-self: center !important;
    justify-self: end !important;
    display: flex !important;
    gap: 4px !important;
    width: auto !important;
    background: transparent !important;
    padding: 0 !important;
  }
  .dashboard-periods button {
    height: 33px !important;
    padding: 8px 16px !important;
    border-radius: 10px !important;
    font-size: 13px !important;
    font-weight: 500 !important;
    line-height: 16.9px !important;
    letter-spacing: 0.065px !important;
  }
  .dashboard-metrics {
    display: grid !important;
    grid-template-columns: repeat(2, 1fr) !important;
    gap: 16px !important;
    width: 100% !important;
  }
  .dashboard-metric:nth-child(1) {
    grid-column: 1 !important;
    width: 100% !important;
  }
  .dashboard-metric:nth-child(2) {
    grid-column: 2 !important;
    width: 100% !important;
  }
  .dashboard-metric:nth-child(3) {
    grid-column: 1 / -1 !important;
    width: 100% !important;
  }
  .dashboard-attention > .dashboard-attention-row {
    display: grid !important;
    grid-template-columns: 1fr auto !important;
    grid-template-rows: auto auto !important;
    gap: 8px 16px !important;
    align-items: center !important;
    padding: 16px 0 !important;
  }
  .dashboard-attention-context {
    grid-column: 1 !important;
    grid-row: 1 / span 2 !important;
  }
  .dashboard-attention-row .status-pill {
    grid-column: 2 !important;
    grid-row: 1 !important;
    justify-self: end !important;
    margin: 0 !important;
  }
  .dashboard-attention-row a {
    grid-column: 2 !important;
    grid-row: 2 !important;
    justify-self: end !important;
    width: auto !important;
    min-width: 140px !important;
    height: 36px !important;
    padding: 0 16px !important;
  }
  .dashboard-mobile-plan {
    display: flex !important;
    flex-direction: row !important;
    align-items: center !important;
    justify-content: space-between !important;
    padding: 16px 20px !important;
    border-radius: 10px !important;
    background: var(--surface-secondary, #f4f7f7) !important;
    border: 1px solid var(--border-subtle, #dce3e2) !important;
    height: auto !important;
    width: 100% !important;
    box-sizing: border-box !important;
  }
  .dashboard-mobile-plan strong {
    font-family: var(--font-family-primary, "Lexend", sans-serif) !important;
    font-size: 13px !important;
    font-weight: 500 !important;
    text-transform: uppercase !important;
    color: var(--text-primary, #142624) !important;
  }
  .dashboard-mobile-plan span {
    font-family: var(--font-family-primary, "Lexend", sans-serif) !important;
    font-size: 13px !important;
    font-weight: 400 !important;
    color: var(--text-secondary, #506360) !important;
  }
  .dashboard-mobile-plan a {
    font-family: var(--font-family-primary, "Lexend", sans-serif) !important;
    font-size: 13px !important;
    font-weight: 500 !important;
    color: var(--interactive-default, #0f766e) !important;
    text-decoration: none !important;
  }
  .business-dashboard.dark .dashboard-mobile-plan {
    background: var(--dash-surface-2, #22252a) !important;
    border-color: var(--dash-border, #2c3036) !important;
  }
  .business-dashboard.dark .dashboard-mobile-plan strong {
    color: var(--dash-text, #f2f3f5) !important;
  }
  .business-dashboard.dark .dashboard-mobile-plan span {
    color: var(--dash-muted, #b3b8c2) !important;
  }
  .business-dashboard.dark .dashboard-mobile-plan a {
    color: var(--interactive-default, #43a79c) !important;
  }
  .dashboard-nav.is-open {
    width: 280px !important;
    max-width: 85vw !important;
  }
}

/* ==========================================================================
   MOBILE PHONE VIEW (max-width: 767px) — Figma Node 504:36262
   ========================================================================== */
@media (max-width: 767px) {
  .dashboard-topbar {
    padding: 0 16px !important;
  }
  .dashboard-content {
    padding: 16px !important;
  }
  .dashboard-product-identity {
    display: none !important;
  }
  .dashboard-mobile-org {
    width: 100% !important;
  }
  .dashboard-mobile-controls {
    display: flex !important;
  }
  .dashboard-search {
    display: none !important;
  }
  .dashboard-top-actions .dashboard-topbar-credits,
  .dashboard-top-actions > span {
    display: none !important;
  }
  .dashboard-top-actions .dashboard-topbar-help,
  .dashboard-top-actions > button[aria-label="Help"] {
    display: none !important;
  }
  .dashboard-heading {
    display: flex !important;
    flex-direction: column !important;
    gap: 16px !important;
    width: 100% !important;
  }
  .dashboard-heading > div:first-child h1 {
    font-size: 24px !important;
    line-height: 30px !important;
    letter-spacing: -0.36px !important;
  }
  .dashboard-create {
    display: flex !important;
    width: 100% !important;
    gap: 12px !important;
  }
  .dashboard-create :is(a, button) {
    flex: 1 1 !important;
    width: 100% !important;
    height: 40px !important;
  }
  .dashboard-periods {
    align-self: flex-start !important;
    justify-self: flex-start !important;
  }
  .dashboard-metrics {
    display: flex !important;
    flex-direction: column !important;
    gap: 16px !important;
    width: 100% !important;
  }
  .dashboard-metric {
    width: 100% !important;
  }
  .dashboard-sidebar-launcher {
    display: grid !important;
  }
}

@media (min-width: 768px) and (max-width: 1024px) {
  .dashboard-nav .dashboard-org-wrap {
    display: none !important;
  }
}

/* Content-aware loading states keep the dashboard shell and component geometry mounted. */
.dashboard-data-skeleton {
  pointer-events: none;
}
.dashboard-data-skeleton .app-skeleton {
  max-width: 100%;
}
.dashboard-metric.dashboard-data-skeleton {
  gap: var(--space-4, 16px);
}
.dashboard-metric.dashboard-data-skeleton > header {
  margin-bottom: var(--space-2, 8px);
}
.dashboard-metric.dashboard-data-skeleton > .app-skeleton {
  flex-shrink: 0;
}
.dashboard-metric.dashboard-data-skeleton > .app-skeleton:last-child {
  margin-top: auto;
}
.dashboard-metric.dashboard-data-skeleton .dashboard-metric-rows > div {
  gap: var(--space-2, 8px);
}
.dashboard-data-skeleton .dashboard-attention-context > .app-skeleton {
  flex-shrink: 0;
}
.dashboard-data-skeleton .dashboard-attention-context > div {
  flex: 1 1;
  grid-template-columns: minmax(0, 1fr);
  gap: var(--space-2, 8px);
}
.dashboard-table-row--loading {
  align-items: center;
  pointer-events: none;
}
.dashboard-table-row--loading .dashboard-invoice-info {
  display: grid;
  gap: 8px;
  width: 100%;
}
.dashboard-chart-skeleton {
  min-height: 286px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  gap: 20px;
}
.dashboard-chart-skeleton-bars {
  height: 220px;
  display: flex;
  align-items: flex-end;
  justify-content: space-around;
  gap: 12px;
  padding: 20px 20px 0;
  border-bottom: 1px solid var(--dash-border);
}
.dashboard-chart-skeleton-bars .app-skeleton {
  min-width: 20px;
}
@media (max-width: 767px) {
  .dashboard-chart-skeleton {
    min-height: 230px;
  }
  .dashboard-chart-skeleton-bars {
    height: 170px;
    padding-inline: 8px;
  }
  .dashboard-attention-row.dashboard-data-skeleton {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
  }
  .dashboard-attention-row.dashboard-data-skeleton > .app-skeleton:last-child {
    grid-column: 1/-1;
    width: 100% !important;
  }
}

/* ==========================================================================
   Desktop Collapsed Sidebar & Smooth Transition Styles (> 1024px)
   ========================================================================== */
.dashboard-nav {
  transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1),
    visibility 0.25s ease !important;
}
.dashboard-main,
.global-dashboard-layout,
.contacts-main,
.invoice-flow-main,
.invoice-register-main,
.quotation-main {
  transition: margin-left 0.25s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

@media (min-width: 1025px) {
  body.sidebar-collapsed .dashboard-nav {
    transform: translateX(-100%) !important;
    visibility: hidden !important;
    pointer-events: none !important;
  }
  body.sidebar-collapsed .dashboard-main,
  body.sidebar-collapsed .global-dashboard-layout,
  body.sidebar-collapsed .contacts-main,
  body.sidebar-collapsed .invoice-flow-main,
  body.sidebar-collapsed .invoice-register-main,
  body.sidebar-collapsed .quotation-main,
  body.sidebar-collapsed main {
    margin-left: 0 !important;
    width: 100% !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/layouts/businessUserDashboard/dashboard.css"],"names":[],"mappings":"AAAA;EACE,qCAAqC;EACrC,4CAA4C;EAC5C,mDAAmD;EACnD,kDAAkD;EAClD,4CAA4C;EAC5C,oDAAoD;EACpD,yCAAyC;EACzC,4CAA4C;EAC5C,iDAAiD;EACjD,mDAAmD;EACnD,4CAA4C;EAC5C,sDAAsD;EACtD,+BAA+B;EAC/B,8BAA8B;EAC9B,oBAAoB;EACpB,qBAAqB;EACrB,wBAAwB;EACxB,0BAA0B;EAC1B,uBAAuB;EACvB,0BAA0B;EAC1B,iBAAiB;EACjB,uBAAuB;EACvB,0BAA0B;EAC1B,6DAA6D;EAC7D,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,4BAA4B;EAC5B,sCAAsC;EACtC,0CAA0C;EAC1C,yCAAyC;EACzC,mCAAmC;EACnC,2CAA2C;EAC3C,gCAAgC;EAChC,mCAAmC;EACnC,wCAAwC;EACxC,0CAA0C;EAC1C,oCAAoC;EACpC,sCAAsC;EACtC,+CAA+C;AACjD;;AAEA;;;EAGE,sBAAsB;AACxB;AACA;;EAEE,cAAc;EACd,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,yBAAyB;EACzB,sBAAsB;EACtB,6BAA6B;EAC7B,oBAAoB;EACpB,qBAAqB;EACrB,oBAAoB;EACpB,qBAAqB;EACrB,0BAA0B;EAC1B,sBAAsB;EACtB,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,0CAA0C;EAC1C,+BAA+B;EAC/B,wEAAwE;EACxE,0BAA0B;EAC1B,8BAA8B;EAC9B,iCAAiC;EACjC,uBAAuB;AACzB;AACA;;;EAGE,sBAAsB;AACxB;AACA;EACE,6DAA6D;EAC7D,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,SAAS;EACT,uBAAuB;EACvB,UAAU;AACZ;AACA;EACE,6DAA6D;EAC7D,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,sCAAsC;EACtC,0CAA0C;EAC1C,yCAAyC;EACzC,mCAAmC;EACnC,2CAA2C;EAC3C,gCAAgC;EAChC,mCAAmC;EACnC,iCAAiC;EACjC,wCAAwC;EACxC,0CAA0C;EAC1C,oCAAoC;AACtC;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,cAAc;EACd,2CAA2C;AAC7C;AACA;;EAEE,wBAAwB;EACxB,8BAA8B;EAC9B,4BAA4B;EAC5B,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,2BAA2B;EAC3B,qBAAqB;EACrB,+CAA+C;EAC/C,8BAA8B;EAC9B,4CAA4C;EAC5C,mCAAmC;EACnC,0BAA0B;EAC1B,yBAAyB;EACzB;+BAC6B;AAC/B;AACA;;EAEE,4CAA4C;EAC5C,kDAAkD;EAClD,kCAAkC;AACpC;AACA;;EAEE,wDAAwD;EACxD,sDAAsD;EACtD,gDAAgD;AAClD;AACA;;EAEE,uDAAuD;EACvD,uDAAuD;EACvD,8CAA8C;AAChD;AACA;;EAEE,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,+BAA+B;EAC/B,6BAA6B;EAC7B,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,sBAAsB;EACtB,wCAAwC;EACxC,wEAAwE;EACxE,0BAA0B;EAC1B,2BAA2B;EAC3B,iCAAiC;EACjC,8BAA8B;EAC9B,yBAAyB;AAC3B;AACA;;EAEE,sBAAsB;EACtB,wCAAwC;AAC1C;AACA;EACE,wEAAwE;EACxE,0BAA0B;EAC1B,2BAA2B;EAC3B,8BAA8B;EAC9B,kCAAkC;EAClC,kCAAkC;EAClC,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,wBAAwB;EACxB,wBAAwB;EACxB,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,0DAA0D;EAC1D,8BAA8B;EAC9B,wDAAwD;EACxD,sBAAsB;EACtB,wEAAwE;EACxE,eAAe;EACf,0DAA0D;AAC5D;AACA;;EAEE,4DAA4D;AAC9D;AACA;EACE,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,wBAAwB;EACxB,8BAA8B;EAC9B,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,iCAAiC;EACjC,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,QAAQ;EACR,cAAc;EACd,aAAa;EACb,2CAA2C;EAC3C,gBAAgB;EAChB,2CAA2C;EAC3C,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,qDAAqD;EACrD,2CAA2C;AAC7C;AACA;;;;;EAKE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,QAAQ;EACR,+CAA+C;EAC/C,mBAAmB;EACnB,6CAA6C;AAC/C;AACA;EACE,aAAa;EACb,SAAO;EACP,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,SAAS;AACX;AACA;EACE,YAAY;EACZ,6CAA6C;AAC/C;AACA;EACE,YAAY;EACZ,eAAe;EACf,8BAA8B;EAC9B,sDAAsD;EACtD,2CAA2C;AAC7C;AACA;EACE,SAAS;AACX;AACA;EACE,aAAa;AACf;AACA;;;EAGE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,+CAA+C;EAC/C,mBAAmB;EACnB,2CAA2C;AAC7C;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,+CAA+C;EAC/C,mBAAmB;EACnB,2CAA2C;AAC7C;AACA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;IACZ,eAAe;EACjB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,0BAA0B;EAC5B;AACF;AACA;EACE,qDAAqD;EACrD,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,6BAA6B;EAC7B,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,0BAA0B;EAC1B,yBAAyB;EACzB,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,4DAA4D;EAC5D,8BAA8B;EAC9B,qDAAqD;EACrD,uDAAuD;EACvD,wEAAwE;EACxE,0BAA0B;EAC1B,2BAA2B;EAC3B,8BAA8B;EAC9B,4BAA4B;EAC5B,6BAA6B;EAC7B,2BAA2B;AAC7B;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,2CAA2C;AAC7C;AACA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,mBAAmB;EACnB,6BAA6B;EAC7B,2BAA2B;EAC3B,0DAA0D;EAC1D,8BAA8B;EAC9B,wDAAwD;EACxD,0BAA0B;EAC1B,2BAA2B;EAC3B,iCAAiC;AACnC;AACA;EACE,6BAA6B;EAC7B,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,0BAA0B;EAC1B,yBAAyB;EACzB,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,4DAA4D;EAC5D,8BAA8B;EAC9B,qDAAqD;EACrD,uDAAuD;EACvD,wEAAwE;EACxE,0BAA0B;EAC1B,2BAA2B;EAC3B,8BAA8B;EAC9B,2BAA2B;AAC7B;AACA;EACE,uBAAuB;EACvB,oBAAuB;EACvB,wBAAwB;EACxB,iCAAiC;EACjC,kCAAkC;EAClC,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;EACE,uBAAuB;EACvB,oBAAuB;EACvB,wBAAwB;EACxB,iCAAiC;EACjC,kCAAkC;EAClC,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;EACE,2BAA2B;EAC3B,wEAAwE;EACxE,0BAA0B;EAC1B,2BAA2B;EAC3B,8BAA8B;EAC9B,kCAAkC;EAClC,kCAAkC;EAClC,8BAA8B;EAC9B,8CAA8C;EAC9C,yBAAyB;AAC3B;AACA;EACE,2BAA2B;EAC3B,wEAAwE;EACxE,0BAA0B;EAC1B,2BAA2B;EAC3B,8BAA8B;EAC9B,kCAAkC;EAClC,kCAAkC;EAClC,8BAA8B;EAC9B,8CAA8C;EAC9C,yBAAyB;AAC3B;AACA;EACE,wEAAwE;EACxE,0BAA0B;EAC1B,2BAA2B;EAC3B,8BAA8B;EAC9B,iCAAiC;EACjC,gDAAgD;EAChD,8BAA8B;EAC9B,yBAAyB;EACzB,2BAA2B;EAC3B,kCAAkC;AACpC;AACA;EACE,wEAAwE;EACxE,0BAA0B;EAC1B,2BAA2B;EAC3B,8BAA8B;EAC9B,iCAAiC;EACjC,gDAAgD;EAChD,8BAA8B;EAC9B,yBAAyB;EACzB,2BAA2B;EAC3B,kCAAkC;AACpC;AACA;EACE,+CAA+C;EAC/C,0BAA0B;EAC1B,4BAA4B;AAC9B;AACA;;EAEE,0BAA0B;EAC1B,qDAAqD;AACvD;;AAEA,0EAA0E;AAC1E;;;;;;EAME,wDAAwD;EACxD,sDAAsD;AACxD;AACA;;;;;;EAME,4DAA4D;AAC9D;AACA;;;;;;EAME,+CAA+C;EAC/C,sDAAsD;EACtD,qDAAqD;AACvD;AACA;;;;;;EAME,8CAA8C;AAChD;AACA;;;;;;EAME,gDAAgD;AAClD;AACA;;;;;;EAME,qDAAqD;AACvD;;AAEA;EACE,eAAe;EACf,aAAa;EACb,SAAS;EACT,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,2CAA2C;EAC3C,mBAAmB;EACnB,+BAA+B;EAC/B;oCACkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,uBAAuB;EACvB,6DAA6D;EAC7D,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;;EAEE,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,SAAO;EACP,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,8CAA8C;EAC9C,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,UAAU;AACZ;AACA;EACE,6BAA6B;EAC7B,oCAAoC;AACtC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;;;EAGE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;EACtB,yDAAyD;AAC3D;AACA;;;EAGE,iCAAiC;AACnC;AACA;;EAEE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,wBAAwB;AAC1B;AACA;EACE,mCAAmC;EACnC,6CAA6C;EAC7C,gBAAgB;AAClB;AACA;EACE,mCAAmC;AACrC;AACA;;;;;;EAME,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,sBAAsB;EACtB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;AACA;;;EAGE,yBAAyB;EACzB,yBAAyB;EACzB,uBAAuB;EACvB,sBAAsB;EACtB,0BAA0B;EAC1B,uBAAuB;EACvB,4BAA4B;EAC5B,2BAA2B;EAC3B,yBAAyB;EACzB,8CAA8C;EAC9C,8BAA8B;EAC9B,wEAAwE;EACxE,0BAA0B;EAC1B,2BAA2B;EAC3B,6BAA6B;EAC7B,8BAA8B;EAC9B,6BAA6B;EAC7B,+BAA+B;EAC/B,8BAA8B;EAC9B,kCAAkC;EAClC,iCAAiC;EACjC,8BAA8B;AAChC;AACA;;EAEE,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,gCAAgC;EAChC,cAAc;AAChB;AACA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,iCAAiC;EACjC,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;AAC3B;AACA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,2BAA2B;AAC7B;AACA;;;EAGE,aAAa;EACb,8BAA8B;EAC9B,eAAe;AACjB;AACA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,8BAA8B;AAChC;AACA;EACE,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE;IACE,kBAAkB;IAClB,WAAW;EACb;AACF;AACA;EACE;IACE,yBAAyB;IACzB,sBAAsB;EACxB;AACF;AACA;EACE,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,2CAA2C;EAC3C,+BAA+B;AACjC;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,oCAAoC;EACpC,mBAAmB;EACnB,iCAAiC;AACnC;AACA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,cAAc;AAChB;AACA;EACE,WAAW;EACX,SAAS;EACT,UAAU;EACV,uBAAuB;EACvB,6DAA6D;EAC7D,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;;EAEE,YAAY;EACZ,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,oDAAoD;EACpD,oBAAoB;EACpB,6DAA6D;EAC7D,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,uBAAuB;EACvB,sBAAsB;AACxB;AACA;;EAEE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,eAAe;AACjB;AACA;;EAEE,iCAAiC;AACnC;AACA;;;EAGE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,sCAAsC;EACtC,kBAAkB;EAClB,WAAW;EACX,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,WAAW;EACX,qCAAqC;EACrC,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,QAAQ;EACR,oCAAoC;EACpC,mBAAmB;EACnB,+BAA+B;EAC/B,6CAA6C;AAC/C;AACA;EACE,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,iCAAiC;AACnC;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,sBAAsB;EACtB,wBAAwB;EACxB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,aAAa;EACb,+BAA+B;EAC/B,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,iCAAiC;AACnC;AACA;EACE,mBAAmB;EACnB,+CAA+C;EAC/C,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,SAAS;EACT,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE,wBAAwB;EACxB,+BAA+B;EAC/B,wCAAwC;AAC1C;AACA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,SAAS;EACT,aAAa;EACb,aAAa;EACb,SAAS;AACX;AACA;EACE,aAAa;EACb,+BAA+B;EAC/B,SAAS;AACX;AACA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;AACA;;EAEE,SAAS;EACT,wBAAwB;AAC1B;AACA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,aAAa;EACb,eAAe;AACjB;AACA;EACE,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,2CAA2C;EAC3C,mBAAmB;EACnB,+BAA+B;EAC/B,6DAA6D;EAC7D,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,aAAa;AACf;AACA;;EAEE,WAAW;EACX,+BAA+B;EAC/B,6BAA6B;AAC/B;AACA;;EAEE,cAAc;AAChB;AACA;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,QAAQ;EACR,uBAAuB;EACvB,UAAU;AACZ;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,qCAAqC;EACrC,uBAAuB;EACvB,iCAAiC;EACjC,6DAA6D;EAC7D,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,yDAAyD;AAC3D;AACA;EACE,gCAAgC;EAChC,0CAA0C;AAC5C;AACA;EACE,gDAAgD;EAChD,0CAA0C;AAC5C;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,qCAAqC;AACvC;AACA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;EACpC,mBAAmB;EACnB,+BAA+B;AACjC;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,wBAAwB;AAC1B;AACA;EACE,SAAS;EACT,sEAAsE;EACtE,uBAAuB;EACvB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,mFAAmF;EACnF,iBAAiB;EACjB,kCAAkC;EAClC,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,sEAAsE;EACtE,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,sEAAsE;EACtE,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,sEAAsE;EACtE,iBAAiB;EACjB,kCAAkC;EAClC,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,oCAAoC;EACpC,sEAAsE;EACtE,uBAAuB;AACzB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,4CAA4C;AAC9C;AACA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,eAAe;EACf,eAAe;EACf,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,iDAAiD;EACjD,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,2CAA2C;AAC7C;AACA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,aAAa;AACf;AACA;;EAEE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2CAA2C;EAC3C,qCAAqC;EACrC,iCAAiC;EACjC,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,SAAS;EACT,6BAA6B;AAC/B;AACA;EACE,0CAA0C;EAC1C,gDAAgD;EAChD,gCAAgC;AAClC;AACA;EACE,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,6DAA6D;EAC7D,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;;EAEE,uCAAuC;EACvC,kCAAkC;AACpC;AACA;;;;EAIE,wCAAwC;EACxC,mCAAmC;AACrC;AACA;;EAEE,qCAAqC;EACrC,gCAAgC;AAClC;AACA;;EAEE,wCAAwC;EACxC,mCAAmC;AACrC;AACA;;EAEE,4CAA4C;EAC5C,0CAA0C;AAC5C;AACA;;EAEE,4CAA4C;EAC5C,mCAAmC;AACrC;AACA;;;;EAIE,uCAAuC;EACvC,kCAAkC;AACpC;AACA;;;;;;;;EAQE,wCAAwC;EACxC,mCAAmC;AACrC;AACA;;;;EAIE,qCAAqC;EACrC,gCAAgC;AAClC;AACA;;;;EAIE,wCAAwC;EACxC,mCAAmC;AACrC;AACA;;;;EAIE,4CAA4C;EAC5C,0CAA0C;AAC5C;AACA;;;;EAIE,4CAA4C;EAC5C,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;AACA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,WAAW;EACX,aAAa;AACf;AACA;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,+CAA+C;EAC/C,eAAe;EACf,iBAAiB;EACjB,oCAAoC;EACpC,mBAAmB;AACrB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,SAAO;EACP,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,aAAa;AACf;AACA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;AACA;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,QAAQ;EACR,mDAAmD;AACrD;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,+CAA+C;EAC/C,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,iCAAiC;EACjC,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,6DAA6D;EAC7D,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,oCAAoC;EACpC,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,oCAAoC;AACtC;;AAEA;EACE,SAAO;EACP,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,aAAa;AACf;AACA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;AACA;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,qBAAqB;EACrB,QAAQ;EACR,mDAAmD;AACrD;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,eAAe;AACjB;AACA;EACE,+CAA+C;EAC/C,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,6DAA6D;EAC7D,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,iCAAiC;EACjC,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,6DAA6D;EAC7D,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,iCAAiC;EACjC,SAAS;EACT,WAAW;AACb;AACA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,eAAe;EACf,eAAe;EACf,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;AACvC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,iBAAiB;EACjB,aAAa;EACb;;;8CAG4C;EAC5C,mBAAmB;EACnB,MAAM;AACR;AACA;EACE,YAAY;EACZ,wBAAwB;EACxB,iCAAiC;EACjC,2CAA2C;EAC3C,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;;EAEE,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,2CAA2C;AAC7C;AACA;EACE,eAAe;AACjB;AACA;EACE,iCAAiC;AACnC;AACA;EACE,mCAAmC;EACnC,oBAAoB;AACtB;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,wBAAwB;EACxB,eAAe;EACf,kBAAkB;EAClB,2CAA2C;AAC7C;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,+CAA+C;EAC/C,eAAe;EACf,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;EACzB,gCAAgC;AAClC;AACA;EACE,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;;;EAGE,cAAc;EACd,eAAe;EACf,wBAAwB;EACxB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;;EAEE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,0CAA0C;EAC1C,4CAA4C;AAC9C;AACA;;;;EAIE,qCAAqC;EACrC,4CAA4C;AAC9C;AACA;EACE,mCAAmC;EACnC,wCAAwC;AAC1C;AACA;EACE,kCAAkC;EAClC,uCAAuC;AACzC;AACA;EACE,mCAAmC;EACnC,wCAAwC;AAC1C;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,+CAA+C;EAC/C,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,+CAA+C;EAC/C,eAAe;EACf,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,eAAe;EACf,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,oCAAoC;AACtC;AACA;;EAEE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;EACvB,wBAAwB;EACxB,wBAAwB;EACxB,qEAAqE;EACrE,SAAS;EACT,UAAU;EACV,SAAS;EACT,UAAU;EACV,oBAAoB;EACpB,sDAAsD;EACtD,aAAa;AACf;AACA;EACE;IACE,qBAAqB;IACrB,+BAA+B;IAC/B,yBAAyB;EAC3B;AACF;AACA;EACE;;IAEE,wBAAwB;IACxB,qBAAqB;IACrB,+BAA+B;IAC/B,6BAA6B;EAC/B;AACF;AACA;;;EAGE,0CAA0C;AAC5C;;AAEA;EACE;IACE,wBAAwB;IACxB,0BAA0B;IAC1B,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;IAClB,uBAAuB;IACvB,0BAA0B;IAC1B,wBAAwB;IACxB,uCAAuC;IACvC;sCACkC;IAClC,6BAA6B;IAC7B,2BAA2B;IAC3B,qDAAqD;IACrD,0CAA0C;IAC1C,2BAA2B;EAC7B;EACA;IACE,mCAAmC;IACnC,8BAA8B;IAC9B,wDAAwD;EAC1D;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;IACvB,2BAA2B;IAC3B,2BAA2B;IAC3B,wBAAwB;IACxB,wBAAwB;IACxB,8BAA8B;IAC9B,yCAAyC;IACzC,sDAAsD;IACtD,qDAAqD;IACrD,iCAAiC;IACjC,yBAAyB;IACzB,yBAAyB;EAC3B;EACA;;IAEE,wBAAwB;IACxB,8BAA8B;IAC9B,4BAA4B;IAC5B,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,2BAA2B;IAC3B,qBAAqB;IACrB,+CAA+C;IAC/C,8BAA8B;IAC9B,4CAA4C;IAC5C,mCAAmC;IACnC,0BAA0B;IAC1B,yBAAyB;IACzB;iCAC6B;EAC/B;EACA;;IAEE,4CAA4C;IAC5C,kDAAkD;IAClD,kCAAkC;EACpC;EACA;;IAEE,wDAAwD;IACxD,sDAAsD;IACtD,gDAAgD;EAClD;EACA;;IAEE,uDAAuD;IACvD,uDAAuD;IACvD,8CAA8C;EAChD;EACA;;IAEE,sBAAsB;IACtB,uBAAuB;IACvB,yBAAyB;IACzB,+BAA+B;IAC/B,6BAA6B;IAC7B,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,eAAe;IACf,WAAW;IACX,UAAU;IACV,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,6CAA6C;IAC7C,mBAAmB;IACnB,gCAAgC;IAChC,qCAAqC;IACrC,0CAA0C;EAC5C;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;IACb,SAAS;EACX;EACA;IACE,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,oCAAoC;IACpC,mBAAmB;IACnB,iCAAiC;IACjC,uBAAuB;EACzB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,YAAY;IACZ,eAAe;IACf,2CAA2C;EAC7C;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;EACA;IACE,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;EACzB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,YAAY;IACZ,QAAQ;EACV;EACA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,2CAA2C;IAC3C,oBAAoB;IACpB,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,aAAa;IACb,SAAS;IACT,aAAa;IACb,sBAAsB;EACxB;;EAEA;;;;;;;;GAQC;EACD;IACE,QAAQ;IACR,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,WAAW;EACb;EACA;IACE,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,8BAA8B;EAChC;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;EACV;EACA;IACE,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,oCAAoC;IACpC,mBAAmB;IACnB,iCAAiC;IACjC,uBAAuB;IACvB,eAAe;EACjB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,6DAA6D;IAC7D,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,oCAAoC;IACpC,qCAAqC;IACrC,+BAA+B;IAC/B,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,WAAW;IACX,YAAY;IACZ,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,sCAAsC;IACtC,kBAAkB;IAClB,wBAAwB;IACxB,kCAAkC;IAClC,6DAA6D;IAC7D,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,YAAY;IACZ,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,QAAQ;EACV;EACA;IACE,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;IACvB,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB;IACtB,wBAAwB;IACxB,mBAAmB;EACrB;EACA;;IAEE,WAAW;IACX,YAAY;IACZ,UAAU;IACV,iBAAiB;IACjB,qDAAqD;IACrD,eAAe;EACjB;EACA;IACE,+BAA+B;IAC/B,gCAAgC;EAClC;EACA;IACE,gCAAgC;IAChC,wBAAwB;IACxB,kCAAkC;EACpC;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;;IAEE,qDAAqD;EACvD;;EAEA,qDAAqD;EACrD;IACE,WAAW;IACX,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;IACnB,2CAA2C;IAC3C,gCAAgC;EAClC;EACA;IACE,YAAY;IACZ,eAAe;IACf,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,qCAAqC;IACrC,6DAA6D;IAC7D,eAAe;IACf,gBAAgB;IAChB,gCAAgC;IAChC,mBAAmB;IACnB,qBAAqB;IACrB,uBAAuB;IACvB,yDAAyD;EAC3D;EACA;IACE,0CAA0C;IAC1C,wCAAwC;EAC1C;EACA;IACE,gDAAgD;EAClD;EACA;IACE,gCAAgC;EAClC;EACA;IACE,qCAAqC;IACrC,wCAAwC;EAC1C;;EAEA,qCAAqC;EACrC;IACE,QAAQ;IACR,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,WAAW;EACb;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;IACvB,uBAAuB;IACvB,SAAS;EACX;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,wBAAwB;IACxB,eAAe;EACjB;EACA;IACE,aAAa;IACb,SAAS;IACT,WAAW;EACb;EACA;IACE,SAAO;IACP,YAAY;IACZ,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,qCAAqC;IACrC,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,qBAAqB;IACrB,0CAA0C;IAC1C,oDAAoD;IACpD,gCAAgC;EAClC;EACA;IACE,sCAAsC;IACtC,SAAS;IACT,cAAc;EAChB;EACA;IACE,0CAA0C;IAC1C,gDAAgD;IAChD,gCAAgC;EAClC;EACA;IACE,sCAAsC;IACtC,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,WAAW;EACb;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;EACzB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,uBAAkB;IAAlB,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,QAAQ;IACR,qBAAqB;IACrB,sBAAsB;IACtB,wBAAwB;IACxB,UAAU;IACV,SAAS;IACT,uBAAuB;EACzB;EACA;IACE,YAAY;IACZ,iBAAiB;IACjB,qCAAqC;IACrC,6DAA6D;IAC7D,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,uBAAuB;IACvB,iCAAiC;IACjC,eAAe;IACf,yDAAyD;IACzD,mBAAmB;EACrB;EACA;IACE,gCAAgC;IAChC,0CAA0C;EAC5C;EACA;IACE,gDAAgD;IAChD,0CAA0C;EAC5C;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,gCAAgC;IAChC,qCAAqC;EACvC;EACA;;IAEE,mCAAmC;IACnC,cAAc;EAChB;;EAEA,+CAA+C;EAC/C;IACE,QAAQ;IACR,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,WAAW;EACb;EACA;;IAEE,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,qCAAqC;IACrC,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,oCAAoC;IACpC,+BAA+B;EACjC;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;EACb;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;IACvB,SAAS;EACX;EACA;IACE,WAAW;IACX,YAAY;IACZ,iCAAiC;EACnC;EACA;;IAEE,iCAAiC;EACnC;EACA;IACE,+CAA+C;IAC/C,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,uBAAuB;IACvB,SAAS;EACX;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,wBAAwB;IACxB,SAAS;EACX;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,WAAW;IACX,SAAS;EACX;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;IACR,WAAW;IACX,UAAU;IACV,SAAS;EACX;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,wBAAwB;EAC1B;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,aAAa;IACb,uBAAuB;IACvB,QAAQ;IACR,WAAW;IACX,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,oCAAoC;EACtC;EACA;IACE,WAAW;IACX,YAAY;IACZ,cAAc;IACd,eAAe;IACf,oCAAoC;EACtC;;EAEA,6CAA6C;EAC7C;IACE,QAAQ;IACR,aAAa;IACb,qCAAqC;IACrC,oCAAoC;IACpC,+BAA+B;EACjC;EACA;IACE,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;IACvB,SAAS;EACX;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,wBAAwB;IACxB,eAAe;EACjB;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;IACT,oBAAoB;IACpB,wCAAwC;IACxC,WAAW;EACb;EACA;IACE,iBAAiB;EACnB;EACA;IACE,aAAa;IACb,uBAAuB;IACvB,QAAQ;IACR,WAAW;EACb;EACA;IACE,WAAW;IACX,YAAY;IACZ,cAAc;IACd,uBAAuB;EACzB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;EACzB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,uBAAuB;IACvB,SAAS;IACT,WAAW;EACb;EACA;IACE,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,qCAAqC;IACrC,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,0CAA0C;IAC1C,oDAAoD;IACpD,gCAAgC;EAClC;EACA;IACE,sCAAsC;IACtC,SAAS;IACT,cAAc;EAChB;EACA;IACE,0CAA0C;IAC1C,gDAAgD;IAChD,gCAAgC;EAClC;EACA;IACE,sCAAsC;IACtC,cAAc;EAChB;;EAEA,6CAA6C;EAC7C;IACE,QAAQ;IACR,qCAAqC;IACrC,oCAAoC;IACpC,+BAA+B;IAC/B,kDAAkD;EACpD;EACA;IACE,aAAa;IACb,YAAY;IACZ,uBAAuB;EACzB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;IACvB,SAAS;EACX;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,oCAAoC;IACpC,eAAe;EACjB;EACA;IACE,YAAY;IACZ,eAAe;IACf,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,gCAAgC;IAChC,qCAAqC;IACrC,mBAAmB;EACrB;EACA;IACE,UAAU;EACZ;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;IACb,0CAA0C;IAC1C;;;;;sBAKkB;IAClB,mBAAmB;IACnB,aAAa;IACb,wCAAwC;IACxC,gBAAgB;IAChB,YAAY;IACZ,QAAQ;IACR,WAAW;EACb;EACA;IACE,kBAAkB;IAClB,+CAA+C;IAC/C,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB;IACtB,yBAAyB;IACzB,uBAAuB;IACvB,UAAU;EACZ;EACA;IACE,gCAAgC;EAClC;EACA;IACE,mBAAmB;IACnB,6DAA6D;IAC7D,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,UAAU;EACZ;EACA;IACE,eAAe;EACjB;EACA;IACE,uBAAuB;IACvB,UAAU;IACV,wBAAwB;IACxB,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,cAAc;IACd,6DAA6D;IAC7D,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,wBAAwB;IACxB,UAAU;IACV,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,oBAAoB;IACpB,iBAAiB;IACjB,UAAU;EACZ;EACA;IACE,kBAAkB;IAClB,UAAU;EACZ;EACA;IACE,iBAAiB;IACjB,+CAA+C;IAC/C,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,gBAAgB;EAClB;EACA;IACE,iBAAiB;IACjB,wBAAwB;IACxB,6DAA6D;IAC7D,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,UAAU;IACV,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,cAAc;EAChB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,wCAAwC;IACxC,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,oCAAoC;EACtC;;EAEA,wDAAwD;EACxD;IACE,QAAQ;IACR,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,WAAW;EACb;EACA;IACE,gBAAgB;IAChB,aAAa;IACb,qCAAqC;IACrC,oCAAoC;IACpC,+BAA+B;EACjC;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;IACvB,SAAS;EACX;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,wBAAwB;IACxB,eAAe;EACjB;EACA;IACE,SAAS;EACX;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,aAAa;IACb,eAAe;EACjB;EACA;;IAEE,aAAa;EACf;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA,mDAAmD;EACnD;IACE,QAAQ;IACR,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,YAAY;IACZ,aAAa;IACb,oCAAoC;IACpC,qCAAqC;IACrC,+BAA+B;IAC/B,WAAW;EACb;EACA;IACE,+CAA+C;IAC/C,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB;IACtB,yBAAyB;IACzB,uBAAuB;EACzB;EACA;IACE,6DAA6D;IAC7D,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,wBAAwB;EAC1B;EACA;IACE,YAAY;IACZ,eAAe;IACf,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,qCAAqC;IACrC,6DAA6D;IAC7D,eAAe;IACf,gBAAgB;IAChB,gCAAgC;IAChC,qBAAqB;IACrB,yDAAyD;EAC3D;EACA;IACE,0CAA0C;IAC1C,wCAAwC;EAC1C;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,qCAAqC;EACvC;EACA;;;;IAIE,0CAA0C;IAC1C,gCAAgC;EAClC;AACF;;AAEA;;+EAE+E;AAC/E;EACE;;;;;IAKE,wBAAwB;EAC1B;EACA;;IAEE,wBAAwB;EAC1B;EACA;;;;IAIE,wBAAwB;EAC1B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,wBAAwB;IACxB,2BAA2B;IAC3B,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,8BAA8B;IAC9B,mBAAmB;IACnB,+CAA+C;IAC/C,8BAA8B;IAC9B,4CAA4C;EAC9C;EACA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,+CAA+C;IAC/C,cAAc;EAChB;EACA;IACE,wEAAwE;IACxE,0BAA0B;IAC1B,oBAAoB;IACpB,qBAAqB;IACrB,kCAAkC;IAClC,kCAAkC;IAClC,sBAAsB;EACxB;EACA;IACE,+CAA+C;EACjD;EACA;IACE,wBAAwB;IACxB,8BAA8B;IAC9B,oBAAoB;EACtB;EACA;;IAEE,+BAA+B;IAC/B,uBAAuB;IACvB,iCAAiC;IACjC,8BAA8B;IAC9B,mBAAmB;IACnB,2DAA2D;IAC3D,+BAA+B;IAC/B,wEAAwE;IACxE,0BAA0B;IAC1B,2BAA2B;IAC3B,8CAA8C;IAC9C,8BAA8B;IAC9B,kCAAkC;EACpC;EACA;;IAEE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;;IAEE,2DAA2D;IAC3D,2CAA2C;EAC7C;EACA;;IAEE,wBAAwB;IACxB,sBAAsB;IACtB,uBAAuB;IACvB,8BAA8B;IAC9B,8BAA8B;IAC9B,oBAAoB;IACpB,kCAAkC;IAClC,0BAA0B;EAC5B;EACA;;IAEE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,wBAAwB;IACxB,sBAAsB;IACtB,uBAAuB;IACvB,8BAA8B;IAC9B,8BAA8B;IAC9B,kCAAkC;EACpC;EACA;IACE,wBAAwB;IACxB,oBAAoB;EACtB;EACA;IACE,wBAAwB;IACxB,iCAAiC;IACjC,oBAAoB;IACpB,sBAAsB;EACxB;EACA;IACE,wBAAwB;IACxB,8BAA8B;IAC9B,yCAAyC;IACzC,sBAAsB;EACxB;EACA;IACE,wBAAwB;IACxB,8BAA8B;IAC9B,mBAAmB;EACrB;EACA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,wBAAwB;IACxB,8BAA8B;IAC9B,0DAA0D;IAC1D,8BAA8B;IAC9B,wDAAwD;IACxD,2CAA2C;IAC3C,0BAA0B;IAC1B,qBAAqB;EACvB;EACA;IACE,qDAAqD;IACrD,oDAAoD;IACpD,2CAA2C;EAC7C;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,wEAAwE;IACxE,0BAA0B;IAC1B,2BAA2B;IAC3B,8BAA8B;IAC9B,kCAAkC;IAClC,gDAAgD;IAChD,8BAA8B;EAChC;EACA;IACE,4CAA4C;EAC9C;EACA;IACE,uBAAuB;IACvB,uBAAuB;IACvB,wBAAwB;IACxB,wBAAwB;IACxB,8BAA8B;IAC9B,mBAAmB;IACnB,0DAA0D;IAC1D,8BAA8B;IAC9B,sDAAsD;IACtD,0BAA0B;IAC1B,qBAAqB;IACrB,iCAAiC;EACnC;EACA;IACE,mDAAmD;IACnD,oDAAoD;EACtD;EACA;;IAEE,sBAAsB;IACtB,uBAAuB;IACvB,4BAA4B;IAC5B,qDAAqD;IACrD,0BAA0B;IAC1B,yBAAyB;EAC3B;EACA;;IAEE,qDAAqD;EACvD;EACA;IACE,wBAAwB;IACxB,8BAA8B;IAC9B,mBAAmB;IACnB,8BAA8B;IAC9B,iEAAiE;IACjE,sBAAsB;EACxB;EACA;IACE,uBAAuB;IACvB,0BAA0B;IAC1B,8BAA8B;IAC9B,wEAAwE;IACxE,0BAA0B;IAC1B,2BAA2B;IAC3B,2CAA2C;IAC3C,8BAA8B;IAC9B,+BAA+B;IAC/B,8BAA8B;IAC9B,kCAAkC;EACpC;EACA;IACE,wBAAwB;IACxB,0CAA0C;IAC1C,yBAAyB;IACzB,sBAAsB;IACtB,8BAA8B;EAChC;EACA;IACE,yBAAyB;IACzB,sBAAsB;IACtB,wBAAwB;IACxB,iCAAiC;IACjC,mBAAmB;EACrB;EACA;IACE,0BAA0B;IAC1B,4BAA4B;IAC5B,2BAA2B;IAC3B,kCAAkC;IAClC,oBAAoB;IACpB,kCAAkC;EACpC;EACA;IACE,0BAA0B;IAC1B,8BAA8B;IAC9B,4BAA4B;IAC5B,oBAAoB;IACpB,mCAAmC;EACrC;EACA;IACE,yBAAyB;IACzB,sBAAsB;IACtB,wBAAwB;IACxB,8BAA8B;IAC9B,oBAAoB;IACpB,sBAAsB;IACtB,oCAAoC;IACpC,8BAA8B;EAChC;EACA;IACE,sBAAsB;IACtB,qBAAqB;IACrB,uBAAuB;IACvB,0BAA0B;IAC1B,8BAA8B;IAC9B,wEAAwE;IACxE,0BAA0B;IAC1B,2BAA2B;IAC3B,8BAA8B;IAC9B,+BAA+B;IAC/B,8BAA8B;IAC9B,kCAAkC;EACpC;EACA;IACE,sDAAsD;IACtD,2DAA2D;IAC3D,8CAA8C;EAChD;EACA;IACE,0DAA0D;IAC1D,oBAAoB;IACpB,yBAAyB;EAC3B;EACA;IACE,qDAAqD;IACrD,2DAA2D;IAC3D,2CAA2C;EAC7C;EACA;IACE,0DAA0D;IAC1D,yBAAyB;EAC3B;EACA;IACE,yBAAyB;IACzB,sBAAsB;IACtB,wBAAwB;IACxB,iCAAiC;IACjC,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,0BAA0B;IAC1B,2BAA2B;IAC3B,8BAA8B;IAC9B,kCAAkC;IAClC,kCAAkC;EACpC;EACA;IACE,0BAA0B;IAC1B,2BAA2B;IAC3B,8BAA8B;IAC9B,kCAAkC;IAClC,mCAAmC;EACrC;EACA;IACE,yBAAyB;IACzB,sBAAsB;IACtB,6BAA6B;IAC7B,4BAA4B;IAC5B,wBAAwB;IACxB,mBAAmB;IACnB,sBAAsB;IACtB,kCAAkC;IAClC,qBAAqB;EACvB;EACA;IACE,uBAAuB;IACvB,4BAA4B;IAC5B,8BAA8B;IAC9B,0BAA0B;IAC1B,2BAA2B;IAC3B,8BAA8B;IAC9B,kCAAkC;EACpC;EACA;IACE,wBAAwB;IACxB,gDAAgD;IAChD,oBAAoB;IACpB,sBAAsB;EACxB;EACA;IACE,yBAAyB;IACzB,sBAAsB;EACxB;EACA;IACE,yBAAyB;IACzB,sBAAsB;EACxB;EACA;IACE,8BAA8B;IAC9B,sBAAsB;EACxB;EACA;IACE,wBAAwB;IACxB,0CAA0C;IAC1C,wCAAwC;IACxC,wBAAwB;IACxB,8BAA8B;IAC9B,0BAA0B;EAC5B;EACA;IACE,yBAAyB;IACzB,+BAA+B;EACjC;EACA;IACE,yBAAyB;IACzB,sBAAsB;IACtB,4BAA4B;IAC5B,oBAAoB;EACtB;EACA;IACE,yBAAyB;IACzB,sBAAsB;IACtB,4BAA4B;IAC5B,sBAAsB;IACtB,2BAA2B;IAC3B,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,wBAAwB;IACxB,8BAA8B;IAC9B,8BAA8B;IAC9B,yCAAyC;IACzC,6BAA6B;IAC7B,8BAA8B;IAC9B,wDAAwD;IACxD,0DAA0D;IAC1D,uBAAuB;IACvB,sBAAsB;IACtB,iCAAiC;EACnC;EACA;IACE,wEAAwE;IACxE,0BAA0B;IAC1B,2BAA2B;IAC3B,oCAAoC;IACpC,8CAA8C;EAChD;EACA;IACE,wEAAwE;IACxE,0BAA0B;IAC1B,2BAA2B;IAC3B,gDAAgD;EAClD;EACA;IACE,wEAAwE;IACxE,0BAA0B;IAC1B,2BAA2B;IAC3B,qDAAqD;IACrD,gCAAgC;EAClC;EACA;IACE,qDAAqD;IACrD,oDAAoD;EACtD;EACA;IACE,2CAA2C;EAC7C;EACA;IACE,4CAA4C;EAC9C;EACA;IACE,qDAAqD;EACvD;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;AACF;;AAEA;;+EAE+E;AAC/E;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;;IAEE,wBAAwB;EAC1B;EACA;;IAEE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;IACxB,iCAAiC;IACjC,oBAAoB;IACpB,sBAAsB;EACxB;EACA;IACE,0BAA0B;IAC1B,4BAA4B;IAC5B,kCAAkC;EACpC;EACA;IACE,wBAAwB;IACxB,sBAAsB;IACtB,oBAAoB;EACtB;EACA;IACE,oBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,iCAAiC;IACjC,mCAAmC;EACrC;EACA;IACE,wBAAwB;IACxB,iCAAiC;IACjC,oBAAoB;IACpB,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA,0FAA0F;AAC1F;EACE,oBAAoB;AACtB;AACA;EACE,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kCAAkC;AACpC;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,cAAc;AAChB;AACA;EACE,SAAO;EACP,qCAAqC;EACrC,wBAAwB;AAC1B;AACA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,QAAQ;EACR,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,SAAS;AACX;AACA;EACE,aAAa;EACb,aAAa;EACb,qBAAqB;EACrB,6BAA6B;EAC7B,SAAS;EACT,oBAAoB;EACpB,2CAA2C;AAC7C;AACA;EACE,eAAe;AACjB;AACA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,0CAA0C;EAC5C;EACA;IACE,iBAAiB;IACjB,sBAAsB;EACxB;AACF;;AAEA;;+EAE+E;AAC/E;EACE;oCACkC;AACpC;AACA;;;;;;EAME,qEAAqE;AACvE;;AAEA;EACE;IACE,uCAAuC;IACvC,6BAA6B;IAC7B,+BAA+B;EACjC;EACA;;;;;;;IAOE,yBAAyB;IACzB,sBAAsB;EACxB;AACF","sourcesContent":[".business-dashboard {\n  --dash-bg: var(--bg-primary, #f4f7f7);\n  --dash-surface: var(--surface-primary, #fff);\n  --dash-surface-2: var(--surface-secondary, #f4f7f7);\n  --dash-surface-3: var(--surface-tertiary, #e8edec);\n  --dash-border: var(--border-subtle, #dce3e2);\n  --dash-border-strong: var(--border-default, #cdd6d4);\n  --dash-text: var(--text-primary, #142624);\n  --dash-muted: var(--text-secondary, #506360);\n  --dash-brand: var(--interactive-default, #0f766e);\n  --dash-brand-soft: var(--interactive-soft, #f0f8f7);\n  --dash-danger: var(--money-overdue, #c23a2b);\n  --dash-danger-soft: var(--money-overdue-soft, #fef2f1);\n  --interactive-selected: #dcefec;\n  --interactive-pressed: #0a4a46;\n  --text-link: #0f766e;\n  --chart-grid: #dce3e2;\n  --chart-primary: #0f766e;\n  --chart-secondary: #aebab8;\n  --chart-danger: #e04434;\n  --warning-default: #b7701a;\n  min-height: 100vh;\n  color: var(--dash-text);\n  background: var(--dash-bg);\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif);\n  font-size: 13px;\n  line-height: 1.4;\n}\n\n.business-dashboard.dark,\n.business-dashboard[data-theme=\"dark\"] {\n  --dash-bg: var(--bg-primary);\n  --dash-surface: var(--surface-primary);\n  --dash-surface-2: var(--surface-secondary);\n  --dash-surface-3: var(--surface-tertiary);\n  --dash-border: var(--border-subtle);\n  --dash-border-strong: var(--border-default);\n  --dash-text: var(--text-primary);\n  --dash-muted: var(--text-secondary);\n  --dash-brand: var(--interactive-default);\n  --dash-brand-soft: var(--interactive-soft);\n  --dash-danger: var(--danger-default);\n  --dash-danger-soft: var(--danger-soft);\n  --interactive-pressed: var(--interactive-hover);\n}\n\n.business-dashboard *,\n.business-dashboard *::before,\n.business-dashboard *::after {\n  box-sizing: border-box;\n}\n.business-dashboard button,\n.business-dashboard input {\n  color: inherit;\n  font: inherit;\n}\n.business-dashboard button {\n  cursor: pointer;\n}\n.business-dashboard a {\n  color: inherit;\n  text-decoration: none;\n}\n\n.dashboard-nav {\n  --dash-surface: #fff;\n  --dash-surface-2: #f4f7f7;\n  --dash-surface-3: #e8edec;\n  --dash-border: #dce3e2;\n  --dash-border-strong: #cdd6d4;\n  --dash-text: #142624;\n  --dash-muted: #506360;\n  --dash-lock: #6b7b78;\n  --dash-brand: #0f766e;\n  --dash-brand-soft: #f0f8f7;\n  --dash-danger: #c23a2b;\n  --text-link: #0f766e;\n  position: fixed;\n  inset: 0 auto 0 0;\n  z-index: 9999;\n  width: 256px;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  border-right: 1px solid var(--dash-border);\n  background: var(--dash-surface);\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif) !important;\n  font-size: 13px !important;\n  line-height: normal !important;\n  box-sizing: border-box !important;\n  color: var(--dash-text);\n}\n.dashboard-nav *,\n.dashboard-nav *::before,\n.dashboard-nav *::after {\n  box-sizing: border-box;\n}\n.dashboard-nav button {\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif);\n  color: inherit;\n  font-size: inherit;\n  cursor: pointer;\n  border: 0;\n  background: transparent;\n  padding: 0;\n}\n.dashboard-nav a {\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif);\n  color: inherit;\n  text-decoration: none;\n}\n.dashboard-nav.dark {\n  --dash-surface: var(--surface-primary);\n  --dash-surface-2: var(--surface-secondary);\n  --dash-surface-3: var(--surface-tertiary);\n  --dash-border: var(--border-subtle);\n  --dash-border-strong: var(--border-default);\n  --dash-text: var(--text-primary);\n  --dash-muted: var(--text-secondary);\n  --dash-lock: var(--text-tertiary);\n  --dash-brand: var(--interactive-default);\n  --dash-brand-soft: var(--interactive-soft);\n  --dash-danger: var(--danger-default);\n}\n.dashboard-nav-brand {\n  height: 64px;\n  min-height: 64px;\n  max-height: 64px;\n  padding: 12px 16px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  box-sizing: border-box;\n  flex-shrink: 0;\n  border-bottom: 1px solid var(--dash-border);\n}\n.dashboard-nav-close-btn,\n.dashboard-nav-brand > button {\n  display: grid !important;\n  place-items: center !important;\n  margin-left: auto !important;\n  width: 40px !important;\n  height: 40px !important;\n  min-width: 40px !important;\n  min-height: 40px !important;\n  padding: 0 !important;\n  border: 1px solid var(--dash-border) !important;\n  border-radius: 10px !important;\n  background: var(--dash-surface-2) !important;\n  color: var(--dash-muted) !important;\n  cursor: pointer !important;\n  flex-shrink: 0 !important;\n  transition: background-color 0.15s ease, border-color 0.15s ease,\n    color 0.15s ease !important;\n}\n.dashboard-nav-close-btn:hover,\n.dashboard-nav-brand > button:hover {\n  background: var(--dash-surface-3) !important;\n  border-color: var(--dash-border-strong) !important;\n  color: var(--dash-text) !important;\n}\n.dashboard-nav.dark .dashboard-nav-close-btn,\n.dashboard-nav.dark .dashboard-nav-brand > button {\n  background: var(--surface-secondary, #1b2726) !important;\n  border-color: var(--border-subtle, #223230) !important;\n  color: var(--text-secondary, #879b97) !important;\n}\n.dashboard-nav.dark .dashboard-nav-close-btn:hover,\n.dashboard-nav.dark .dashboard-nav-brand > button:hover {\n  background: var(--surface-tertiary, #243533) !important;\n  border-color: var(--border-default, #324644) !important;\n  color: var(--text-primary, #f2f3f5) !important;\n}\n.dashboard-nav-close-btn svg,\n.dashboard-nav-brand > button svg {\n  width: 18px !important;\n  height: 18px !important;\n  color: inherit !important;\n  stroke: currentColor !important;\n  stroke-width: 1.67 !important;\n  display: block !important;\n}\n.dashboard-brand {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  white-space: nowrap;\n  height: 32px;\n  flex-shrink: 0;\n}\n.dashboard-brand > span {\n  width: 32px;\n  height: 32px;\n  min-width: 32px;\n  max-width: 32px;\n  flex: 0 0 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 9999px;\n  color: #fff !important;\n  background: var(--dash-brand) !important;\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif) !important;\n  font-size: 11px !important;\n  font-weight: 500 !important;\n  letter-spacing: 0.11px !important;\n  line-height: 14.3px !important;\n  text-transform: lowercase;\n}\n.business-dashboard.dark .dashboard-brand > span,\n.dashboard-nav.dark .dashboard-brand > span {\n  color: #fff !important;\n  background: var(--dash-brand) !important;\n}\n.dashboard-brand strong {\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif) !important;\n  font-size: 13px !important;\n  font-weight: 500 !important;\n  line-height: 16.9px !important;\n  color: var(--dash-text) !important;\n  letter-spacing: 0.065px !important;\n  white-space: nowrap;\n}\n.dashboard-org-wrap {\n  width: 100%;\n  height: 100px;\n  min-height: 100px;\n  max-height: 100px;\n  padding: 12px;\n  box-sizing: border-box;\n  flex-shrink: 0;\n  position: relative;\n}\n.dashboard-org {\n  width: 100%;\n  height: 76px;\n  min-height: 76px;\n  padding: 12px !important;\n  display: flex !important;\n  align-items: center !important;\n  gap: 8px !important;\n  text-align: left;\n  border: 1px solid var(--border-subtle, #dce3e2) !important;\n  border-radius: 10px !important;\n  background: var(--surface-secondary, #f4f7f7) !important;\n  box-sizing: border-box;\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif) !important;\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease;\n}\n.dashboard-org:hover,\n.dashboard-org.is-open {\n  border-color: var(--interactive-default, #0f766e) !important;\n}\n.dashboard-org.is-switching {\n  cursor: wait !important;\n}\n.dashboard-org > .dashboard-org-switching {\n  width: 100%;\n  display: flex !important;\n  flex-direction: row !important;\n  align-items: center !important;\n  gap: 8px !important;\n}\n.dashboard-org > .dashboard-org-switching > .app-skeleton {\n  flex: 0 0 32px;\n}\n.dashboard-org > .dashboard-org-switching > div {\n  display: flex !important;\n  flex: 1 1 auto !important;\n  flex-direction: column !important;\n  gap: 5px !important;\n}\n.dashboard-organisation-switch-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 10000;\n  display: grid;\n  grid-template-columns: 252px minmax(0, 1fr);\n  overflow: hidden;\n  background: var(--surface-primary, #ffffff);\n  cursor: wait;\n}\n.dashboard-organisation-switch-overlay > aside {\n  padding: 16px 12px;\n  border-right: 1px solid var(--border-subtle, #dce3e2);\n  background: var(--surface-primary, #ffffff);\n}\n.dashboard-switch-brand-skeleton,\n.dashboard-switch-org-skeleton,\n.dashboard-switch-nav-skeleton > div,\n.dashboard-organisation-switch-overlay > section > header,\n.dashboard-organisation-switch-overlay > section > header > div {\n  display: flex;\n  align-items: center;\n}\n.dashboard-switch-brand-skeleton {\n  height: 32px;\n  gap: 9px;\n  margin-bottom: 28px;\n}\n.dashboard-switch-org-skeleton {\n  min-height: 76px;\n  padding: 12px;\n  gap: 8px;\n  border: 1px solid var(--border-subtle, #dce3e2);\n  border-radius: 10px;\n  background: var(--surface-secondary, #f4f7f7);\n}\n.dashboard-switch-org-skeleton > div {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  gap: 6px;\n}\n.dashboard-switch-nav-skeleton {\n  display: flex;\n  flex-direction: column;\n  gap: 22px;\n  padding: 30px 10px;\n}\n.dashboard-switch-nav-skeleton > div {\n  gap: 12px;\n}\n.dashboard-organisation-switch-overlay > section {\n  min-width: 0;\n  background: var(--surface-secondary, #f7f9f9);\n}\n.dashboard-organisation-switch-overlay > section > header {\n  height: 64px;\n  padding: 0 24px;\n  justify-content: space-between;\n  border-bottom: 1px solid var(--border-subtle, #dce3e2);\n  background: var(--surface-primary, #ffffff);\n}\n.dashboard-organisation-switch-overlay > section > header > div {\n  gap: 16px;\n}\n.dashboard-organisation-switch-overlay main {\n  padding: 32px;\n}\n.dashboard-switch-heading-skeleton,\n.dashboard-switch-card-grid > div,\n.dashboard-switch-content-skeleton {\n  display: flex;\n  flex-direction: column;\n}\n.dashboard-switch-heading-skeleton {\n  gap: 12px;\n  margin-bottom: 28px;\n}\n.dashboard-switch-card-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 16px;\n}\n.dashboard-switch-card-grid > div {\n  min-height: 126px;\n  padding: 20px;\n  justify-content: space-between;\n  border: 1px solid var(--border-subtle, #dce3e2);\n  border-radius: 12px;\n  background: var(--surface-primary, #ffffff);\n}\n.dashboard-switch-content-skeleton {\n  margin-top: 24px;\n  padding: 24px;\n  gap: 14px;\n  border: 1px solid var(--border-subtle, #dce3e2);\n  border-radius: 12px;\n  background: var(--surface-primary, #ffffff);\n}\n@media (max-width: 767px) {\n  .dashboard-organisation-switch-overlay {\n    grid-template-columns: 1fr;\n  }\n  .dashboard-organisation-switch-overlay > aside {\n    display: none;\n  }\n  .dashboard-organisation-switch-overlay > section > header {\n    height: 56px;\n    padding: 0 16px;\n  }\n  .dashboard-organisation-switch-overlay > section > header > .app-skeleton {\n    width: 58% !important;\n  }\n  .dashboard-organisation-switch-overlay main {\n    padding: 20px 16px;\n  }\n  .dashboard-switch-card-grid {\n    grid-template-columns: 1fr;\n  }\n}\n.org-switch-icon {\n  color: var(--interactive-default, #0f766e) !important;\n  width: 16px !important;\n  height: 16px !important;\n  stroke-width: 2 !important;\n  flex-shrink: 0 !important;\n  margin-left: auto !important;\n}\n.dashboard-org > span {\n  position: relative !important;\n  width: 32px !important;\n  height: 32px !important;\n  min-width: 32px !important;\n  max-width: 32px !important;\n  flex: 0 0 32px !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  border: 1.5px solid var(--border-subtle, #dce3e2) !important;\n  border-radius: 16px !important;\n  color: var(--interactive-default, #0f766e) !important;\n  background: var(--interactive-soft, #f0f8f7) !important;\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif) !important;\n  font-size: 12px !important;\n  font-weight: 500 !important;\n  line-height: normal !important;\n  letter-spacing: 0 !important;\n  text-align: center !important;\n  overflow: hidden !important;\n}\n.dashboard-org > span > img {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  background: var(--surface-primary, #ffffff);\n}\n.dashboard-mobile-org {\n  display: flex !important;\n  align-items: center !important;\n  gap: 8px !important;\n  padding: 10px 12px !important;\n  min-height: 66px !important;\n  border: 1px solid var(--border-subtle, #dce3e2) !important;\n  border-radius: 10px !important;\n  background: var(--surface-secondary, #f4f7f7) !important;\n  cursor: pointer !important;\n  text-align: left !important;\n  box-sizing: border-box !important;\n}\n.dashboard-mobile-org > span {\n  position: relative !important;\n  width: 32px !important;\n  height: 32px !important;\n  min-width: 32px !important;\n  max-width: 32px !important;\n  flex: 0 0 32px !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  border: 1.5px solid var(--border-subtle, #dce3e2) !important;\n  border-radius: 16px !important;\n  color: var(--interactive-default, #0f766e) !important;\n  background: var(--interactive-soft, #f0f8f7) !important;\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif) !important;\n  font-size: 12px !important;\n  font-weight: 500 !important;\n  line-height: normal !important;\n  overflow: hidden !important;\n}\n.dashboard-org div {\n  min-width: 0 !important;\n  flex: 1 1 0% !important;\n  display: flex !important;\n  flex-direction: column !important;\n  justify-content: center !important;\n  gap: 2px !important;\n  overflow: hidden !important;\n}\n.dashboard-mobile-org div {\n  min-width: 0 !important;\n  flex: 1 1 0% !important;\n  display: flex !important;\n  flex-direction: column !important;\n  justify-content: center !important;\n  gap: 2px !important;\n  overflow: hidden !important;\n}\n.dashboard-org strong {\n  overflow: hidden !important;\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif) !important;\n  font-size: 13px !important;\n  font-weight: 500 !important;\n  line-height: 16.9px !important;\n  letter-spacing: 0.065px !important;\n  text-overflow: ellipsis !important;\n  white-space: nowrap !important;\n  color: var(--text-primary, #142624) !important;\n  display: block !important;\n}\n.dashboard-mobile-org strong {\n  overflow: hidden !important;\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif) !important;\n  font-size: 13px !important;\n  font-weight: 500 !important;\n  line-height: 16.9px !important;\n  letter-spacing: 0.065px !important;\n  text-overflow: ellipsis !important;\n  white-space: nowrap !important;\n  color: var(--text-primary, #142624) !important;\n  display: block !important;\n}\n.dashboard-org small {\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif) !important;\n  font-size: 11px !important;\n  font-weight: 400 !important;\n  line-height: 15.4px !important;\n  letter-spacing: 0.11px !important;\n  color: var(--text-secondary, #506360) !important;\n  white-space: nowrap !important;\n  display: block !important;\n  overflow: hidden !important;\n  text-overflow: ellipsis !important;\n}\n.dashboard-mobile-org small {\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif) !important;\n  font-size: 11px !important;\n  font-weight: 400 !important;\n  line-height: 15.4px !important;\n  letter-spacing: 0.11px !important;\n  color: var(--text-secondary, #506360) !important;\n  white-space: nowrap !important;\n  display: block !important;\n  overflow: hidden !important;\n  text-overflow: ellipsis !important;\n}\n.dashboard-org-user {\n  color: var(--text-tertiary, #667976) !important;\n  font-size: 10px !important;\n  line-height: 14px !important;\n}\n.dashboard-org .org-switch-icon,\n.dashboard-mobile-org .org-switch-icon {\n  stroke-width: 2 !important;\n  color: var(--interactive-default, #0f766e) !important;\n}\n\n/* Dark mode overrides for Organisation Selector (Figma Node 1119:53210) */\n.business-dashboard.dark .dashboard-org,\n[data-theme=\"dark\"] .dashboard-org,\n.dark .dashboard-org,\n.business-dashboard.dark .dashboard-mobile-org,\n[data-theme=\"dark\"] .dashboard-mobile-org,\n.dark .dashboard-mobile-org {\n  background: var(--surface-secondary, #22252a) !important;\n  border-color: var(--border-subtle, #2c3036) !important;\n}\n.business-dashboard.dark .dashboard-org:hover,\n.business-dashboard.dark .dashboard-org.is-open,\n[data-theme=\"dark\"] .dashboard-org:hover,\n[data-theme=\"dark\"] .dashboard-org.is-open,\n.dark .dashboard-org:hover,\n.dark .dashboard-org.is-open {\n  border-color: var(--interactive-default, #43a79c) !important;\n}\n.business-dashboard.dark .dashboard-org > span,\n[data-theme=\"dark\"] .dashboard-org > span,\n.dark .dashboard-org > span,\n.business-dashboard.dark .dashboard-mobile-org > span,\n[data-theme=\"dark\"] .dashboard-mobile-org > span,\n.dark .dashboard-mobile-org > span {\n  background: rgba(67, 167, 156, 0.15) !important;\n  border-color: var(--border-subtle, #2c3036) !important;\n  color: var(--interactive-default, #43a79c) !important;\n}\n.business-dashboard.dark .dashboard-org strong,\n[data-theme=\"dark\"] .dashboard-org strong,\n.dark .dashboard-org strong,\n.business-dashboard.dark .dashboard-mobile-org strong,\n[data-theme=\"dark\"] .dashboard-mobile-org strong,\n.dark .dashboard-mobile-org strong {\n  color: var(--text-primary, #f2f3f5) !important;\n}\n.business-dashboard.dark .dashboard-org small,\n[data-theme=\"dark\"] .dashboard-org small,\n.dark .dashboard-org small,\n.business-dashboard.dark .dashboard-mobile-org small,\n[data-theme=\"dark\"] .dashboard-mobile-org small,\n.dark .dashboard-mobile-org small {\n  color: var(--text-secondary, #b3b8c2) !important;\n}\n.business-dashboard.dark .dashboard-org .org-switch-icon,\n[data-theme=\"dark\"] .dashboard-org .org-switch-icon,\n.dark .dashboard-org .org-switch-icon,\n.business-dashboard.dark .dashboard-mobile-org .org-switch-icon,\n[data-theme=\"dark\"] .dashboard-mobile-org .org-switch-icon,\n.dark .dashboard-mobile-org .org-switch-icon {\n  color: var(--interactive-default, #43a79c) !important;\n}\n\n.dashboard-org-menu {\n  position: fixed;\n  z-index: 1200;\n  top: 76px;\n  left: 264px;\n  width: 360px;\n  padding: 6px;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  border: 1px solid var(--dash-border-strong);\n  border-radius: 14px;\n  background: var(--dash-surface);\n  box-shadow: 0 6px 16px -4px rgba(14, 26, 32, 0.1),\n    0 1px 2px rgba(14, 26, 32, 0.04);\n}\n\n.dashboard-org-menu :is(button, a) {\n  width: 100%;\n  height: 44px;\n  padding: 0 16px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  border: 0;\n  border-radius: 4px;\n  background: transparent;\n  color: var(--dash-text);\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif);\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 20.2px;\n  text-align: left;\n  text-decoration: none;\n}\n\n.dashboard-org-menu :is(button, a):hover,\n.dashboard-org-menu :is(button, a).active {\n  color: var(--dash-brand);\n  background: var(--dash-brand-soft);\n}\n\n.dashboard-org-menu :is(button, a) > svg {\n  width: 20px;\n  height: 20px;\n  flex-shrink: 0;\n}\n\n.dashboard-org-menu :is(button, a) > span {\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.dashboard-org-menu button:disabled {\n  cursor: default;\n  opacity: 1;\n}\n\n.dashboard-org-menu .dashboard-org-menu-check {\n  margin-left: auto;\n}\n.dashboard-mobile-org small {\n  color: var(--dash-muted);\n}\n.dashboard-nav-links {\n  flex: 1;\n  min-height: 0;\n  padding: 16px 12px;\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: var(--dash-muted) transparent;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n.dashboard-nav-links::-webkit-scrollbar {\n  width: 6px;\n}\n.dashboard-nav-links::-webkit-scrollbar-thumb {\n  background: var(--dash-muted);\n  border-radius: var(--radius-sm, 4px);\n}\n.dashboard-nav-group {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n.dashboard-nav-links > a,\n.dashboard-nav-group a,\n.dashboard-nav-group .dashboard-locked-link {\n  width: 100%;\n  height: 40px;\n  padding: 9px 12px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  border: 0;\n  border-radius: 10px;\n  color: var(--dash-text);\n  background: transparent;\n  appearance: none;\n  font-family: inherit;\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 20.2px;\n  letter-spacing: 0;\n  text-align: left;\n  text-decoration: none;\n  box-sizing: border-box;\n  transition: background-color 0.15s ease, color 0.15s ease;\n}\n.dashboard-nav-links > a:hover:not(.active),\n.dashboard-nav-group a:hover:not(.active),\n.dashboard-nav-group .dashboard-locked-link:hover {\n  background: var(--dash-surface-2);\n}\n.dashboard-nav-links a svg,\n.dashboard-locked-link svg {\n  width: 20px;\n  height: 20px;\n  flex-shrink: 0;\n  color: var(--dash-muted);\n}\n.dashboard-nav-links a.active {\n  color: var(--dash-brand) !important;\n  background: var(--dash-brand-soft) !important;\n  font-weight: 500;\n}\n.dashboard-nav-links a.active svg {\n  color: var(--dash-brand) !important;\n}\n.dashboard-nav-links > a > .dashboard-nav-label,\n.dashboard-nav-group a > .dashboard-nav-label,\n.dashboard-nav-group .dashboard-locked-link > .dashboard-nav-label,\n.dashboard-nav-links > a > span:not(.dashboard-nav-badge),\n.dashboard-nav-group a > span:not(.dashboard-nav-badge),\n.dashboard-nav-group .dashboard-locked-link > span:not(.dashboard-nav-badge) {\n  flex: 1 1 auto;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.dashboard-nav-group p {\n  margin: 0;\n  padding: 20px 12px 4px;\n  color: var(--dash-muted);\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 16.9px;\n  letter-spacing: 0.065px;\n  text-transform: uppercase;\n}\n.dashboard-nav-badge,\n.dashboard-nav-group a em,\n.dashboard-locked-link em {\n  flex: 0 0 auto !important;\n  flex-shrink: 0 !important;\n  flex-grow: 0 !important;\n  width: auto !important;\n  min-width: 18px !important;\n  height: 18px !important;\n  margin-left: auto !important;\n  padding: 1px 6px !important;\n  color: #ffffff !important;\n  background: var(--red-600, #c23a2b) !important;\n  border-radius: 10px !important;\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif) !important;\n  font-size: 11px !important;\n  font-weight: 600 !important;\n  font-style: normal !important;\n  line-height: normal !important;\n  text-align: center !important;\n  display: inline-flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  box-sizing: border-box !important;\n  white-space: nowrap !important;\n}\n.dashboard-nav-group a small,\n.dashboard-locked-link small {\n  margin-left: auto;\n  color: var(--dash-muted);\n}\n.dashboard-locked-link .dashboard-lock-icon {\n  width: 14px;\n  height: 14px;\n  margin-left: auto;\n  color: var(--dash-lock, #6b7b78);\n  flex-shrink: 0;\n}\n.dashboard-plan {\n  margin: 12px 12px 16px;\n  padding: 12px 12px 10px;\n  border-radius: 10px;\n  background: var(--dash-surface-2);\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  flex-shrink: 0;\n}\n.dashboard-plan-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 16.9px;\n  letter-spacing: 0.065px;\n}\n.dashboard-plan-header strong {\n  font-weight: 500;\n  color: var(--dash-text);\n  text-transform: uppercase;\n}\n.dashboard-plan-header a {\n  color: var(--dash-brand);\n  font-weight: 500;\n  text-decoration: none;\n}\n.dashboard-plan-header a:hover {\n  text-decoration: underline;\n}\n.dashboard-plan-usage {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 20.2px;\n  letter-spacing: 0;\n}\n.dashboard-plan-usage span {\n  color: var(--dash-muted);\n}\n.dashboard-plan-usage b {\n  font-weight: 400;\n  color: var(--dash-text);\n}\n.dashboard-plan-progress {\n  width: 100%;\n  height: 4px;\n  border-radius: 2px;\n  background: var(--dash-border);\n  overflow: hidden;\n}\n.dashboard-plan-progress span {\n  display: block;\n  height: 100%;\n  border-radius: 2px;\n  background: var(--dash-brand);\n  transition: width 0.3s ease;\n}\n.dashboard-plan\n  div:not(.dashboard-plan-header):not(.dashboard-plan-usage):not(.dashboard-plan-progress),\n.dashboard-plan p {\n  display: flex;\n  justify-content: space-between;\n  font-size: 13px;\n}\n.dashboard-plan div a:not(.dashboard-plan-header a) {\n  color: var(--dash-brand);\n  font-weight: 500;\n}\n.dashboard-plan p {\n  margin: 8px 0;\n}\n.dashboard-plan i {\n  height: 4px;\n  display: block;\n  overflow: hidden;\n  border-radius: 2px;\n  background: var(--dash-border);\n}\n.dashboard-plan i span {\n  height: 100%;\n  display: block;\n  border-radius: 2px;\n  background: var(--dash-brand);\n}\n\n.dashboard-main {\n  min-height: 100vh;\n  margin-left: 256px;\n}\n\n@media (min-width: 1025px) {\n  .global-dashboard-layout {\n    margin-left: 256px;\n    width: auto;\n  }\n}\n@media (max-width: 1024px) {\n  .global-dashboard-layout {\n    margin-left: 0 !important;\n    width: 100% !important;\n  }\n}\n.dashboard-topbar {\n  position: sticky;\n  top: 0;\n  z-index: 100;\n  height: 64px;\n  padding: 0 24px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-bottom: 1px solid var(--dash-border);\n  background: var(--dash-surface);\n}\n.dashboard-search {\n  width: 320px;\n  max-width: 320px;\n  height: 40px;\n  padding: 0 12px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  border: 1px solid var(--dash-border);\n  border-radius: 10px;\n  background: var(--dash-surface-2);\n}\n.dashboard-search svg {\n  width: 16px;\n  height: 16px;\n  color: var(--text-tertiary, #6b7b78);\n  flex-shrink: 0;\n}\n.dashboard-search input {\n  width: 100%;\n  border: 0;\n  outline: 0;\n  background: transparent;\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif);\n  font-size: 14px;\n  color: var(--dash-text);\n}\n.dashboard-top-actions {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n.dashboard-top-actions > span,\n.dashboard-top-actions .dashboard-topbar-credits {\n  height: 32px;\n  padding: 0 12px 0 10px;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  border: 1px solid var(--dash-border-strong, #cdd6d4);\n  border-radius: 999px;\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif);\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--dash-text);\n  cursor: pointer;\n  background: transparent;\n  box-sizing: border-box;\n}\n.dashboard-top-actions\n  > button:not(.dashboard-profile-control):not(.dashboard-topbar-credits) {\n  width: 36px;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 0;\n  border-radius: 18px;\n  background: transparent;\n  color: var(--dash-text);\n  cursor: pointer;\n}\n.dashboard-top-actions\n  > button:not(.dashboard-profile-control):not(.dashboard-topbar-credits):hover {\n  background: var(--dash-surface-2);\n}\n.dashboard-top-actions\n  > button:not(.dashboard-profile-control):not(.dashboard-topbar-credits)\n  svg {\n  width: 20px;\n  height: 20px;\n}\n.dashboard-topbar-credits svg {\n  width: 16px;\n  height: 16px;\n}\n.dashboard-profile-control {\n  padding: 4px;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  border: 0;\n  border-radius: 10px;\n  background: transparent;\n}\n.dashboard-profile-control > svg {\n  transition: transform 160ms ease;\n}\n.dashboard-profile-control.is-open > svg {\n  transform: rotate(180deg);\n}\n.dashboard-avatar {\n  position: relative;\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  display: grid;\n  place-items: center;\n  border: 1.5px solid var(--dash-border);\n  border-radius: 50%;\n  color: #fff;\n  background: var(--dash-brand);\n  font-size: 10px;\n  font-weight: 500;\n  line-height: 1;\n  text-align: center;\n}\n.dashboard-avatar i {\n  position: absolute;\n  right: -1px;\n  bottom: -1px;\n  width: 9px;\n  height: 9px;\n  border: 2px solid var(--dash-surface);\n  border-radius: 50%;\n  background: #26a269;\n}\n.dashboard-avatar > img {\n  width: 100%;\n  height: 100%;\n  display: block;\n  object-fit: cover;\n  border-radius: inherit;\n}\n.dashboard-mobile-controls {\n  display: none;\n}\n.dashboard-profile-menu {\n  position: absolute;\n  z-index: 60;\n  top: 56px;\n  right: 12px;\n  width: 240px;\n  padding: 4px;\n  display: grid;\n  gap: 4px;\n  border: 1px solid var(--dash-border);\n  border-radius: 10px;\n  background: var(--dash-surface);\n  box-shadow: 0 8px 30px rgba(14, 26, 32, 0.16);\n}\n.dashboard-profile-menu > button {\n  height: 36px;\n  padding: 0 12px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  border: 0;\n  border-radius: 6px;\n  background: transparent;\n  text-align: left;\n  font-size: 14px;\n}\n.dashboard-profile-menu > button:hover {\n  background: var(--dash-surface-2);\n}\n.dashboard-profile-help {\n  display: none !important;\n}\n.dashboard-profile-menu > small {\n  padding: 4px 12px 10px;\n  color: var(--dash-muted);\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.dashboard-credits {\n  padding: 16px;\n  display: none;\n  grid-template-columns: 20px 1fr;\n  align-items: center;\n  gap: 8px;\n  border-radius: 10px;\n  background: var(--dash-surface-2);\n}\n.dashboard-credits strong {\n  grid-column: 1 / -1;\n  font-family: var(--font-family-mono, monospace);\n  font-size: 20px;\n}\n.dashboard-appearance {\n  padding: 8px 12px;\n  color: var(--dash-muted);\n}\n.dashboard-appearance > div {\n  width: 168px;\n  height: 36px;\n  margin-top: 8px;\n  padding: 3px;\n  display: flex;\n  border: 0;\n  border-radius: 10px;\n  background: transparent;\n}\n.dashboard-appearance button {\n  width: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  border: 0;\n  border-radius: 6px;\n  background: transparent;\n}\n.dashboard-appearance button.active {\n  color: var(--dash-brand);\n  background: var(--dash-surface);\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n}\n.dashboard-appearance button:focus-visible {\n  outline: 2px solid var(--focus-ring);\n  outline-offset: 3px;\n}\n.dashboard-profile-close {\n  display: none !important;\n}\n\n.dashboard-content {\n  width: 100%;\n  max-width: none;\n  margin: 0;\n  padding: 32px;\n  display: grid;\n  gap: 24px;\n}\n.dashboard-heading {\n  display: grid;\n  grid-template-columns: 1fr auto;\n  gap: 16px;\n}\n.dashboard-heading h1 {\n  margin: 0;\n  font-size: 32px;\n  font-weight: 600;\n  line-height: 40px;\n  letter-spacing: -0.48px;\n}\n.dashboard-heading p,\n.dashboard-period-info span {\n  margin: 0;\n  color: var(--dash-muted);\n}\n.dashboard-heading > div:first-child > p {\n  margin-top: 4px;\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 20.2px;\n  letter-spacing: 0;\n}\n.dashboard-create {\n  display: flex;\n  gap: 12px;\n}\n.dashboard-create button {\n  font: inherit;\n  cursor: pointer;\n}\n.dashboard-create :is(a, button) {\n  height: 40px;\n  padding: 0 12px;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  border: 1px solid var(--dash-border-strong);\n  border-radius: 10px;\n  background: var(--dash-surface);\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif);\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 16.9px;\n  letter-spacing: 0.065px;\n}\n.dashboard-create :is(a, button) svg {\n  display: none;\n}\n.dashboard-create :is(a, button).primary,\n.dashboard-attention a.primary {\n  color: #fff;\n  border-color: var(--dash-brand);\n  background: var(--dash-brand);\n}\n.business-dashboard.dark .dashboard-create :is(a, button).primary,\n.business-dashboard.dark .dashboard-attention a.primary {\n  color: #101113;\n}\n.dashboard-period-info {\n  display: grid;\n  gap: 4px;\n}\n.dashboard-period-info b {\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 16.9px;\n  letter-spacing: 0.065px;\n  color: var(--dash-text);\n}\n.dashboard-period-info span {\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 18.2px;\n  letter-spacing: 0.065px;\n  color: var(--dash-muted);\n}\n.dashboard-periods {\n  align-self: end;\n  justify-self: end;\n  display: flex;\n  gap: 4px;\n  background: transparent;\n  padding: 0;\n}\n.dashboard-periods button {\n  height: 33px;\n  padding: 8px 16px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: 0;\n  border-radius: var(--radius-md, 10px);\n  background: transparent;\n  color: var(--dash-muted, #506360);\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif);\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 16.9px;\n  letter-spacing: 0.065px;\n  white-space: nowrap;\n  cursor: pointer;\n  transition: background-color 150ms ease, color 150ms ease;\n}\n.dashboard-periods button:hover {\n  color: var(--dash-text, #142624);\n  background: var(--dash-surface-2, #f4f7f7);\n}\n.dashboard-periods button.active {\n  background: var(--interactive-selected, #dcefec);\n  color: var(--interactive-pressed, #0a4a46);\n}\n.business-dashboard.dark .dashboard-periods button {\n  color: #b3b8c2;\n}\n.business-dashboard.dark .dashboard-periods button:hover {\n  color: #f2f3f5;\n  background: rgba(255, 255, 255, 0.05);\n}\n.business-dashboard.dark .dashboard-periods button.active {\n  background: rgba(67, 167, 156, 0.2);\n  color: #83c7be;\n}\n\n.dashboard-card {\n  overflow: hidden;\n  border: 1px solid var(--dash-border);\n  border-radius: 14px;\n  background: var(--dash-surface);\n}\n.dashboard-metrics {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 24px;\n}\n.dashboard-metric {\n  min-height: 300px;\n  height: 300px;\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n}\n.dashboard-metric header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.dashboard-metric header svg {\n  width: 20px;\n  height: 20px;\n  color: var(--dash-brand);\n}\n.dashboard-card h2 {\n  margin: 0;\n  font: 500 16px/22.4px var(--font-family-primary, \"Lexend\", sans-serif);\n  letter-spacing: -0.08px;\n  color: var(--dash-text);\n}\n.dashboard-money {\n  margin-top: 24px;\n  font: 700 20px/24px var(--font-family-mono, \"JetBrains Mono\", monospace) !important;\n  letter-spacing: 0;\n  font-variant-numeric: tabular-nums;\n  color: var(--dash-text);\n}\n.dashboard-metric > p {\n  margin: 8px 0 24px;\n  font: 400 13px/18.2px var(--font-family-primary, \"Lexend\", sans-serif);\n  letter-spacing: 0.065px;\n  color: var(--dash-muted);\n}\n.dashboard-metric-rows {\n  display: grid;\n  gap: 12px;\n}\n.dashboard-metric-rows div {\n  display: flex;\n  justify-content: space-between;\n}\n.dashboard-metric-rows span {\n  font: 400 13px/20.2px var(--font-family-primary, \"Lexend\", sans-serif);\n  letter-spacing: 0;\n  color: var(--dash-muted);\n}\n.dashboard-metric-rows b {\n  font: 400 13px/20.2px var(--font-family-primary, \"Lexend\", sans-serif);\n  letter-spacing: 0;\n  font-variant-numeric: tabular-nums;\n  color: var(--dash-text);\n}\n.dashboard-note {\n  margin-top: auto;\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  color: var(--text-tertiary, #6b7b78);\n  font: 400 13px/18.2px var(--font-family-primary, \"Lexend\", sans-serif);\n  letter-spacing: 0.065px;\n}\n.business-dashboard.dark .dashboard-note {\n  color: var(--text-tertiary, #9299a5);\n}\n.dashboard-note svg {\n  width: 16px;\n  height: 16px;\n  flex: none;\n  margin-top: 1px;\n}\n\n.dashboard-attention {\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  box-shadow: 0 1px 2px rgba(14, 26, 32, 0.06);\n}\n.dashboard-attention > header {\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.dashboard-attention > header p {\n  margin: 4px 0 0;\n  font-size: 13px;\n  color: var(--dash-muted);\n}\n.dashboard-attention-row {\n  min-height: 72px;\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 112px 160px;\n  align-items: center;\n  gap: 16px;\n  padding-bottom: 8px;\n  border-bottom: 1px solid var(--dash-border);\n}\n.dashboard-attention-row:last-child {\n  border-bottom: 0;\n}\n.dashboard-attention-context {\n  min-width: 0;\n  min-height: 64px;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n.dashboard-attention-context svg {\n  width: 20px;\n  height: 20px;\n  flex: none;\n  color: var(--dash-text);\n}\n.dashboard-attention-context > div {\n  min-width: 0;\n  display: grid;\n}\n.dashboard-attention-context strong,\n.dashboard-attention-context p {\n  margin: 0;\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 20.2px;\n  color: var(--dash-text);\n}\n.dashboard-attention-row > .status-pill {\n  justify-self: start;\n}\n.dashboard-attention-row a {\n  width: 160px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid var(--dash-border-strong);\n  border-radius: var(--radius-md, 10px);\n  background: var(--dash-surface-2);\n  color: var(--dash-text);\n  font-size: 13px;\n  font-weight: 500;\n  white-space: nowrap;\n}\n.dashboard-attention-row a.primary {\n  color: #fff;\n  border: 0;\n  background: var(--dash-brand);\n}\n.business-dashboard.dark .dashboard-attention-row a {\n  background: var(--dash-surface-2, #22252a);\n  border-color: var(--dash-border-strong, #3a3f47);\n  color: var(--dash-text, #f2f3f5);\n}\n.business-dashboard.dark .dashboard-attention-row a.primary {\n  color: #101113;\n  background: var(--dash-brand, #43a79c);\n}\n\n.status-pill {\n  height: 22px;\n  padding: 0 6px;\n  border-radius: 999px;\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif);\n  font-size: 12px;\n  font-weight: 500;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  white-space: nowrap;\n  font-style: normal;\n}\n.status-pill.status-overdue,\n.status-pill.overdue {\n  background: var(--danger-soft, #fef2f1);\n  color: var(--danger-text, #a3301f);\n}\n.status-pill.status-awaiting-payment,\n.status-pill.awaiting-payment,\n.status-pill.status-pending,\n.status-pill.pending {\n  background: var(--warning-soft, #fef8ec);\n  color: var(--warning-text, #7d4412);\n}\n.status-pill.status-sent,\n.status-pill.sent {\n  background: var(--info-soft, #eff6ff);\n  color: var(--info-text, #1d4ed8);\n}\n.status-pill.status-paid,\n.status-pill.paid {\n  background: var(--success-soft, #edfbf2);\n  color: var(--success-text, #115a33);\n}\n.status-pill.status-viewed,\n.status-pill.viewed {\n  background: var(--interactive-soft, #f0f8f7);\n  color: var(--interactive-default, #0f766e);\n}\n.status-pill.status-draft,\n.status-pill.draft {\n  background: var(--surface-tertiary, #e8edec);\n  color: var(--text-primary, #142624);\n}\n.business-dashboard.dark .status-pill.status-overdue,\n.business-dashboard.dark .status-pill.overdue,\n.business-dashboard[data-theme=\"dark\"] .status-pill.status-overdue,\n.business-dashboard[data-theme=\"dark\"] .status-pill.overdue {\n  background: var(--danger-soft, #332022);\n  color: var(--danger-text, #f3aaa4);\n}\n.business-dashboard.dark .status-pill.status-awaiting-payment,\n.business-dashboard.dark .status-pill.awaiting-payment,\n.business-dashboard.dark .status-pill.status-pending,\n.business-dashboard.dark .status-pill.pending,\n.business-dashboard[data-theme=\"dark\"] .status-pill.status-awaiting-payment,\n.business-dashboard[data-theme=\"dark\"] .status-pill.awaiting-payment,\n.business-dashboard[data-theme=\"dark\"] .status-pill.status-pending,\n.business-dashboard[data-theme=\"dark\"] .status-pill.pending {\n  background: var(--warning-soft, #342b1d);\n  color: var(--warning-text, #e6c78c);\n}\n.business-dashboard.dark .status-pill.status-sent,\n.business-dashboard.dark .status-pill.sent,\n.business-dashboard[data-theme=\"dark\"] .status-pill.status-sent,\n.business-dashboard[data-theme=\"dark\"] .status-pill.sent {\n  background: var(--info-soft, #1e2b3c);\n  color: var(--info-text, #aec9ec);\n}\n.business-dashboard.dark .status-pill.status-paid,\n.business-dashboard.dark .status-pill.paid,\n.business-dashboard[data-theme=\"dark\"] .status-pill.status-paid,\n.business-dashboard[data-theme=\"dark\"] .status-pill.paid {\n  background: var(--success-soft, #1b2d25);\n  color: var(--success-text, #94d3af);\n}\n.business-dashboard.dark .status-pill.status-viewed,\n.business-dashboard.dark .status-pill.viewed,\n.business-dashboard[data-theme=\"dark\"] .status-pill.status-viewed,\n.business-dashboard[data-theme=\"dark\"] .status-pill.viewed {\n  background: var(--interactive-soft, #22252a);\n  color: var(--interactive-default, #43a79c);\n}\n.business-dashboard.dark .status-pill.status-draft,\n.business-dashboard.dark .status-pill.draft,\n.business-dashboard[data-theme=\"dark\"] .status-pill.status-draft,\n.business-dashboard[data-theme=\"dark\"] .status-pill.draft {\n  background: var(--surface-tertiary, #2b2f35);\n  color: var(--text-primary, #f2f3f5);\n}\n\n.dashboard-charts {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 24px;\n}\n.dashboard-charts article {\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n.dashboard-charts article:first-child {\n  height: 451px;\n}\n.dashboard-charts article:last-child {\n  height: 432px;\n}\n.dashboard-charts header p {\n  margin: 4px 0 0;\n  font-size: 12px;\n  line-height: 19px;\n  letter-spacing: 0.12px;\n  color: var(--dash-muted);\n}\n.dashboard-chart-container {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  width: 100%;\n}\n.dashboard-plot-row {\n  display: flex;\n  gap: 12px;\n  align-items: flex-start;\n  width: 100%;\n  margin-top: 0;\n}\n.dashboard-currency-scale {\n  width: 48px;\n  height: 228px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  font-family: var(--font-family-mono, monospace);\n  font-size: 13px;\n  line-height: 19px;\n  color: var(--text-tertiary, #6b7b78);\n  padding: 18px 0 7px;\n}\n.business-dashboard.dark .dashboard-currency-scale {\n  color: var(--text-tertiary, #9299a5);\n}\n.dashboard-bar-chart {\n  flex: 1;\n  display: flex;\n  align-items: flex-end;\n  gap: 12px;\n  height: 256px;\n}\n.dashboard-bar-item {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n}\n.dashboard-bar-track {\n  width: 100%;\n  height: 210px;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 4px;\n  border-bottom: 1px solid var(--chart-grid, #dce3e2);\n}\n.business-dashboard.dark .dashboard-bar-track {\n  border-bottom-color: #343940;\n}\n.dashboard-bar-track b {\n  font-family: var(--font-family-mono, monospace);\n  font-size: 13px;\n  line-height: 16.9px;\n  font-weight: 400;\n  color: var(--dash-muted, #506360);\n  text-align: center;\n}\n.business-dashboard.dark .dashboard-bar-track b {\n  color: #b3b8c2;\n}\n.dashboard-bar-track i {\n  width: 100%;\n  max-width: 44px;\n  border-radius: 3px;\n  display: block;\n}\n.dashboard-bar-track i.overdue {\n  background: var(--chart-danger, #e04434);\n}\n.business-dashboard.dark .dashboard-bar-track i.overdue {\n  background: var(--chart-danger, #f08078);\n}\n.dashboard-bar-track i.due {\n  background: var(--warning-default, #b7701a);\n}\n.business-dashboard.dark .dashboard-bar-track i.due {\n  background: var(--warning-default, #ddb56b);\n}\n.dashboard-bar-track i.future {\n  background: var(--chart-primary, #0f766e);\n}\n.business-dashboard.dark .dashboard-bar-track i.future {\n  background: var(--chart-primary, #43a79c);\n}\n.dashboard-bar-label {\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif);\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 19px;\n  letter-spacing: 0.12px;\n  color: var(--text-tertiary, #6b7b78);\n  text-align: center;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n.business-dashboard.dark .dashboard-bar-label {\n  color: var(--text-tertiary, #9299a5);\n}\n\n.dashboard-cash-chart {\n  flex: 1;\n  display: flex;\n  align-items: flex-end;\n  gap: 12px;\n  height: 237px;\n}\n.dashboard-cash-item {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n}\n.dashboard-cash-track {\n  width: 100%;\n  height: 210px;\n  display: flex;\n  justify-content: center;\n  align-items: flex-end;\n  gap: 4px;\n  border-bottom: 1px solid var(--chart-grid, #dce3e2);\n}\n.business-dashboard.dark .dashboard-cash-track {\n  border-bottom-color: #343940;\n}\n.cash-col {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 4px;\n  max-width: 28px;\n}\n.cash-col b {\n  font-family: var(--font-family-mono, monospace);\n  font-size: 13px;\n  font-weight: 400;\n  color: var(--dash-muted, #506360);\n  text-align: center;\n}\n.business-dashboard.dark .cash-col b {\n  color: #b3b8c2;\n}\n.cash-col i {\n  width: 100%;\n  max-width: 28px;\n  border-radius: 3px;\n  display: block;\n}\n.cash-col i.in {\n  background: var(--chart-primary, #0f766e);\n}\n.business-dashboard.dark .cash-col i.in {\n  background: var(--chart-primary, #43a79c);\n}\n.cash-col i.out {\n  background: var(--chart-secondary, #aebab8);\n}\n.business-dashboard.dark .cash-col i.out {\n  background: var(--chart-secondary, #77817c);\n}\n\n.dashboard-legend {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px 24px;\n  align-items: center;\n}\n.dashboard-legend-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.dashboard-legend-item span:not(.legend-marker) {\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif);\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 19px;\n  letter-spacing: 0.12px;\n  color: var(--dash-muted, #506360);\n  white-space: nowrap;\n}\n.business-dashboard.dark .dashboard-legend-item span:not(.legend-marker) {\n  color: #b3b8c2;\n}\n.legend-marker {\n  width: 10px;\n  height: 10px;\n  border-radius: 2px;\n  flex-shrink: 0;\n}\n.legend-marker.overdue {\n  background: var(--chart-danger, #e04434);\n}\n.business-dashboard.dark .legend-marker.overdue {\n  background: var(--chart-danger, #f08078);\n}\n.legend-marker.due {\n  background: var(--warning-default, #b7701a);\n}\n.business-dashboard.dark .legend-marker.due {\n  background: var(--warning-default, #ddb56b);\n}\n.legend-marker.future {\n  background: var(--chart-primary, #0f766e);\n}\n.business-dashboard.dark .legend-marker.future {\n  background: var(--chart-primary, #43a79c);\n}\n.legend-marker.cash-out {\n  background: var(--chart-secondary, #aebab8);\n}\n.business-dashboard.dark .legend-marker.cash-out {\n  background: var(--chart-secondary, #77817c);\n}\n.dashboard-chart-summary {\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif);\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 19px;\n  letter-spacing: 0.12px;\n  color: var(--dash-muted, #506360);\n  margin: 0;\n  width: 100%;\n}\n.business-dashboard.dark .dashboard-chart-summary {\n  color: #b3b8c2;\n}\n\n.dashboard-invoices header {\n  min-height: 58px;\n  padding: 0 24px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.dashboard-invoices {\n  box-shadow: 0 1px 2px rgba(14, 26, 32, 0.06);\n}\n.dashboard-invoices header p {\n  margin: 2px 0 0;\n  font-size: 13px;\n  color: var(--text-tertiary, #6b7b78);\n}\n.business-dashboard.dark .dashboard-invoices header p {\n  color: var(--text-tertiary, #9299a5);\n}\n.dashboard-invoices header a {\n  min-height: 40px;\n  padding: 0 12px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--text-link, #0f766e);\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 16.9px;\n  letter-spacing: 0.065px;\n  border-radius: var(--radius-md, 10px);\n}\n.business-dashboard.dark .dashboard-invoices header a {\n  color: var(--text-link, #83c7be);\n}\n.dashboard-table {\n  overflow-x: auto;\n}\n.dashboard-table-head,\n.dashboard-table-row {\n  min-width: 1000px;\n  display: grid;\n  grid-template-columns:\n    minmax(112px, 1fr) minmax(150px, 1.35fr) minmax(100px, 0.9fr)\n    minmax(112px, 0.95fr) minmax(108px, 0.95fr) minmax(124px, 1.05fr)\n    minmax(104px, 0.9fr) minmax(144px, 1.15fr);\n  align-items: center;\n  gap: 0;\n}\n.dashboard-table-head {\n  height: 44px;\n  color: var(--dash-muted);\n  background: var(--dash-surface-2);\n  border-bottom: 1px solid var(--dash-border);\n  font-size: 12px;\n  line-height: 16px;\n  font-weight: 500;\n}\n.dashboard-table-head > span {\n  min-width: 0;\n  padding: 0 16px;\n}\n.dashboard-table-head > span:nth-child(7),\n.dashboard-table-head > span:nth-child(8) {\n  text-align: right;\n}\n.dashboard-table-row {\n  min-height: 52px;\n  border-bottom: 1px solid var(--dash-border);\n}\n.dashboard-invoice-row {\n  cursor: pointer;\n}\n.dashboard-invoice-row:hover {\n  background: var(--dash-surface-2);\n}\n.dashboard-invoice-row:focus-visible {\n  outline: 2px solid var(--text-link);\n  outline-offset: -2px;\n}\n.dashboard-empty-state {\n  min-height: 112px;\n  padding: 24px;\n  display: grid;\n  place-items: center;\n  color: var(--dash-muted);\n  font-size: 13px;\n  text-align: center;\n  border-bottom: 1px solid var(--dash-border);\n}\n.dashboard-table-row .invoice-number {\n  grid-column: 1;\n  padding: 10px 16px;\n  font-family: var(--font-family-mono, monospace);\n  font-size: 14px;\n  line-height: 18.2px;\n  letter-spacing: 0.28px;\n  font-weight: 500;\n  text-transform: uppercase;\n  color: var(--text-link, #0f766e);\n}\n.dashboard-table-row .customer {\n  grid-column: 2;\n  min-width: 0;\n  padding: 10px 16px;\n  font-size: 13px;\n  line-height: 20.2px;\n  color: var(--dash-text);\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.dashboard-table-row .customer small,\n.dashboard-table-row .invoice-payment-status small,\n.dashboard-table-row .invoice-balance small {\n  display: block;\n  margin-top: 3px;\n  color: var(--dash-muted);\n  font-size: 12px;\n  line-height: 16px;\n}\n.dashboard-table-row .invoice-date {\n  grid-column: 3;\n  padding: 10px 16px;\n  font-size: 13px;\n  line-height: 19px;\n  white-space: nowrap;\n}\n.dashboard-table-row .due-date {\n  grid-column: 4;\n  padding: 10px 16px;\n  color: var(--dash-text);\n  font-size: 13px;\n  line-height: 19px;\n  white-space: nowrap;\n}\n.dashboard-table-row .invoice-lifecycle-status {\n  grid-column: 5;\n  padding: 10px 16px;\n}\n.dashboard-table-row .invoice-payment-status {\n  grid-column: 6;\n  padding: 10px 16px;\n}\n.dashboard-table-row .invoice-lifecycle-status i,\n.dashboard-table-row .invoice-payment-status i {\n  display: inline-flex;\n  min-height: 22px;\n  align-items: center;\n  padding: 0 6px;\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 500;\n  line-height: 14px;\n  font-style: normal;\n  white-space: nowrap;\n}\n.dashboard-table-row .invoice-lifecycle-status i {\n  color: var(--interactive-default, #0f766e);\n  background: var(--interactive-soft, #f0f8f7);\n}\n.dashboard-table-row .invoice-lifecycle-status i.draft,\n.dashboard-table-row .invoice-lifecycle-status i.pending,\n.dashboard-table-row .invoice-payment-status i.draft,\n.dashboard-table-row .invoice-payment-status i.voided {\n  color: var(--text-secondary, #506360);\n  background: var(--surface-tertiary, #e8edec);\n}\n.dashboard-table-row .invoice-payment-status i.awaiting {\n  color: var(--warning-text, #7d4412);\n  background: var(--warning-soft, #fef8ec);\n}\n.dashboard-table-row .invoice-payment-status i.overdue {\n  color: var(--danger-text, #a3301f);\n  background: var(--danger-soft, #fef2f1);\n}\n.dashboard-table-row .invoice-payment-status i.paid {\n  color: var(--success-text, #115a33);\n  background: var(--success-soft, #edfbf2);\n}\n.dashboard-table-row .invoice-amount {\n  grid-column: 7;\n  padding: 10px 16px;\n  font-family: var(--font-family-mono, monospace);\n  font-size: 15px;\n  line-height: 19.5px;\n  font-weight: 500;\n  color: var(--dash-text);\n  text-align: right;\n  white-space: nowrap;\n}\n.dashboard-table-row .invoice-balance {\n  grid-column: 8;\n  min-width: 0;\n  padding: 10px 16px;\n  text-align: right;\n}\n.dashboard-table-row .invoice-balance strong {\n  display: block;\n  font-family: var(--font-family-mono, monospace);\n  font-size: 15px;\n  line-height: 19.5px;\n  white-space: nowrap;\n}\n.dashboard-invoices footer {\n  padding: 16px 24px;\n  color: var(--text-tertiary, #6b7b78);\n  font-size: 13px;\n  line-height: 18.2px;\n  letter-spacing: 0.065px;\n}\n.business-dashboard.dark .dashboard-invoices footer {\n  color: var(--text-tertiary, #9299a5);\n}\n.dashboard-mobile-context,\n.dashboard-mobile-plan {\n  display: none;\n}\n.dashboard-sidebar-launcher {\n  display: none;\n}\n.dashboard-overlay {\n  position: fixed !important;\n  inset: 0 !important;\n  top: 0 !important;\n  left: 0 !important;\n  right: 0 !important;\n  bottom: 0 !important;\n  width: 100vw !important;\n  height: 100vh !important;\n  z-index: 9998 !important;\n  background: var(--overlay-default, rgba(10, 22, 20, 0.44)) !important;\n  border: 0;\n  padding: 0;\n  margin: 0;\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 0.25s cubic-bezier(0.4, 0, 0.2, 1);\n  display: none;\n}\n@media (max-width: 1024px) {\n  .dashboard-overlay.is-open {\n    opacity: 1 !important;\n    pointer-events: auto !important;\n    display: block !important;\n  }\n}\n@media (min-width: 1025px) {\n  .dashboard-overlay,\n  .dashboard-overlay.is-open {\n    display: none !important;\n    opacity: 0 !important;\n    pointer-events: none !important;\n    visibility: hidden !important;\n  }\n}\n.business-dashboard.dark .dashboard-overlay,\n.dashboard-nav.dark ~ .dashboard-overlay,\n[data-theme=\"dark\"] .dashboard-overlay {\n  background: rgba(0, 0, 0, 0.65) !important;\n}\n\n@media (max-width: 1024px) {\n  .dashboard-nav {\n    display: flex !important;\n    position: fixed !important;\n    top: 0 !important;\n    bottom: 0 !important;\n    left: 0 !important;\n    width: 280px !important;\n    max-width: 85vw !important;\n    z-index: 9999 !important;\n    transform: translateX(-100%) !important;\n    transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1),\n      visibility 0.25s ease !important;\n    visibility: hidden !important;\n    box-shadow: none !important;\n    border-right: 1px solid var(--dash-border) !important;\n    background: var(--dash-surface) !important;\n    overflow: hidden !important;\n  }\n  .dashboard-nav.is-open {\n    transform: translateX(0) !important;\n    visibility: visible !important;\n    box-shadow: 4px 0 24px rgba(10, 22, 20, 0.18) !important;\n  }\n  .dashboard-nav .dashboard-org-wrap {\n    display: none !important;\n  }\n  .dashboard-nav-brand {\n    height: 76px !important;\n    min-height: 76px !important;\n    max-height: 76px !important;\n    padding: 16px !important;\n    display: flex !important;\n    align-items: center !important;\n    justify-content: space-between !important;\n    border-bottom: 1px solid var(--dash-border) !important;\n    border-right: 1px solid var(--dash-border) !important;\n    box-sizing: border-box !important;\n    flex-shrink: 0 !important;\n    z-index: 10000 !important;\n  }\n  .dashboard-nav-close-btn,\n  .dashboard-nav-brand > button {\n    display: grid !important;\n    place-items: center !important;\n    margin-left: auto !important;\n    width: 44px !important;\n    height: 44px !important;\n    min-width: 44px !important;\n    min-height: 44px !important;\n    padding: 0 !important;\n    border: 1px solid var(--dash-border) !important;\n    border-radius: 10px !important;\n    background: var(--dash-surface-2) !important;\n    color: var(--dash-muted) !important;\n    cursor: pointer !important;\n    flex-shrink: 0 !important;\n    transition: background-color 0.15s ease, border-color 0.15s ease,\n      color 0.15s ease !important;\n  }\n  .dashboard-nav-close-btn:hover,\n  .dashboard-nav-brand > button:hover {\n    background: var(--dash-surface-3) !important;\n    border-color: var(--dash-border-strong) !important;\n    color: var(--dash-text) !important;\n  }\n  .dashboard-nav.dark .dashboard-nav-close-btn,\n  .dashboard-nav.dark .dashboard-nav-brand > button {\n    background: var(--surface-secondary, #1b2726) !important;\n    border-color: var(--border-subtle, #223230) !important;\n    color: var(--text-secondary, #879b97) !important;\n  }\n  .dashboard-nav.dark .dashboard-nav-close-btn:hover,\n  .dashboard-nav.dark .dashboard-nav-brand > button:hover {\n    background: var(--surface-tertiary, #243533) !important;\n    border-color: var(--border-default, #324644) !important;\n    color: var(--text-primary, #f2f3f5) !important;\n  }\n  .dashboard-nav-close-btn svg,\n  .dashboard-nav-brand > button svg {\n    width: 18px !important;\n    height: 18px !important;\n    color: inherit !important;\n    stroke: currentColor !important;\n    stroke-width: 1.67 !important;\n    display: block !important;\n  }\n  .dashboard-overlay {\n    display: block !important;\n  }\n  .dashboard-sidebar-launcher {\n    position: fixed;\n    z-index: 38;\n    left: 12px;\n    bottom: 12px;\n    width: 44px;\n    height: 44px;\n    display: grid;\n    place-items: center;\n    border: 1px solid var(--dash-border, #dce3e2);\n    border-radius: 10px;\n    color: var(--dash-text, #142624);\n    background: var(--dash-surface, #fff);\n    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.18);\n  }\n  .dashboard-main {\n    margin-left: 0;\n  }\n  .dashboard-mobile-controls {\n    display: flex;\n    gap: 12px;\n  }\n  .dashboard-mobile-controls button {\n    width: 44px;\n    height: 44px;\n    display: grid;\n    place-items: center;\n    border: 1px solid var(--dash-border);\n    border-radius: 10px;\n    background: var(--dash-surface-2);\n    color: var(--dash-text);\n  }\n  .dashboard-mobile-controls button svg {\n    width: 20px;\n    height: 20px;\n  }\n  .dashboard-topbar {\n    height: 64px;\n    padding: 0 24px;\n    border-bottom: 1px solid var(--dash-border);\n  }\n  .dashboard-top-actions {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n  }\n  .dashboard-top-actions .dashboard-notification {\n    width: 36px;\n    height: 36px;\n    display: grid;\n    place-items: center;\n    border-radius: 18px;\n    background: transparent;\n    color: var(--dash-text);\n  }\n  .dashboard-top-actions .dashboard-notification svg {\n    width: 20px;\n    height: 20px;\n  }\n  .dashboard-profile-control {\n    padding: 4px;\n    gap: 4px;\n  }\n  .dashboard-avatar {\n    width: 32px;\n    height: 32px;\n    border-radius: 16px;\n  }\n  .dashboard-profile-control > svg {\n    width: 16px;\n    height: 16px;\n  }\n  .dashboard-credits {\n    display: grid;\n  }\n  .dashboard-profile-help {\n    display: flex !important;\n  }\n  .dashboard-appearance {\n    border-bottom: 1px solid var(--dash-border);\n    padding-bottom: 18px;\n    margin-bottom: 8px;\n  }\n  .dashboard-content {\n    max-width: none;\n    padding: 24px;\n    gap: 20px;\n    display: flex;\n    flex-direction: column;\n  }\n\n  /* ORDER matching Figma:\n     1. Mobile/Tablet context (Product identity + Org selector + Shortcuts)\n     2. Heading (Dashboard title + Create buttons + Metadata + Periods)\n     3. Financial summary metrics\n     4. Needs attention\n     5. Recent invoices\n     6. Historical analysis charts\n     7. Plan and usage banner\n  */\n  .dashboard-mobile-context {\n    order: 1;\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    width: 100%;\n  }\n  .dashboard-org-product-row {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n  }\n  .dashboard-product-identity {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n  }\n  .dashboard-launcher-btn {\n    width: 44px;\n    height: 44px;\n    display: grid;\n    place-items: center;\n    border: 1px solid var(--dash-border);\n    border-radius: 10px;\n    background: var(--dash-surface-2);\n    color: var(--dash-text);\n    cursor: pointer;\n  }\n  .dashboard-launcher-btn svg {\n    width: 20px;\n    height: 20px;\n  }\n  .dashboard-product-name {\n    font-family: var(--font-family-primary, \"Lexend\", sans-serif);\n    font-size: 13px;\n    font-weight: 500;\n    line-height: 16.9px;\n    letter-spacing: 0.065px;\n    color: var(--dash-muted);\n    white-space: nowrap;\n  }\n  .dashboard-mobile-org {\n    height: 61px;\n    padding: 12px;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    border: 1px solid var(--dash-border);\n    border-radius: var(--radius-md, 10px);\n    background: var(--dash-surface);\n    text-align: left;\n    cursor: pointer;\n  }\n  .dashboard-mobile-org > span {\n    width: 32px;\n    height: 32px;\n    flex: none;\n    display: grid;\n    place-items: center;\n    border: 1.5px solid var(--dash-border);\n    border-radius: 50%;\n    color: var(--dash-brand);\n    background: var(--dash-brand-soft);\n    font-family: var(--font-family-primary, \"Lexend\", sans-serif);\n    font-size: 12px;\n    font-weight: 500;\n  }\n  .dashboard-mobile-org div {\n    min-width: 0;\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n  }\n  .dashboard-mobile-org strong {\n    overflow: hidden;\n    font-size: 13px;\n    font-weight: 500;\n    line-height: 16.9px;\n    letter-spacing: 0.065px;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    color: var(--dash-text);\n  }\n  .dashboard-mobile-org small {\n    font-size: 11px;\n    font-weight: 400;\n    line-height: 15.4px;\n    letter-spacing: 0.11px;\n    color: var(--dash-muted);\n    white-space: nowrap;\n  }\n  .dashboard-mobile-org .org-switch-icon,\n  .dashboard-mobile-org svg {\n    width: 16px;\n    height: 16px;\n    flex: none;\n    margin-left: auto;\n    color: var(--interactive-default, #0f766e) !important;\n    stroke-width: 3;\n  }\n  .business-dashboard.dark .dashboard-mobile-org {\n    background: var(--dash-surface);\n    border-color: var(--dash-border);\n  }\n  .business-dashboard.dark .dashboard-mobile-org > span {\n    border-color: var(--dash-border);\n    color: var(--dash-brand);\n    background: var(--dash-brand-soft);\n  }\n  .business-dashboard.dark .dashboard-mobile-org strong {\n    color: var(--dash-text);\n  }\n  .business-dashboard.dark .dashboard-mobile-org small {\n    color: var(--dash-muted);\n  }\n  .business-dashboard.dark .dashboard-mobile-org .org-switch-icon,\n  .business-dashboard.dark .dashboard-mobile-org svg {\n    color: var(--interactive-default, #43a79c) !important;\n  }\n\n  /* Shortcuts matching Figma 452:55846 and 504:36335 */\n  .dashboard-shortcuts {\n    width: 100%;\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 8px;\n    padding-bottom: 8px;\n    border-bottom: 1px solid var(--dash-border);\n    color: var(--text-link, #0f766e);\n  }\n  .dashboard-shortcut {\n    height: 40px;\n    padding: 0 12px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 6px;\n    border-radius: var(--radius-md, 10px);\n    font-family: var(--font-family-primary, \"Lexend\", sans-serif);\n    font-size: 13px;\n    font-weight: 500;\n    color: var(--text-link, #0f766e);\n    white-space: nowrap;\n    text-decoration: none;\n    background: transparent;\n    transition: background-color 150ms ease, color 150ms ease;\n  }\n  .dashboard-shortcut:hover {\n    background: var(--dash-surface-2, #f4f7f7);\n    color: var(--interactive-hover, #0c5f59);\n  }\n  .business-dashboard.dark .dashboard-shortcuts {\n    border-bottom-color: var(--dash-border, #2c3036);\n  }\n  .business-dashboard.dark .dashboard-shortcut {\n    color: var(--text-link, #83c7be);\n  }\n  .business-dashboard.dark .dashboard-shortcut:hover {\n    background: rgba(255, 255, 255, 0.05);\n    color: var(--interactive-hover, #83c7be);\n  }\n\n  /* Heading matching Figma 504:36317 */\n  .dashboard-heading {\n    order: 2;\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    width: 100%;\n  }\n  .dashboard-heading > div:first-child h1 {\n    font-size: 24px;\n    font-weight: 600;\n    line-height: 30px;\n    letter-spacing: -0.36px;\n    color: var(--dash-text);\n    margin: 0;\n  }\n  .dashboard-heading > div:first-child p {\n    font-size: 13px;\n    font-weight: 400;\n    line-height: 20.2px;\n    letter-spacing: 0;\n    color: var(--dash-muted);\n    margin: 4px 0 0;\n  }\n  .dashboard-create {\n    display: flex;\n    gap: 12px;\n    width: 100%;\n  }\n  .dashboard-create :is(a, button) {\n    flex: 1;\n    height: 40px;\n    padding: 0 12px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 6px;\n    border-radius: var(--radius-md, 10px);\n    font-size: 13px;\n    font-weight: 500;\n    white-space: nowrap;\n    text-decoration: none;\n    background: var(--dash-surface-2, #f4f7f7);\n    border: 1px solid var(--dash-border-strong, #cdd6d4);\n    color: var(--dash-text, #142624);\n  }\n  .dashboard-create :is(a, button).primary {\n    background: var(--dash-brand, #0f766e);\n    border: 0;\n    color: #ffffff;\n  }\n  .business-dashboard.dark .dashboard-create :is(a, button) {\n    background: var(--dash-surface-2, #22252a);\n    border-color: var(--dash-border-strong, #3a3f47);\n    color: var(--dash-text, #f2f3f5);\n  }\n  .business-dashboard.dark .dashboard-create :is(a, button).primary {\n    background: var(--dash-brand, #43a79c);\n    color: #101113;\n  }\n  .dashboard-create :is(a, button) svg {\n    display: none;\n  }\n  .dashboard-period-info {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    width: 100%;\n  }\n  .dashboard-period-info b {\n    font-size: 13px;\n    font-weight: 500;\n    line-height: 16.9px;\n    letter-spacing: 0.065px;\n    color: var(--dash-text);\n  }\n  .dashboard-period-info span {\n    font-size: 13px;\n    font-weight: 400;\n    line-height: 18.2px;\n    letter-spacing: 0.065px;\n    color: var(--dash-muted);\n  }\n  .dashboard-periods {\n    width: fit-content;\n    max-width: 100%;\n    display: flex;\n    gap: 4px;\n    align-items: flex-end;\n    align-self: flex-start;\n    justify-self: flex-start;\n    padding: 0;\n    border: 0;\n    background: transparent;\n  }\n  .dashboard-periods button {\n    height: 33px;\n    padding: 8px 16px;\n    border-radius: var(--radius-md, 10px);\n    font-family: var(--font-family-primary, \"Lexend\", sans-serif);\n    font-size: 13px;\n    font-weight: 500;\n    line-height: 16.9px;\n    letter-spacing: 0.065px;\n    border: 0;\n    background: transparent;\n    color: var(--dash-muted, #506360);\n    cursor: pointer;\n    transition: background-color 150ms ease, color 150ms ease;\n    white-space: nowrap;\n  }\n  .dashboard-periods button:hover {\n    color: var(--dash-text, #142624);\n    background: var(--dash-surface-2, #f4f7f7);\n  }\n  .dashboard-periods button.active {\n    background: var(--interactive-selected, #dcefec);\n    color: var(--interactive-pressed, #0a4a46);\n  }\n  .business-dashboard.dark .dashboard-periods button,\n  .business-dashboard[data-theme=\"dark\"] .dashboard-periods button {\n    color: var(--dash-muted, #b3b8c2);\n  }\n  .business-dashboard.dark .dashboard-periods button:hover,\n  .business-dashboard[data-theme=\"dark\"] .dashboard-periods button:hover {\n    color: var(--dash-text, #f2f3f5);\n    background: rgba(255, 255, 255, 0.05);\n  }\n  .business-dashboard.dark .dashboard-periods button.active,\n  .business-dashboard[data-theme=\"dark\"] .dashboard-periods button.active {\n    background: rgba(67, 167, 156, 0.2);\n    color: #83c7be;\n  }\n\n  /* Financial summary matching Figma 504:36398 */\n  .dashboard-metrics {\n    order: 3;\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    width: 100%;\n  }\n  .dashboard-metric,\n  .dashboard-metric:last-child {\n    width: 100%;\n    height: auto;\n    min-height: auto;\n    padding: 16px;\n    border-radius: var(--radius-lg, 14px);\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    border: 1px solid var(--dash-border);\n    background: var(--dash-surface);\n  }\n  .dashboard-metric header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n  }\n  .dashboard-metric header h2 {\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 22.4px;\n    letter-spacing: -0.08px;\n    color: var(--dash-text);\n    margin: 0;\n  }\n  .dashboard-metric header svg {\n    width: 20px;\n    height: 20px;\n    color: var(--dash-brand, #0f766e);\n  }\n  .business-dashboard.dark .dashboard-metric header svg,\n  .business-dashboard[data-theme=\"dark\"] .dashboard-metric header svg {\n    color: var(--dash-brand, #43a79c);\n  }\n  .dashboard-metric .dashboard-money {\n    font-family: var(--font-family-mono, monospace);\n    font-size: 20px;\n    font-weight: 700;\n    line-height: 24px;\n    letter-spacing: 0;\n    color: var(--dash-text);\n    margin: 0;\n  }\n  .dashboard-metric > p {\n    font-size: 13px;\n    font-weight: 400;\n    line-height: 18.2px;\n    letter-spacing: 0.065px;\n    color: var(--dash-muted);\n    margin: 0;\n  }\n  .dashboard-metric-rows {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    width: 100%;\n    margin: 0;\n  }\n  .dashboard-metric-rows > div {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 4px;\n    width: 100%;\n    padding: 0;\n    border: 0;\n  }\n  .dashboard-metric-rows > div span {\n    font-size: 13px;\n    font-weight: 400;\n    line-height: 20.2px;\n    color: var(--dash-muted);\n  }\n  .dashboard-metric-rows > div b {\n    font-size: 13px;\n    font-weight: 400;\n    line-height: 20.2px;\n    color: var(--dash-text);\n  }\n  .dashboard-note {\n    display: flex;\n    align-items: flex-start;\n    gap: 8px;\n    width: 100%;\n    margin-top: 0;\n    font-size: 13px;\n    font-weight: 400;\n    line-height: 18.2px;\n    letter-spacing: 0.065px;\n    color: var(--text-tertiary, #6b7b78);\n  }\n  .dashboard-note svg {\n    width: 16px;\n    height: 16px;\n    flex-shrink: 0;\n    margin-top: 1px;\n    color: var(--text-tertiary, #6b7b78);\n  }\n\n  /* Needs attention matching Figma 504:36516 */\n  .dashboard-attention {\n    order: 4;\n    padding: 16px;\n    border-radius: var(--radius-lg, 14px);\n    border: 1px solid var(--dash-border);\n    background: var(--dash-surface);\n  }\n  .dashboard-attention > header {\n    padding-bottom: 4px;\n  }\n  .dashboard-attention > header h2 {\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 22.4px;\n    letter-spacing: -0.08px;\n    color: var(--dash-text);\n    margin: 0;\n  }\n  .dashboard-attention > header p {\n    font-size: 13px;\n    font-weight: 400;\n    line-height: 18.2px;\n    letter-spacing: 0.065px;\n    color: var(--dash-muted);\n    margin: 4px 0 0;\n  }\n  .dashboard-attention > .dashboard-attention-row {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 12px;\n    padding: 12px 0 16px;\n    border-top: 1px solid var(--dash-border);\n    width: 100%;\n  }\n  .dashboard-attention > .dashboard-attention-row:last-child {\n    padding-bottom: 0;\n  }\n  .dashboard-attention-priority {\n    display: flex;\n    align-items: flex-start;\n    gap: 8px;\n    width: 100%;\n  }\n  .dashboard-attention-priority svg {\n    width: 20px;\n    height: 20px;\n    flex-shrink: 0;\n    color: var(--dash-text);\n  }\n  .dashboard-attention-priority strong {\n    font-size: 13px;\n    font-weight: 500;\n    line-height: 16.9px;\n    letter-spacing: 0.065px;\n    color: var(--dash-text);\n  }\n  .dashboard-attention-desc {\n    font-size: 13px;\n    font-weight: 400;\n    line-height: 20.2px;\n    letter-spacing: 0;\n    color: var(--dash-text);\n    margin: 0;\n    width: 100%;\n  }\n  .dashboard-attention-row a {\n    width: 100%;\n    height: 40px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: var(--radius-md, 10px);\n    font-size: 13px;\n    font-weight: 500;\n    text-decoration: none;\n    background: var(--dash-surface-2, #f4f7f7);\n    border: 1px solid var(--dash-border-strong, #cdd6d4);\n    color: var(--dash-text, #142624);\n  }\n  .dashboard-attention-row a.primary {\n    background: var(--dash-brand, #0f766e);\n    border: 0;\n    color: #ffffff;\n  }\n  .business-dashboard.dark .dashboard-attention-row a {\n    background: var(--dash-surface-2, #22252a);\n    border-color: var(--dash-border-strong, #3a3f47);\n    color: var(--dash-text, #f2f3f5);\n  }\n  .business-dashboard.dark .dashboard-attention-row a.primary {\n    background: var(--dash-brand, #43a79c);\n    color: #101113;\n  }\n\n  /* Recent Invoices matching Figma 504:36585 */\n  .dashboard-invoices {\n    order: 5;\n    border-radius: var(--radius-lg, 14px);\n    border: 1px solid var(--dash-border);\n    background: var(--dash-surface);\n    box-shadow: 0px 1px 2px 0px rgba(14, 26, 32, 0.06);\n  }\n  .dashboard-invoices header {\n    padding: 16px;\n    height: auto;\n    align-items: flex-start;\n  }\n  .dashboard-invoices header h2 {\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 22.4px;\n    letter-spacing: -0.08px;\n    color: var(--dash-text);\n    margin: 0;\n  }\n  .dashboard-invoices header p {\n    font-size: 13px;\n    font-weight: 400;\n    line-height: 18.2px;\n    letter-spacing: 0.065px;\n    color: var(--text-tertiary, #6b7b78);\n    margin: 4px 0 0;\n  }\n  .dashboard-invoices header a {\n    height: 40px;\n    padding: 0 12px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 13px;\n    font-weight: 500;\n    line-height: 16.9px;\n    letter-spacing: 0.065px;\n    color: var(--text-link, #0f766e);\n    border-radius: var(--radius-md, 10px);\n    white-space: nowrap;\n  }\n  .dashboard-table {\n    padding: 0;\n  }\n  .dashboard-table-head {\n    display: none;\n  }\n  .dashboard-table-row {\n    display: grid;\n    grid-template-columns: minmax(0, 1fr) auto;\n    grid-template-areas:\n      \"invoice lifecycle\"\n      \"customer customer\"\n      \"invoice-date due\"\n      \"payment payment\"\n      \"amount balance\";\n    align-items: center;\n    padding: 16px;\n    border-top: 1px solid var(--dash-border);\n    border-bottom: 0;\n    min-width: 0;\n    gap: 8px;\n    width: 100%;\n  }\n  .dashboard-table-row .invoice-number {\n    grid-area: invoice;\n    font-family: var(--font-family-mono, monospace);\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 18.2px;\n    letter-spacing: 0.28px;\n    text-transform: uppercase;\n    color: var(--dash-text);\n    padding: 0;\n  }\n  .dashboard-table-row .invoice-number {\n    color: var(--text-link, #0f766e);\n  }\n  .dashboard-table-row .customer {\n    grid-area: customer;\n    font-family: var(--font-family-primary, \"Lexend\", sans-serif);\n    font-size: 13px;\n    font-weight: 400;\n    line-height: 20.2px;\n    color: var(--dash-text);\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    width: 100%;\n    padding: 0;\n  }\n  .dashboard-table-row .customer small {\n    margin-top: 2px;\n  }\n  .dashboard-table-row .invoice-date {\n    grid-area: invoice-date;\n    padding: 0;\n    color: var(--dash-muted);\n    font-size: 13px;\n    white-space: nowrap;\n  }\n  .dashboard-table-row .invoice-date::before {\n    content: \"Invoice date \";\n  }\n  .dashboard-table-row .due-date {\n    grid-area: due;\n    font-family: var(--font-family-primary, \"Lexend\", sans-serif);\n    font-size: 13px;\n    font-weight: 400;\n    line-height: 20.2px;\n    color: var(--dash-muted);\n    padding: 0;\n    text-align: right;\n  }\n  .dashboard-table-row .due-date::before {\n    content: \"Due \";\n  }\n  .dashboard-table-row .invoice-lifecycle-status {\n    grid-area: lifecycle;\n    justify-self: end;\n    padding: 0;\n  }\n  .dashboard-table-row .invoice-payment-status {\n    grid-area: payment;\n    padding: 0;\n  }\n  .dashboard-table-row .invoice-amount {\n    grid-area: amount;\n    font-family: var(--font-family-mono, monospace);\n    font-size: 15px;\n    font-weight: 500;\n    line-height: 19.5px;\n    color: var(--dash-text);\n    white-space: nowrap;\n    padding: 0;\n    text-align: left;\n  }\n  .dashboard-table-row .invoice-amount::before {\n    content: \"Total \";\n    color: var(--dash-muted);\n    font-family: var(--font-family-primary, \"Lexend\", sans-serif);\n    font-size: 12px;\n    font-weight: 400;\n  }\n  .dashboard-table-row .invoice-balance {\n    grid-area: balance;\n    padding: 0;\n    text-align: right;\n  }\n  .dashboard-table-row--loading > :nth-child(1) {\n    grid-area: invoice;\n  }\n  .dashboard-table-row--loading > :nth-child(2) {\n    grid-area: customer;\n  }\n  .dashboard-table-row--loading > :nth-child(3) {\n    grid-area: invoice-date;\n  }\n  .dashboard-table-row--loading > :nth-child(4) {\n    grid-area: due;\n  }\n  .dashboard-table-row--loading > :nth-child(5) {\n    grid-area: lifecycle;\n  }\n  .dashboard-table-row--loading > :nth-child(6) {\n    grid-area: payment;\n  }\n  .dashboard-table-row--loading > :nth-child(7) {\n    grid-area: amount;\n  }\n  .dashboard-table-row--loading > :nth-child(8) {\n    grid-area: balance;\n  }\n  .dashboard-invoices footer {\n    border-top: 1px solid var(--dash-border);\n    padding: 16px;\n    font-size: 13px;\n    font-weight: 400;\n    line-height: 18.2px;\n    letter-spacing: 0.065px;\n    color: var(--text-tertiary, #6b7b78);\n  }\n\n  /* Historical analysis charts matching Figma 504:36970 */\n  .dashboard-charts {\n    order: 6;\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    width: 100%;\n  }\n  .dashboard-charts article {\n    min-height: auto;\n    padding: 16px;\n    border-radius: var(--radius-lg, 14px);\n    border: 1px solid var(--dash-border);\n    background: var(--dash-surface);\n  }\n  .dashboard-charts header h2 {\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 22.4px;\n    letter-spacing: -0.08px;\n    color: var(--dash-text);\n    margin: 0;\n  }\n  .dashboard-charts header p {\n    font-size: 13px;\n    font-weight: 400;\n    line-height: 18.2px;\n    letter-spacing: 0.065px;\n    color: var(--dash-muted);\n    margin: 4px 0 0;\n  }\n  .dashboard-chart-container {\n    gap: 16px;\n  }\n  .dashboard-plot-row {\n    margin-top: 8px;\n  }\n  .dashboard-currency-scale {\n    width: 48px;\n    height: 210px;\n    font-size: 12px;\n  }\n  .dashboard-bar-chart,\n  .dashboard-cash-chart {\n    height: 228px;\n  }\n  .dashboard-bar-label {\n    font-size: 12px;\n    line-height: 18px;\n  }\n\n  /* Plan and usage banner matching Figma 504:37240 */\n  .dashboard-mobile-plan {\n    order: 7;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    height: 56px;\n    padding: 16px;\n    border: 1px solid var(--dash-border);\n    border-radius: var(--radius-md, 10px);\n    background: var(--dash-surface);\n    width: 100%;\n  }\n  .dashboard-mobile-plan strong {\n    font-family: var(--font-family-mono, monospace);\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 18.2px;\n    letter-spacing: 0.28px;\n    text-transform: uppercase;\n    color: var(--dash-text);\n  }\n  .dashboard-mobile-plan span {\n    font-family: var(--font-family-primary, \"Lexend\", sans-serif);\n    font-size: 13px;\n    font-weight: 400;\n    line-height: 20.2px;\n    letter-spacing: 0;\n    color: var(--dash-muted);\n  }\n  .dashboard-mobile-plan a {\n    height: 40px;\n    padding: 0 12px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: var(--radius-md, 10px);\n    font-family: var(--font-family-primary, \"Lexend\", sans-serif);\n    font-size: 13px;\n    font-weight: 500;\n    color: var(--text-link, #0f766e);\n    text-decoration: none;\n    transition: background-color 150ms ease, color 150ms ease;\n  }\n  .dashboard-mobile-plan a:hover {\n    background: var(--dash-surface-2, #f4f7f7);\n    color: var(--interactive-hover, #0c5f59);\n  }\n  .business-dashboard.dark .dashboard-mobile-plan a,\n  .business-dashboard[data-theme=\"dark\"] .dashboard-mobile-plan a {\n    color: var(--text-link, #83c7be);\n  }\n  .business-dashboard.dark .dashboard-mobile-plan a:hover,\n  .business-dashboard[data-theme=\"dark\"] .dashboard-mobile-plan a:hover {\n    background: rgba(255, 255, 255, 0.05);\n  }\n  .business-dashboard.dark .dashboard-invoice-actions button:hover,\n  .business-dashboard[data-theme=\"dark\"]\n    .dashboard-invoice-actions\n    button:hover {\n    background: var(--dash-surface-2, #22252a);\n    color: var(--dash-text, #f2f3f5);\n  }\n}\n\n/* ==========================================================================\n   TABLET VIEW (768px - 1024px) — Figma Node 452:55830 & 460:63624\n   ========================================================================== */\n@media (min-width: 768px) and (max-width: 1024px) {\n  .business-dashboard:has(.dashboard-product-identity)\n    .dashboard-mobile-controls,\n  .business-dashboard:has(.dashboard-product-identity)\n    .app-topbar__mobile-controls,\n  .dashboard-main:has(.dashboard-product-identity) .dashboard-mobile-controls {\n    display: none !important;\n  }\n  .business-dashboard:has(.dashboard-launcher-btn) .dashboard-sidebar-launcher,\n  .business-dashboard:has(.app-topbar__mobile-btn) .dashboard-sidebar-launcher {\n    display: none !important;\n  }\n  .business-dashboard:not(:has(.dashboard-product-identity))\n    .dashboard-mobile-controls,\n  .business-dashboard:not(:has(.dashboard-product-identity))\n    .app-topbar__mobile-controls {\n    display: flex !important;\n  }\n  .dashboard-topbar {\n    padding: 0 24px !important;\n  }\n  .dashboard-search {\n    display: flex !important;\n    max-width: 320px !important;\n    width: 100% !important;\n    height: 40px !important;\n    padding: 0 12px !important;\n    align-items: center !important;\n    gap: 8px !important;\n    border: 1px solid var(--dash-border) !important;\n    border-radius: 10px !important;\n    background: var(--dash-surface-2) !important;\n  }\n  .dashboard-search svg {\n    width: 16px !important;\n    height: 16px !important;\n    color: var(--text-tertiary, #6b7b78) !important;\n    flex-shrink: 0;\n  }\n  .dashboard-search input {\n    font-family: var(--font-family-primary, \"Lexend\", sans-serif) !important;\n    font-size: 14px !important;\n    border: 0 !important;\n    outline: 0 !important;\n    background: transparent !important;\n    color: var(--dash-text) !important;\n    width: 100% !important;\n  }\n  .dashboard-search input::placeholder {\n    color: var(--text-tertiary, #6b7b78) !important;\n  }\n  .dashboard-top-actions {\n    display: flex !important;\n    align-items: center !important;\n    gap: 16px !important;\n  }\n  .dashboard-top-actions .dashboard-topbar-credits,\n  .dashboard-top-actions > span {\n    display: inline-flex !important;\n    height: 32px !important;\n    padding: 0 12px 0 10px !important;\n    align-items: center !important;\n    gap: 6px !important;\n    border: 1px solid var(--border-default, #cdd6d4) !important;\n    border-radius: 999px !important;\n    font-family: var(--font-family-primary, \"Lexend\", sans-serif) !important;\n    font-size: 13px !important;\n    font-weight: 500 !important;\n    color: var(--text-primary, #142624) !important;\n    white-space: nowrap !important;\n    background: transparent !important;\n  }\n  .dashboard-top-actions .dashboard-topbar-credits svg,\n  .dashboard-top-actions > span svg {\n    width: 16px !important;\n    height: 16px !important;\n  }\n  .business-dashboard.dark .dashboard-top-actions .dashboard-topbar-credits,\n  .business-dashboard.dark .dashboard-top-actions > span {\n    border-color: var(--dash-border-strong, #3a3f47) !important;\n    color: var(--dash-text, #f2f3f5) !important;\n  }\n  .dashboard-top-actions .dashboard-topbar-help,\n  .dashboard-top-actions > button[aria-label=\"Help\"] {\n    display: grid !important;\n    width: 36px !important;\n    height: 36px !important;\n    place-items: center !important;\n    border-radius: 18px !important;\n    border: 0 !important;\n    background: transparent !important;\n    cursor: pointer !important;\n  }\n  .dashboard-top-actions .dashboard-topbar-help svg,\n  .dashboard-top-actions > button[aria-label=\"Help\"] svg {\n    width: 20px !important;\n    height: 20px !important;\n  }\n  .dashboard-top-actions .dashboard-notification {\n    display: grid !important;\n    width: 36px !important;\n    height: 36px !important;\n    place-items: center !important;\n    border-radius: 18px !important;\n    background: transparent !important;\n  }\n  .dashboard-content {\n    padding: 24px !important;\n    gap: 20px !important;\n  }\n  .dashboard-mobile-context {\n    display: flex !important;\n    flex-direction: column !important;\n    gap: 16px !important;\n    width: 100% !important;\n  }\n  .dashboard-org-product-row {\n    display: flex !important;\n    align-items: center !important;\n    justify-content: space-between !important;\n    width: 100% !important;\n  }\n  .dashboard-product-identity {\n    display: flex !important;\n    align-items: center !important;\n    gap: 8px !important;\n  }\n  .dashboard-launcher-btn {\n    width: 44px !important;\n    height: 44px !important;\n    display: grid !important;\n    place-items: center !important;\n    border: 1px solid var(--border-subtle, #dce3e2) !important;\n    border-radius: 10px !important;\n    background: var(--surface-secondary, #f4f7f7) !important;\n    color: var(--dash-text, #142624) !important;\n    cursor: pointer !important;\n    padding: 0 !important;\n  }\n  .business-dashboard.dark .dashboard-launcher-btn {\n    background: var(--dash-surface-2, #22252a) !important;\n    border-color: var(--dash-border, #2c3036) !important;\n    color: var(--dash-text, #f2f3f5) !important;\n  }\n  .dashboard-launcher-btn svg {\n    width: 20px !important;\n    height: 20px !important;\n  }\n  .dashboard-product-name {\n    font-family: var(--font-family-primary, \"Lexend\", sans-serif) !important;\n    font-size: 13px !important;\n    font-weight: 500 !important;\n    line-height: 16.9px !important;\n    letter-spacing: 0.065px !important;\n    color: var(--text-secondary, #506360) !important;\n    white-space: nowrap !important;\n  }\n  .business-dashboard.dark .dashboard-product-name {\n    color: var(--dash-muted, #b3b8c2) !important;\n  }\n  .dashboard-mobile-org {\n    width: 220px !important;\n    height: 61px !important;\n    padding: 12px !important;\n    display: flex !important;\n    align-items: center !important;\n    gap: 8px !important;\n    border: 1px solid var(--border-subtle, #dce3e2) !important;\n    border-radius: 10px !important;\n    background: var(--surface-primary, #ffffff) !important;\n    cursor: pointer !important;\n    flex: none !important;\n    box-sizing: border-box !important;\n  }\n  .business-dashboard.dark .dashboard-mobile-org {\n    background: var(--dash-surface, #191b1f) !important;\n    border-color: var(--dash-border, #2c3036) !important;\n  }\n  .dashboard-mobile-org .org-switch-icon,\n  .org-switch-icon {\n    width: 16px !important;\n    height: 16px !important;\n    margin-left: auto !important;\n    color: var(--interactive-default, #0f766e) !important;\n    stroke-width: 3 !important;\n    flex-shrink: 0 !important;\n  }\n  .business-dashboard.dark .dashboard-mobile-org .org-switch-icon,\n  .business-dashboard.dark .org-switch-icon {\n    color: var(--interactive-default, #43a79c) !important;\n  }\n  .dashboard-shortcuts {\n    display: flex !important;\n    align-items: center !important;\n    gap: 8px !important;\n    padding-bottom: 8px !important;\n    border-bottom: 1px solid var(--border-subtle, #dce3e2) !important;\n    width: 100% !important;\n  }\n  .dashboard-shortcut {\n    height: 40px !important;\n    padding: 0 12px !important;\n    border-radius: 10px !important;\n    font-family: var(--font-family-primary, \"Lexend\", sans-serif) !important;\n    font-size: 13px !important;\n    font-weight: 500 !important;\n    color: var(--text-link, #0f766e) !important;\n    white-space: nowrap !important;\n    display: inline-flex !important;\n    align-items: center !important;\n    justify-content: center !important;\n  }\n  .dashboard-heading {\n    display: grid !important;\n    grid-template-columns: 1fr auto !important;\n    gap: 16px 20px !important;\n    width: 100% !important;\n    align-items: center !important;\n  }\n  .dashboard-heading > div:first-child {\n    grid-column: 1 !important;\n    grid-row: 1 !important;\n    display: flex !important;\n    flex-direction: column !important;\n    gap: 4px !important;\n  }\n  .dashboard-heading > div:first-child h1 {\n    font-size: 28px !important;\n    line-height: 35px !important;\n    font-weight: 600 !important;\n    letter-spacing: -0.42px !important;\n    margin: 0 !important;\n    color: var(--dash-text) !important;\n  }\n  .dashboard-heading > div:first-child p {\n    font-size: 13px !important;\n    line-height: 20.2px !important;\n    letter-spacing: 0 !important;\n    margin: 0 !important;\n    color: var(--dash-muted) !important;\n  }\n  .dashboard-create {\n    grid-column: 2 !important;\n    grid-row: 1 !important;\n    display: flex !important;\n    flex-direction: row !important;\n    gap: 12px !important;\n    width: auto !important;\n    justify-content: flex-end !important;\n    align-items: center !important;\n  }\n  .dashboard-create :is(a, button) {\n    width: auto !important;\n    flex: none !important;\n    height: 36px !important;\n    padding: 0 14px !important;\n    border-radius: 10px !important;\n    font-family: var(--font-family-primary, \"Lexend\", sans-serif) !important;\n    font-size: 13px !important;\n    font-weight: 500 !important;\n    white-space: nowrap !important;\n    display: inline-flex !important;\n    align-items: center !important;\n    justify-content: center !important;\n  }\n  .dashboard-create a:not(.primary) {\n    background: var(--surface-primary, #ffffff) !important;\n    border: 1px solid var(--border-default, #cdd6d4) !important;\n    color: var(--text-primary, #142624) !important;\n  }\n  .dashboard-create :is(a, button).primary {\n    background: var(--interactive-default, #0f766e) !important;\n    border: 0 !important;\n    color: #ffffff !important;\n  }\n  .business-dashboard.dark .dashboard-create a:not(.primary) {\n    background: var(--dash-surface-2, #22252a) !important;\n    border-color: var(--dash-border-strong, #3a3f47) !important;\n    color: var(--dash-text, #f2f3f5) !important;\n  }\n  .business-dashboard.dark .dashboard-create :is(a, button).primary {\n    background: var(--interactive-default, #43a79c) !important;\n    color: #101113 !important;\n  }\n  .dashboard-period-info {\n    grid-column: 1 !important;\n    grid-row: 2 !important;\n    display: flex !important;\n    flex-direction: column !important;\n    gap: 4px !important;\n    width: 100% !important;\n  }\n  .dashboard-period-info b {\n    font-size: 13px !important;\n    font-weight: 500 !important;\n    line-height: 16.9px !important;\n    letter-spacing: 0.065px !important;\n    color: var(--dash-text) !important;\n  }\n  .dashboard-period-info span {\n    font-size: 13px !important;\n    font-weight: 400 !important;\n    line-height: 18.2px !important;\n    letter-spacing: 0.065px !important;\n    color: var(--dash-muted) !important;\n  }\n  .dashboard-periods {\n    grid-column: 2 !important;\n    grid-row: 2 !important;\n    align-self: center !important;\n    justify-self: end !important;\n    display: flex !important;\n    gap: 4px !important;\n    width: auto !important;\n    background: transparent !important;\n    padding: 0 !important;\n  }\n  .dashboard-periods button {\n    height: 33px !important;\n    padding: 8px 16px !important;\n    border-radius: 10px !important;\n    font-size: 13px !important;\n    font-weight: 500 !important;\n    line-height: 16.9px !important;\n    letter-spacing: 0.065px !important;\n  }\n  .dashboard-metrics {\n    display: grid !important;\n    grid-template-columns: repeat(2, 1fr) !important;\n    gap: 16px !important;\n    width: 100% !important;\n  }\n  .dashboard-metric:nth-child(1) {\n    grid-column: 1 !important;\n    width: 100% !important;\n  }\n  .dashboard-metric:nth-child(2) {\n    grid-column: 2 !important;\n    width: 100% !important;\n  }\n  .dashboard-metric:nth-child(3) {\n    grid-column: 1 / -1 !important;\n    width: 100% !important;\n  }\n  .dashboard-attention > .dashboard-attention-row {\n    display: grid !important;\n    grid-template-columns: 1fr auto !important;\n    grid-template-rows: auto auto !important;\n    gap: 8px 16px !important;\n    align-items: center !important;\n    padding: 16px 0 !important;\n  }\n  .dashboard-attention-context {\n    grid-column: 1 !important;\n    grid-row: 1 / span 2 !important;\n  }\n  .dashboard-attention-row .status-pill {\n    grid-column: 2 !important;\n    grid-row: 1 !important;\n    justify-self: end !important;\n    margin: 0 !important;\n  }\n  .dashboard-attention-row a {\n    grid-column: 2 !important;\n    grid-row: 2 !important;\n    justify-self: end !important;\n    width: auto !important;\n    min-width: 140px !important;\n    height: 36px !important;\n    padding: 0 16px !important;\n  }\n  .dashboard-mobile-plan {\n    display: flex !important;\n    flex-direction: row !important;\n    align-items: center !important;\n    justify-content: space-between !important;\n    padding: 16px 20px !important;\n    border-radius: 10px !important;\n    background: var(--surface-secondary, #f4f7f7) !important;\n    border: 1px solid var(--border-subtle, #dce3e2) !important;\n    height: auto !important;\n    width: 100% !important;\n    box-sizing: border-box !important;\n  }\n  .dashboard-mobile-plan strong {\n    font-family: var(--font-family-primary, \"Lexend\", sans-serif) !important;\n    font-size: 13px !important;\n    font-weight: 500 !important;\n    text-transform: uppercase !important;\n    color: var(--text-primary, #142624) !important;\n  }\n  .dashboard-mobile-plan span {\n    font-family: var(--font-family-primary, \"Lexend\", sans-serif) !important;\n    font-size: 13px !important;\n    font-weight: 400 !important;\n    color: var(--text-secondary, #506360) !important;\n  }\n  .dashboard-mobile-plan a {\n    font-family: var(--font-family-primary, \"Lexend\", sans-serif) !important;\n    font-size: 13px !important;\n    font-weight: 500 !important;\n    color: var(--interactive-default, #0f766e) !important;\n    text-decoration: none !important;\n  }\n  .business-dashboard.dark .dashboard-mobile-plan {\n    background: var(--dash-surface-2, #22252a) !important;\n    border-color: var(--dash-border, #2c3036) !important;\n  }\n  .business-dashboard.dark .dashboard-mobile-plan strong {\n    color: var(--dash-text, #f2f3f5) !important;\n  }\n  .business-dashboard.dark .dashboard-mobile-plan span {\n    color: var(--dash-muted, #b3b8c2) !important;\n  }\n  .business-dashboard.dark .dashboard-mobile-plan a {\n    color: var(--interactive-default, #43a79c) !important;\n  }\n  .dashboard-nav.is-open {\n    width: 280px !important;\n    max-width: 85vw !important;\n  }\n}\n\n/* ==========================================================================\n   MOBILE PHONE VIEW (max-width: 767px) — Figma Node 504:36262\n   ========================================================================== */\n@media (max-width: 767px) {\n  .dashboard-topbar {\n    padding: 0 16px !important;\n  }\n  .dashboard-content {\n    padding: 16px !important;\n  }\n  .dashboard-product-identity {\n    display: none !important;\n  }\n  .dashboard-mobile-org {\n    width: 100% !important;\n  }\n  .dashboard-mobile-controls {\n    display: flex !important;\n  }\n  .dashboard-search {\n    display: none !important;\n  }\n  .dashboard-top-actions .dashboard-topbar-credits,\n  .dashboard-top-actions > span {\n    display: none !important;\n  }\n  .dashboard-top-actions .dashboard-topbar-help,\n  .dashboard-top-actions > button[aria-label=\"Help\"] {\n    display: none !important;\n  }\n  .dashboard-heading {\n    display: flex !important;\n    flex-direction: column !important;\n    gap: 16px !important;\n    width: 100% !important;\n  }\n  .dashboard-heading > div:first-child h1 {\n    font-size: 24px !important;\n    line-height: 30px !important;\n    letter-spacing: -0.36px !important;\n  }\n  .dashboard-create {\n    display: flex !important;\n    width: 100% !important;\n    gap: 12px !important;\n  }\n  .dashboard-create :is(a, button) {\n    flex: 1 !important;\n    width: 100% !important;\n    height: 40px !important;\n  }\n  .dashboard-periods {\n    align-self: flex-start !important;\n    justify-self: flex-start !important;\n  }\n  .dashboard-metrics {\n    display: flex !important;\n    flex-direction: column !important;\n    gap: 16px !important;\n    width: 100% !important;\n  }\n  .dashboard-metric {\n    width: 100% !important;\n  }\n  .dashboard-sidebar-launcher {\n    display: grid !important;\n  }\n}\n\n@media (min-width: 768px) and (max-width: 1024px) {\n  .dashboard-nav .dashboard-org-wrap {\n    display: none !important;\n  }\n}\n\n/* Content-aware loading states keep the dashboard shell and component geometry mounted. */\n.dashboard-data-skeleton {\n  pointer-events: none;\n}\n.dashboard-data-skeleton .app-skeleton {\n  max-width: 100%;\n}\n.dashboard-metric.dashboard-data-skeleton {\n  gap: var(--space-4, 16px);\n}\n.dashboard-metric.dashboard-data-skeleton > header {\n  margin-bottom: var(--space-2, 8px);\n}\n.dashboard-metric.dashboard-data-skeleton > .app-skeleton {\n  flex-shrink: 0;\n}\n.dashboard-metric.dashboard-data-skeleton > .app-skeleton:last-child {\n  margin-top: auto;\n}\n.dashboard-metric.dashboard-data-skeleton .dashboard-metric-rows > div {\n  gap: var(--space-2, 8px);\n}\n.dashboard-data-skeleton .dashboard-attention-context > .app-skeleton {\n  flex-shrink: 0;\n}\n.dashboard-data-skeleton .dashboard-attention-context > div {\n  flex: 1;\n  grid-template-columns: minmax(0, 1fr);\n  gap: var(--space-2, 8px);\n}\n.dashboard-table-row--loading {\n  align-items: center;\n  pointer-events: none;\n}\n.dashboard-table-row--loading .dashboard-invoice-info {\n  display: grid;\n  gap: 8px;\n  width: 100%;\n}\n.dashboard-chart-skeleton {\n  min-height: 286px;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  gap: 20px;\n}\n.dashboard-chart-skeleton-bars {\n  height: 220px;\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-around;\n  gap: 12px;\n  padding: 20px 20px 0;\n  border-bottom: 1px solid var(--dash-border);\n}\n.dashboard-chart-skeleton-bars .app-skeleton {\n  min-width: 20px;\n}\n@media (max-width: 767px) {\n  .dashboard-chart-skeleton {\n    min-height: 230px;\n  }\n  .dashboard-chart-skeleton-bars {\n    height: 170px;\n    padding-inline: 8px;\n  }\n  .dashboard-attention-row.dashboard-data-skeleton {\n    display: grid;\n    grid-template-columns: minmax(0, 1fr) auto;\n  }\n  .dashboard-attention-row.dashboard-data-skeleton > .app-skeleton:last-child {\n    grid-column: 1/-1;\n    width: 100% !important;\n  }\n}\n\n/* ==========================================================================\n   Desktop Collapsed Sidebar & Smooth Transition Styles (> 1024px)\n   ========================================================================== */\n.dashboard-nav {\n  transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1),\n    visibility 0.25s ease !important;\n}\n.dashboard-main,\n.global-dashboard-layout,\n.contacts-main,\n.invoice-flow-main,\n.invoice-register-main,\n.quotation-main {\n  transition: margin-left 0.25s cubic-bezier(0.4, 0, 0.2, 1) !important;\n}\n\n@media (min-width: 1025px) {\n  body.sidebar-collapsed .dashboard-nav {\n    transform: translateX(-100%) !important;\n    visibility: hidden !important;\n    pointer-events: none !important;\n  }\n  body.sidebar-collapsed .dashboard-main,\n  body.sidebar-collapsed .global-dashboard-layout,\n  body.sidebar-collapsed .contacts-main,\n  body.sidebar-collapsed .invoice-flow-main,\n  body.sidebar-collapsed .invoice-register-main,\n  body.sidebar-collapsed .quotation-main,\n  body.sidebar-collapsed main {\n    margin-left: 0 !important;\n    width: 100% !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
